/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    Cloudinary_DateTime: { input: any; output: any };
    Cloudinary_JSON: { input: any; output: any };
    /**
     * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
     *     compliant with the 'date-time' format outlined in section 5.6 of
     *     the RFC 3339 profile of the ISO 8601 standard for representation
     *     of dates and times using the Gregorian calendar.
     */
    DateTime: { input: any; output: any };
    /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
    Dimension: { input: any; output: any };
    /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
    HexColor: { input: any; output: any };
    /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
    JSON: { input: any; output: any };
    /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
    Quality: { input: any; output: any };
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/accordionContentItem) */
export type AccordionContentItem = Entry &
    _Node & {
        __typename?: 'AccordionContentItem';
        _id: Scalars['ID']['output'];
        bodyText?: Maybe<Scalars['String']['output']>;
        contentfulMetadata: ContentfulMetadata;
        headline?: Maybe<Scalars['String']['output']>;
        imagesCollection?: Maybe<AccordionContentItemImagesCollection>;
        imagesCursorCollection?: Maybe<AccordionContentItemImagesCursorCollection>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<AccordionContentItemLinkingCollections>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/accordionContentItem) */
export type AccordionContentItemBodyTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/accordionContentItem) */
export type AccordionContentItemHeadlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/accordionContentItem) */
export type AccordionContentItemImagesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<AccordionContentItemImagesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/accordionContentItem) */
export type AccordionContentItemImagesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<AccordionContentItemImagesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/accordionContentItem) */
export type AccordionContentItemInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/accordionContentItem) */
export type AccordionContentItemLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccordionContentItemCollection = {
    __typename?: 'AccordionContentItemCollection';
    items: Array<Maybe<AccordionContentItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type AccordionContentItemCursorCollection = {
    __typename?: 'AccordionContentItemCursorCollection';
    items: Array<Maybe<AccordionContentItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type AccordionContentItemFilter = {
    AND?: InputMaybe<Array<InputMaybe<AccordionContentItemFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<AccordionContentItemFilter>>>;
    bodyText?: InputMaybe<Scalars['String']['input']>;
    bodyText_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    bodyText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    bodyText_not?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headline?: InputMaybe<Scalars['String']['input']>;
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headline_not?: InputMaybe<Scalars['String']['input']>;
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    images?: InputMaybe<CfImageWrapperNestedFilter>;
    imagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type AccordionContentItemImagesCollection = {
    __typename?: 'AccordionContentItemImagesCollection';
    items: Array<Maybe<ImageWrapper>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum AccordionContentItemImagesCollectionOrder {
    AltTextAsc = 'altText_ASC',
    AltTextDesc = 'altText_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type AccordionContentItemImagesCursorCollection = {
    __typename?: 'AccordionContentItemImagesCursorCollection';
    items: Array<Maybe<ImageWrapper>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum AccordionContentItemImagesCursorCollectionOrder {
    AltTextAsc = 'altText_ASC',
    AltTextDesc = 'altText_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type AccordionContentItemLinkingCollections = {
    __typename?: 'AccordionContentItemLinkingCollections';
    blockAccordionContentCollection?: Maybe<BlockAccordionContentCollection>;
    blockAccordionContentCursorCollection?: Maybe<BlockAccordionContentCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type AccordionContentItemLinkingCollectionsBlockAccordionContentCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<AccordionContentItemLinkingCollectionsBlockAccordionContentCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionContentItemLinkingCollectionsBlockAccordionContentCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<AccordionContentItemLinkingCollectionsBlockAccordionContentCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionContentItemLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionContentItemLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AccordionContentItemLinkingCollectionsBlockAccordionContentCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum AccordionContentItemLinkingCollectionsBlockAccordionContentCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum AccordionContentItemOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
    __typename?: 'Asset';
    contentType?: Maybe<Scalars['String']['output']>;
    contentfulMetadata: ContentfulMetadata;
    description?: Maybe<Scalars['String']['output']>;
    fileName?: Maybe<Scalars['String']['output']>;
    height?: Maybe<Scalars['Int']['output']>;
    linkedFrom?: Maybe<AssetLinkingCollections>;
    size?: Maybe<Scalars['Int']['output']>;
    sys: Sys;
    title?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
    width?: Maybe<Scalars['Int']['output']>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    transform?: InputMaybe<ImageTransformOptions>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetCollection = {
    __typename?: 'AssetCollection';
    items: Array<Maybe<Asset>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type AssetCursorCollection = {
    __typename?: 'AssetCursorCollection';
    items: Array<Maybe<Asset>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type AssetFilter = {
    AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
    contentType?: InputMaybe<Scalars['String']['input']>;
    contentType_contains?: InputMaybe<Scalars['String']['input']>;
    contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentType_not?: InputMaybe<Scalars['String']['input']>;
    contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
    contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    description?: InputMaybe<Scalars['String']['input']>;
    description_contains?: InputMaybe<Scalars['String']['input']>;
    description_exists?: InputMaybe<Scalars['Boolean']['input']>;
    description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    description_not?: InputMaybe<Scalars['String']['input']>;
    description_not_contains?: InputMaybe<Scalars['String']['input']>;
    description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    fileName?: InputMaybe<Scalars['String']['input']>;
    fileName_contains?: InputMaybe<Scalars['String']['input']>;
    fileName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    fileName_not?: InputMaybe<Scalars['String']['input']>;
    fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
    fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    height?: InputMaybe<Scalars['Int']['input']>;
    height_exists?: InputMaybe<Scalars['Boolean']['input']>;
    height_gt?: InputMaybe<Scalars['Int']['input']>;
    height_gte?: InputMaybe<Scalars['Int']['input']>;
    height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    height_lt?: InputMaybe<Scalars['Int']['input']>;
    height_lte?: InputMaybe<Scalars['Int']['input']>;
    height_not?: InputMaybe<Scalars['Int']['input']>;
    height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    size?: InputMaybe<Scalars['Int']['input']>;
    size_exists?: InputMaybe<Scalars['Boolean']['input']>;
    size_gt?: InputMaybe<Scalars['Int']['input']>;
    size_gte?: InputMaybe<Scalars['Int']['input']>;
    size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    size_lt?: InputMaybe<Scalars['Int']['input']>;
    size_lte?: InputMaybe<Scalars['Int']['input']>;
    size_not?: InputMaybe<Scalars['Int']['input']>;
    size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    url?: InputMaybe<Scalars['String']['input']>;
    url_contains?: InputMaybe<Scalars['String']['input']>;
    url_exists?: InputMaybe<Scalars['Boolean']['input']>;
    url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    url_not?: InputMaybe<Scalars['String']['input']>;
    url_not_contains?: InputMaybe<Scalars['String']['input']>;
    url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    width?: InputMaybe<Scalars['Int']['input']>;
    width_exists?: InputMaybe<Scalars['Boolean']['input']>;
    width_gt?: InputMaybe<Scalars['Int']['input']>;
    width_gte?: InputMaybe<Scalars['Int']['input']>;
    width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    width_lt?: InputMaybe<Scalars['Int']['input']>;
    width_lte?: InputMaybe<Scalars['Int']['input']>;
    width_not?: InputMaybe<Scalars['Int']['input']>;
    width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssetLinkingCollections = {
    __typename?: 'AssetLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    iconCollection?: Maybe<IconCollection>;
    iconCursorCollection?: Maybe<IconCursorCollection>;
    imageWrapperCollection?: Maybe<ImageWrapperCollection>;
    imageWrapperCursorCollection?: Maybe<ImageWrapperCursorCollection>;
};

export type AssetLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetLinkingCollectionsIconCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetLinkingCollectionsIconCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetLinkingCollectionsImageWrapperCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetLinkingCollectionsImageWrapperCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssetOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    FileNameAsc = 'fileName_ASC',
    FileNameDesc = 'fileName_DESC',
    HeightAsc = 'height_ASC',
    HeightDesc = 'height_DESC',
    SizeAsc = 'size_ASC',
    SizeDesc = 'size_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    UrlAsc = 'url_ASC',
    UrlDesc = 'url_DESC',
    WidthAsc = 'width_ASC',
    WidthDesc = 'width_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockAccordionContent) */
export type BlockAccordionContent = Entry &
    _Node & {
        __typename?: 'BlockAccordionContent';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        itemsCollection?: Maybe<BlockAccordionContentItemsCollection>;
        itemsCursorCollection?: Maybe<BlockAccordionContentItemsCursorCollection>;
        linkedFrom?: Maybe<BlockAccordionContentLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        paragraph?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockAccordionContent) */
export type BlockAccordionContentHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockAccordionContent) */
export type BlockAccordionContentInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockAccordionContent) */
export type BlockAccordionContentItemsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockAccordionContentItemsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<AccordionContentItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockAccordionContent) */
export type BlockAccordionContentItemsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockAccordionContentItemsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<AccordionContentItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockAccordionContent) */
export type BlockAccordionContentLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockAccordionContent) */
export type BlockAccordionContentOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockAccordionContent) */
export type BlockAccordionContentParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockAccordionContentCollection = {
    __typename?: 'BlockAccordionContentCollection';
    items: Array<Maybe<BlockAccordionContent>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockAccordionContentCursorCollection = {
    __typename?: 'BlockAccordionContentCursorCollection';
    items: Array<Maybe<BlockAccordionContent>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockAccordionContentFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockAccordionContentFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockAccordionContentFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    items?: InputMaybe<CfAccordionContentItemNestedFilter>;
    itemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockAccordionContentItemsCollection = {
    __typename?: 'BlockAccordionContentItemsCollection';
    items: Array<Maybe<AccordionContentItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockAccordionContentItemsCollectionOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockAccordionContentItemsCursorCollection = {
    __typename?: 'BlockAccordionContentItemsCursorCollection';
    items: Array<Maybe<AccordionContentItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockAccordionContentItemsCursorCollectionOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockAccordionContentLinkingCollections = {
    __typename?: 'BlockAccordionContentLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type BlockAccordionContentLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockAccordionContentLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>
    >;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockAccordionContentLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockAccordionContentLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockAccordionContentLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockAccordionContentLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockAccordionContentLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockAccordionContentLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockAccordionContentOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockClientTestimonial) */
export type BlockClientTestimonial = Entry &
    _Node & {
        __typename?: 'BlockClientTestimonial';
        _id: Scalars['ID']['output'];
        authorName?: Maybe<Scalars['String']['output']>;
        authorTitle?: Maybe<Scalars['String']['output']>;
        client?: Maybe<Client>;
        contentfulMetadata: ContentfulMetadata;
        image?: Maybe<ImageWrapper>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockClientTestimonialLinkingCollections>;
        quote?: Maybe<Scalars['String']['output']>;
        quoteShort?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockClientTestimonial) */
export type BlockClientTestimonialAuthorNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockClientTestimonial) */
export type BlockClientTestimonialAuthorTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockClientTestimonial) */
export type BlockClientTestimonialClientArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ClientFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockClientTestimonial) */
export type BlockClientTestimonialImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockClientTestimonial) */
export type BlockClientTestimonialInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockClientTestimonial) */
export type BlockClientTestimonialLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockClientTestimonial) */
export type BlockClientTestimonialQuoteArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockClientTestimonial) */
export type BlockClientTestimonialQuoteShortArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialCollection = {
    __typename?: 'BlockClientTestimonialCollection';
    items: Array<Maybe<BlockClientTestimonial>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockClientTestimonialCursorCollection = {
    __typename?: 'BlockClientTestimonialCursorCollection';
    items: Array<Maybe<BlockClientTestimonial>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockClientTestimonialFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockClientTestimonialFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockClientTestimonialFilter>>>;
    authorName?: InputMaybe<Scalars['String']['input']>;
    authorName_contains?: InputMaybe<Scalars['String']['input']>;
    authorName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    authorName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    authorName_not?: InputMaybe<Scalars['String']['input']>;
    authorName_not_contains?: InputMaybe<Scalars['String']['input']>;
    authorName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    authorTitle?: InputMaybe<Scalars['String']['input']>;
    authorTitle_contains?: InputMaybe<Scalars['String']['input']>;
    authorTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    authorTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    authorTitle_not?: InputMaybe<Scalars['String']['input']>;
    authorTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    authorTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    client?: InputMaybe<CfClientNestedFilter>;
    client_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    image?: InputMaybe<CfImageWrapperNestedFilter>;
    image_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    quote?: InputMaybe<Scalars['String']['input']>;
    quoteShort?: InputMaybe<Scalars['String']['input']>;
    quoteShort_contains?: InputMaybe<Scalars['String']['input']>;
    quoteShort_exists?: InputMaybe<Scalars['Boolean']['input']>;
    quoteShort_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    quoteShort_not?: InputMaybe<Scalars['String']['input']>;
    quoteShort_not_contains?: InputMaybe<Scalars['String']['input']>;
    quoteShort_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    quote_contains?: InputMaybe<Scalars['String']['input']>;
    quote_exists?: InputMaybe<Scalars['Boolean']['input']>;
    quote_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    quote_not?: InputMaybe<Scalars['String']['input']>;
    quote_not_contains?: InputMaybe<Scalars['String']['input']>;
    quote_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockClientTestimonialLinkingCollections = {
    __typename?: 'BlockClientTestimonialLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    blockSlideshowCollection?: Maybe<BlockSlideshowCollection>;
    blockSlideshowCursorCollection?: Maybe<BlockSlideshowCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockClientTestimonialLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockClientTestimonialLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>
    >;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockClientTestimonialLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsBlockSlideshowCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsBlockSlideshowCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsBlockSlideshowCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsBlockSlideshowCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClientTestimonialLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockClientTestimonialLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsBlockSlideshowCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsBlockSlideshowCursorCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockClientTestimonialOrder {
    AuthorNameAsc = 'authorName_ASC',
    AuthorNameDesc = 'authorName_DESC',
    AuthorTitleAsc = 'authorTitle_ASC',
    AuthorTitleDesc = 'authorTitle_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockDarkCircleBackground) */
export type BlockDarkCircleBackground = Entry &
    _Node & {
        __typename?: 'BlockDarkCircleBackground';
        _id: Scalars['ID']['output'];
        block?: Maybe<BlockDarkCircleBackgroundBlock>;
        blocksCollection?: Maybe<BlockDarkCircleBackgroundBlocksCollection>;
        blocksCursorCollection?: Maybe<BlockDarkCircleBackgroundBlocksCursorCollection>;
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockDarkCircleBackgroundLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        style?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockDarkCircleBackground) */
export type BlockDarkCircleBackgroundBlockArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockDarkCircleBackground) */
export type BlockDarkCircleBackgroundBlocksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockDarkCircleBackgroundBlocksFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockDarkCircleBackground) */
export type BlockDarkCircleBackgroundBlocksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockDarkCircleBackgroundBlocksFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockDarkCircleBackground) */
export type BlockDarkCircleBackgroundHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockDarkCircleBackground) */
export type BlockDarkCircleBackgroundInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockDarkCircleBackground) */
export type BlockDarkCircleBackgroundLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockDarkCircleBackground) */
export type BlockDarkCircleBackgroundOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockDarkCircleBackground) */
export type BlockDarkCircleBackgroundStyleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundBlock = BlockIconBlocks | BlockIndustryBlocks | BlockNumberedBlocks;

export type BlockDarkCircleBackgroundBlocksCollection = {
    __typename?: 'BlockDarkCircleBackgroundBlocksCollection';
    items: Array<Maybe<BlockDarkCircleBackgroundBlocksItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockDarkCircleBackgroundBlocksCursorCollection = {
    __typename?: 'BlockDarkCircleBackgroundBlocksCursorCollection';
    items: Array<Maybe<BlockDarkCircleBackgroundBlocksItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockDarkCircleBackgroundBlocksFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundBlocksFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundBlocksFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockDarkCircleBackgroundBlocksItem =
    | BlockAccordionContent
    | BlockClientTestimonial
    | BlockFeaturedCaseStudies
    | BlockIconBlocks
    | BlockImage
    | BlockImageWithPartialOverlay
    | BlockIndustryBlocks
    | BlockJobList
    | BlockLogoCarousel
    | BlockLogoGrid
    | BlockNumberedBlocks
    | BlockPageSection
    | BlockPeopleList
    | BlockRichText
    | BlockScrolljackSection
    | BlockSlideshow
    | BlockStackedCards
    | BlockTabbedContent
    | BlockTechnologyBlocks;

export type BlockDarkCircleBackgroundCollection = {
    __typename?: 'BlockDarkCircleBackgroundCollection';
    items: Array<Maybe<BlockDarkCircleBackground>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockDarkCircleBackgroundCursorCollection = {
    __typename?: 'BlockDarkCircleBackgroundCursorCollection';
    items: Array<Maybe<BlockDarkCircleBackground>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockDarkCircleBackgroundFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundFilter>>>;
    block_exists?: InputMaybe<Scalars['Boolean']['input']>;
    blocks?: InputMaybe<CfblocksMultiTypeNestedFilter>;
    blocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    style?: InputMaybe<Scalars['String']['input']>;
    style_contains?: InputMaybe<Scalars['String']['input']>;
    style_exists?: InputMaybe<Scalars['Boolean']['input']>;
    style_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    style_not?: InputMaybe<Scalars['String']['input']>;
    style_not_contains?: InputMaybe<Scalars['String']['input']>;
    style_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockDarkCircleBackgroundLinkingCollections = {
    __typename?: 'BlockDarkCircleBackgroundLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageCaseStudyCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageExpertiseCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageSubIndustryCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDarkCircleBackgroundLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockDarkCircleBackgroundLinkingCollectionsPageTechnologyCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockDarkCircleBackgroundLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockDarkCircleBackgroundOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockFeaturedCaseStudies) */
export type BlockFeaturedCaseStudies = Entry &
    _Node & {
        __typename?: 'BlockFeaturedCaseStudies';
        _id: Scalars['ID']['output'];
        button?: Maybe<Button>;
        caseStudiesCollection?: Maybe<BlockFeaturedCaseStudiesCaseStudiesCollection>;
        caseStudiesCursorCollection?: Maybe<BlockFeaturedCaseStudiesCaseStudiesCursorCollection>;
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockFeaturedCaseStudiesLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockFeaturedCaseStudies) */
export type BlockFeaturedCaseStudiesButtonArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ButtonFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockFeaturedCaseStudies) */
export type BlockFeaturedCaseStudiesCaseStudiesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesCaseStudiesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageCaseStudyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockFeaturedCaseStudies) */
export type BlockFeaturedCaseStudiesCaseStudiesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesCaseStudiesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageCaseStudyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockFeaturedCaseStudies) */
export type BlockFeaturedCaseStudiesHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockFeaturedCaseStudies) */
export type BlockFeaturedCaseStudiesLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockFeaturedCaseStudies) */
export type BlockFeaturedCaseStudiesOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesCaseStudiesCollection = {
    __typename?: 'BlockFeaturedCaseStudiesCaseStudiesCollection';
    items: Array<Maybe<PageCaseStudy>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockFeaturedCaseStudiesCaseStudiesCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export type BlockFeaturedCaseStudiesCaseStudiesCursorCollection = {
    __typename?: 'BlockFeaturedCaseStudiesCaseStudiesCursorCollection';
    items: Array<Maybe<PageCaseStudy>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockFeaturedCaseStudiesCaseStudiesCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export type BlockFeaturedCaseStudiesCollection = {
    __typename?: 'BlockFeaturedCaseStudiesCollection';
    items: Array<Maybe<BlockFeaturedCaseStudies>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockFeaturedCaseStudiesCursorCollection = {
    __typename?: 'BlockFeaturedCaseStudiesCursorCollection';
    items: Array<Maybe<BlockFeaturedCaseStudies>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockFeaturedCaseStudiesFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesFilter>>>;
    button?: InputMaybe<CfButtonNestedFilter>;
    button_exists?: InputMaybe<Scalars['Boolean']['input']>;
    caseStudies?: InputMaybe<CfPageCaseStudyNestedFilter>;
    caseStudiesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockFeaturedCaseStudiesLinkingCollections = {
    __typename?: 'BlockFeaturedCaseStudiesLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>
    >;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageSubIndustryCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFeaturedCaseStudiesLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockFeaturedCaseStudiesLinkingCollectionsPageTechnologyCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockFeaturedCaseStudiesLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockFeaturedCaseStudiesOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocks = Entry &
    _Node & {
        __typename?: 'BlockIconBlocks';
        _id: Scalars['ID']['output'];
        backgroundColor?: Maybe<Scalars['String']['output']>;
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        iconBlocksCollection?: Maybe<BlockIconBlocksIconBlocksCollection>;
        iconBlocksCursorCollection?: Maybe<BlockIconBlocksIconBlocksCursorCollection>;
        iconColor?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockIconBlocksLinkingCollections>;
        numberOfColumnsOfBlocks?: Maybe<Scalars['String']['output']>;
        overline?: Maybe<Scalars['String']['output']>;
        paragraph?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocksBackgroundColorArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocksHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocksIconBlocksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksIconBlocksCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IconBlockFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocksIconBlocksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksIconBlocksCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IconBlockFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocksIconColorArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocksInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocksLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocksNumberOfColumnsOfBlocksArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocksOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIconBlocks) */
export type BlockIconBlocksParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksCollection = {
    __typename?: 'BlockIconBlocksCollection';
    items: Array<Maybe<BlockIconBlocks>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockIconBlocksCursorCollection = {
    __typename?: 'BlockIconBlocksCursorCollection';
    items: Array<Maybe<BlockIconBlocks>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockIconBlocksFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockIconBlocksFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockIconBlocksFilter>>>;
    backgroundColor?: InputMaybe<Scalars['String']['input']>;
    backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
    backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
    backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
    backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
    backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    iconBlocks?: InputMaybe<CfIconBlockNestedFilter>;
    iconBlocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    iconColor?: InputMaybe<Scalars['String']['input']>;
    iconColor_contains?: InputMaybe<Scalars['String']['input']>;
    iconColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
    iconColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    iconColor_not?: InputMaybe<Scalars['String']['input']>;
    iconColor_not_contains?: InputMaybe<Scalars['String']['input']>;
    iconColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    numberOfColumnsOfBlocks?: InputMaybe<Scalars['String']['input']>;
    numberOfColumnsOfBlocks_contains?: InputMaybe<Scalars['String']['input']>;
    numberOfColumnsOfBlocks_exists?: InputMaybe<Scalars['Boolean']['input']>;
    numberOfColumnsOfBlocks_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    numberOfColumnsOfBlocks_not?: InputMaybe<Scalars['String']['input']>;
    numberOfColumnsOfBlocks_not_contains?: InputMaybe<Scalars['String']['input']>;
    numberOfColumnsOfBlocks_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockIconBlocksIconBlocksCollection = {
    __typename?: 'BlockIconBlocksIconBlocksCollection';
    items: Array<Maybe<IconBlock>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockIconBlocksIconBlocksCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockIconBlocksIconBlocksCursorCollection = {
    __typename?: 'BlockIconBlocksIconBlocksCursorCollection';
    items: Array<Maybe<IconBlock>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockIconBlocksIconBlocksCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockIconBlocksLinkingCollections = {
    __typename?: 'BlockIconBlocksLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockIconBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockIconBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIconBlocksLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockIconBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockIconBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIconBlocksOrder {
    BackgroundColorAsc = 'backgroundColor_ASC',
    BackgroundColorDesc = 'backgroundColor_DESC',
    IconColorAsc = 'iconColor_ASC',
    IconColorDesc = 'iconColor_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    NumberOfColumnsOfBlocksAsc = 'numberOfColumnsOfBlocks_ASC',
    NumberOfColumnsOfBlocksDesc = 'numberOfColumnsOfBlocks_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImage) */
export type BlockImage = Entry &
    _Node & {
        __typename?: 'BlockImage';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        imagesCollection?: Maybe<BlockImageImagesCollection>;
        imagesCursorCollection?: Maybe<BlockImageImagesCursorCollection>;
        internalName?: Maybe<Scalars['String']['output']>;
        isFullBleed?: Maybe<Scalars['Boolean']['output']>;
        linkedFrom?: Maybe<BlockImageLinkingCollections>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImage) */
export type BlockImageImagesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageImagesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImage) */
export type BlockImageImagesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageImagesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImage) */
export type BlockImageInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImage) */
export type BlockImageIsFullBleedArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImage) */
export type BlockImageLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockImageCollection = {
    __typename?: 'BlockImageCollection';
    items: Array<Maybe<BlockImage>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockImageCursorCollection = {
    __typename?: 'BlockImageCursorCollection';
    items: Array<Maybe<BlockImage>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockImageFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockImageFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockImageFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    images?: InputMaybe<CfImageWrapperNestedFilter>;
    imagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    isFullBleed?: InputMaybe<Scalars['Boolean']['input']>;
    isFullBleed_exists?: InputMaybe<Scalars['Boolean']['input']>;
    isFullBleed_not?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockImageImagesCollection = {
    __typename?: 'BlockImageImagesCollection';
    items: Array<Maybe<ImageWrapper>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockImageImagesCollectionOrder {
    AltTextAsc = 'altText_ASC',
    AltTextDesc = 'altText_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockImageImagesCursorCollection = {
    __typename?: 'BlockImageImagesCursorCollection';
    items: Array<Maybe<ImageWrapper>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockImageImagesCursorCollectionOrder {
    AltTextAsc = 'altText_ASC',
    AltTextDesc = 'altText_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockImageLinkingCollections = {
    __typename?: 'BlockImageLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockImageLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockImageLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockImageLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockImageLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockImageLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockImageLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockImageLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockImageLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsFullBleedAsc = 'isFullBleed_ASC',
    IsFullBleedDesc = 'isFullBleed_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImageWithPartialOverlay) */
export type BlockImageWithPartialOverlay = Entry &
    _Node & {
        __typename?: 'BlockImageWithPartialOverlay';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        image?: Maybe<ImageWrapper>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockImageWithPartialOverlayLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        paragraphText?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImageWithPartialOverlay) */
export type BlockImageWithPartialOverlayHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImageWithPartialOverlay) */
export type BlockImageWithPartialOverlayImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImageWithPartialOverlay) */
export type BlockImageWithPartialOverlayInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImageWithPartialOverlay) */
export type BlockImageWithPartialOverlayLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImageWithPartialOverlay) */
export type BlockImageWithPartialOverlayOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockImageWithPartialOverlay) */
export type BlockImageWithPartialOverlayParagraphTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayCollection = {
    __typename?: 'BlockImageWithPartialOverlayCollection';
    items: Array<Maybe<BlockImageWithPartialOverlay>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockImageWithPartialOverlayCursorCollection = {
    __typename?: 'BlockImageWithPartialOverlayCursorCollection';
    items: Array<Maybe<BlockImageWithPartialOverlay>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockImageWithPartialOverlayFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    image?: InputMaybe<CfImageWrapperNestedFilter>;
    image_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraphText?: InputMaybe<Scalars['String']['input']>;
    paragraphText_contains?: InputMaybe<Scalars['String']['input']>;
    paragraphText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraphText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraphText_not?: InputMaybe<Scalars['String']['input']>;
    paragraphText_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraphText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockImageWithPartialOverlayLinkingCollections = {
    __typename?: 'BlockImageWithPartialOverlayLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>
    >;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageCaseStudyCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageCompanyCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageExpertiseCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageIndustryCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageJournalCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageLandingCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageServiceCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageSubIndustryCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImageWithPartialOverlayLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockImageWithPartialOverlayLinkingCollectionsPageTechnologyCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockImageWithPartialOverlayLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockImageWithPartialOverlayOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIndustryBlocks) */
export type BlockIndustryBlocks = Entry &
    _Node & {
        __typename?: 'BlockIndustryBlocks';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockIndustryBlocksLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        pagesCollection?: Maybe<BlockIndustryBlocksPagesCollection>;
        pagesCursorCollection?: Maybe<BlockIndustryBlocksPagesCursorCollection>;
        paragraph?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIndustryBlocks) */
export type BlockIndustryBlocksHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIndustryBlocks) */
export type BlockIndustryBlocksLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIndustryBlocks) */
export type BlockIndustryBlocksOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIndustryBlocks) */
export type BlockIndustryBlocksPagesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksPagesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageIndustryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIndustryBlocks) */
export type BlockIndustryBlocksPagesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksPagesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageIndustryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockIndustryBlocks) */
export type BlockIndustryBlocksParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksCollection = {
    __typename?: 'BlockIndustryBlocksCollection';
    items: Array<Maybe<BlockIndustryBlocks>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockIndustryBlocksCursorCollection = {
    __typename?: 'BlockIndustryBlocksCursorCollection';
    items: Array<Maybe<BlockIndustryBlocks>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockIndustryBlocksFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    pages?: InputMaybe<CfPageIndustryNestedFilter>;
    pagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockIndustryBlocksLinkingCollections = {
    __typename?: 'BlockIndustryBlocksLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockIndustryBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>
    >;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockIndustryBlocksLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockIndustryBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockIndustryBlocksOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockIndustryBlocksPagesCollection = {
    __typename?: 'BlockIndustryBlocksPagesCollection';
    items: Array<Maybe<PageIndustry>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockIndustryBlocksPagesCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockIndustryBlocksPagesCursorCollection = {
    __typename?: 'BlockIndustryBlocksPagesCursorCollection';
    items: Array<Maybe<PageIndustry>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockIndustryBlocksPagesCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockJobList) */
export type BlockJobList = Entry &
    _Node & {
        __typename?: 'BlockJobList';
        _id: Scalars['ID']['output'];
        careersCollection?: Maybe<BlockJobListCareersCollection>;
        careersCursorCollection?: Maybe<BlockJobListCareersCursorCollection>;
        contentfulMetadata: ContentfulMetadata;
        extraJobBody?: Maybe<Scalars['String']['output']>;
        extraJobHeader?: Maybe<Scalars['String']['output']>;
        extraJobIcon?: Maybe<Icon>;
        headerText?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockJobListLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockJobList) */
export type BlockJobListCareersCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListCareersCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CareerFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockJobList) */
export type BlockJobListCareersCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListCareersCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CareerFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockJobList) */
export type BlockJobListExtraJobBodyArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockJobList) */
export type BlockJobListExtraJobHeaderArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockJobList) */
export type BlockJobListExtraJobIconArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IconFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockJobList) */
export type BlockJobListHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockJobList) */
export type BlockJobListInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockJobList) */
export type BlockJobListLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockJobList) */
export type BlockJobListOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListCareersCollection = {
    __typename?: 'BlockJobListCareersCollection';
    items: Array<Maybe<Career>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockJobListCareersCollectionOrder {
    BreezyUrlAsc = 'breezyUrl_ASC',
    BreezyUrlDesc = 'breezyUrl_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockJobListCareersCursorCollection = {
    __typename?: 'BlockJobListCareersCursorCollection';
    items: Array<Maybe<Career>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockJobListCareersCursorCollectionOrder {
    BreezyUrlAsc = 'breezyUrl_ASC',
    BreezyUrlDesc = 'breezyUrl_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockJobListCollection = {
    __typename?: 'BlockJobListCollection';
    items: Array<Maybe<BlockJobList>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockJobListCursorCollection = {
    __typename?: 'BlockJobListCursorCollection';
    items: Array<Maybe<BlockJobList>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockJobListFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockJobListFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockJobListFilter>>>;
    careers?: InputMaybe<CfCareerNestedFilter>;
    careersCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    extraJobBody?: InputMaybe<Scalars['String']['input']>;
    extraJobBody_contains?: InputMaybe<Scalars['String']['input']>;
    extraJobBody_exists?: InputMaybe<Scalars['Boolean']['input']>;
    extraJobBody_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    extraJobBody_not?: InputMaybe<Scalars['String']['input']>;
    extraJobBody_not_contains?: InputMaybe<Scalars['String']['input']>;
    extraJobBody_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    extraJobHeader?: InputMaybe<Scalars['String']['input']>;
    extraJobHeader_contains?: InputMaybe<Scalars['String']['input']>;
    extraJobHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
    extraJobHeader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    extraJobHeader_not?: InputMaybe<Scalars['String']['input']>;
    extraJobHeader_not_contains?: InputMaybe<Scalars['String']['input']>;
    extraJobHeader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    extraJobIcon?: InputMaybe<CfIconNestedFilter>;
    extraJobIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockJobListLinkingCollections = {
    __typename?: 'BlockJobListLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockJobListLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockJobListLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockJobListLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockJobListLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockJobListLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockJobListLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockJobListLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockJobListOrder {
    ExtraJobHeaderAsc = 'extraJobHeader_ASC',
    ExtraJobHeaderDesc = 'extraJobHeader_DESC',
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoCarousel) */
export type BlockLogoCarousel = Entry &
    _Node & {
        __typename?: 'BlockLogoCarousel';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        intro?: Maybe<BlockLogoCarouselIntro>;
        linkedFrom?: Maybe<BlockLogoCarouselLinkingCollections>;
        logoGridCollection?: Maybe<BlockLogoCarouselLogoGridCollection>;
        logoGridCursorCollection?: Maybe<BlockLogoCarouselLogoGridCursorCollection>;
        logosCloudinary?: Maybe<Scalars['JSON']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoCarousel) */
export type BlockLogoCarouselInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoCarousel) */
export type BlockLogoCarouselIntroArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoCarousel) */
export type BlockLogoCarouselLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoCarousel) */
export type BlockLogoCarouselLogoGridCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoCarouselLogoGridCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoCarousel) */
export type BlockLogoCarouselLogoGridCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoCarouselLogoGridCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoCarousel) */
export type BlockLogoCarouselLogosCloudinaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoCarousel) */
export type BlockLogoCarouselTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoCarouselCollection = {
    __typename?: 'BlockLogoCarouselCollection';
    items: Array<Maybe<BlockLogoCarousel>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockLogoCarouselCursorCollection = {
    __typename?: 'BlockLogoCarouselCursorCollection';
    items: Array<Maybe<BlockLogoCarousel>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockLogoCarouselFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockLogoCarouselFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockLogoCarouselFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    intro_contains?: InputMaybe<Scalars['String']['input']>;
    intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
    intro_not_contains?: InputMaybe<Scalars['String']['input']>;
    logoGrid?: InputMaybe<CfImageWrapperNestedFilter>;
    logoGridCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    logosCloudinary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockLogoCarouselIntro = {
    __typename?: 'BlockLogoCarouselIntro';
    json: Scalars['JSON']['output'];
    links: BlockLogoCarouselIntroLinks;
};

export type BlockLogoCarouselIntroAssets = {
    __typename?: 'BlockLogoCarouselIntroAssets';
    block: Array<Maybe<Asset>>;
    hyperlink: Array<Maybe<Asset>>;
};

export type BlockLogoCarouselIntroEntries = {
    __typename?: 'BlockLogoCarouselIntroEntries';
    block: Array<Maybe<Entry>>;
    hyperlink: Array<Maybe<Entry>>;
    inline: Array<Maybe<Entry>>;
};

export type BlockLogoCarouselIntroLinks = {
    __typename?: 'BlockLogoCarouselIntroLinks';
    assets: BlockLogoCarouselIntroAssets;
    entries: BlockLogoCarouselIntroEntries;
    resources: BlockLogoCarouselIntroResources;
};

export type BlockLogoCarouselIntroResources = {
    __typename?: 'BlockLogoCarouselIntroResources';
    block: Array<BlockLogoCarouselIntroResourcesBlock>;
    hyperlink: Array<BlockLogoCarouselIntroResourcesHyperlink>;
    inline: Array<BlockLogoCarouselIntroResourcesInline>;
};

export type BlockLogoCarouselIntroResourcesBlock = ResourceLink & {
    __typename?: 'BlockLogoCarouselIntroResourcesBlock';
    sys: ResourceSys;
};

export type BlockLogoCarouselIntroResourcesHyperlink = ResourceLink & {
    __typename?: 'BlockLogoCarouselIntroResourcesHyperlink';
    sys: ResourceSys;
};

export type BlockLogoCarouselIntroResourcesInline = ResourceLink & {
    __typename?: 'BlockLogoCarouselIntroResourcesInline';
    sys: ResourceSys;
};

export type BlockLogoCarouselLinkingCollections = {
    __typename?: 'BlockLogoCarouselLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
};

export type BlockLogoCarouselLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoCarouselLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoCarouselLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockLogoCarouselLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoCarouselLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoCarouselLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoCarouselLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoCarouselLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoCarouselLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoCarouselLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockLogoCarouselLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockLogoCarouselLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockLogoCarouselLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoCarouselLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockLogoCarouselLogoGridCollection = {
    __typename?: 'BlockLogoCarouselLogoGridCollection';
    items: Array<Maybe<ImageWrapper>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockLogoCarouselLogoGridCollectionOrder {
    AltTextAsc = 'altText_ASC',
    AltTextDesc = 'altText_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockLogoCarouselLogoGridCursorCollection = {
    __typename?: 'BlockLogoCarouselLogoGridCursorCollection';
    items: Array<Maybe<ImageWrapper>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockLogoCarouselLogoGridCursorCollectionOrder {
    AltTextAsc = 'altText_ASC',
    AltTextDesc = 'altText_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoCarouselOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoGrid) */
export type BlockLogoGrid = Entry &
    _Node & {
        __typename?: 'BlockLogoGrid';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        isFullBleed?: Maybe<Scalars['Boolean']['output']>;
        linkedFrom?: Maybe<BlockLogoGridLinkingCollections>;
        logosCloudinary?: Maybe<Scalars['JSON']['output']>;
        logosCollection?: Maybe<BlockLogoGridLogosCollection>;
        logosCursorCollection?: Maybe<BlockLogoGridLogosCursorCollection>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoGrid) */
export type BlockLogoGridInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoGrid) */
export type BlockLogoGridIsFullBleedArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoGrid) */
export type BlockLogoGridLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoGrid) */
export type BlockLogoGridLogosCloudinaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoGrid) */
export type BlockLogoGridLogosCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLogosCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockLogoGrid) */
export type BlockLogoGridLogosCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLogosCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

export type BlockLogoGridCollection = {
    __typename?: 'BlockLogoGridCollection';
    items: Array<Maybe<BlockLogoGrid>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockLogoGridCursorCollection = {
    __typename?: 'BlockLogoGridCursorCollection';
    items: Array<Maybe<BlockLogoGrid>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockLogoGridFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockLogoGridFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockLogoGridFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    isFullBleed?: InputMaybe<Scalars['Boolean']['input']>;
    isFullBleed_exists?: InputMaybe<Scalars['Boolean']['input']>;
    isFullBleed_not?: InputMaybe<Scalars['Boolean']['input']>;
    logos?: InputMaybe<CfImageWrapperNestedFilter>;
    logosCloudinary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    logosCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockLogoGridLinkingCollections = {
    __typename?: 'BlockLogoGridLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockLogoGridLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockLogoGridLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLogoGridLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockLogoGridLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockLogoGridLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockLogoGridLogosCollection = {
    __typename?: 'BlockLogoGridLogosCollection';
    items: Array<Maybe<ImageWrapper>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockLogoGridLogosCollectionOrder {
    AltTextAsc = 'altText_ASC',
    AltTextDesc = 'altText_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockLogoGridLogosCursorCollection = {
    __typename?: 'BlockLogoGridLogosCursorCollection';
    items: Array<Maybe<ImageWrapper>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockLogoGridLogosCursorCollectionOrder {
    AltTextAsc = 'altText_ASC',
    AltTextDesc = 'altText_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockLogoGridOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsFullBleedAsc = 'isFullBleed_ASC',
    IsFullBleedDesc = 'isFullBleed_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockNumberedBlocks) */
export type BlockNumberedBlocks = Entry &
    _Node & {
        __typename?: 'BlockNumberedBlocks';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        factsCollection?: Maybe<BlockNumberedBlocksFactsCollection>;
        factsCursorCollection?: Maybe<BlockNumberedBlocksFactsCursorCollection>;
        internalTitle?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockNumberedBlocksLinkingCollections>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockNumberedBlocks) */
export type BlockNumberedBlocksFactsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksFactsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FactFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockNumberedBlocks) */
export type BlockNumberedBlocksFactsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksFactsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FactFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockNumberedBlocks) */
export type BlockNumberedBlocksInternalTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockNumberedBlocks) */
export type BlockNumberedBlocksLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockNumberedBlocksCollection = {
    __typename?: 'BlockNumberedBlocksCollection';
    items: Array<Maybe<BlockNumberedBlocks>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockNumberedBlocksCursorCollection = {
    __typename?: 'BlockNumberedBlocksCursorCollection';
    items: Array<Maybe<BlockNumberedBlocks>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockNumberedBlocksFactsCollection = {
    __typename?: 'BlockNumberedBlocksFactsCollection';
    items: Array<Maybe<Fact>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockNumberedBlocksFactsCollectionOrder {
    HeaderAsc = 'header_ASC',
    HeaderDesc = 'header_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockNumberedBlocksFactsCursorCollection = {
    __typename?: 'BlockNumberedBlocksFactsCursorCollection';
    items: Array<Maybe<Fact>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockNumberedBlocksFactsCursorCollectionOrder {
    HeaderAsc = 'header_ASC',
    HeaderDesc = 'header_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockNumberedBlocksFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    facts?: InputMaybe<CfFactNestedFilter>;
    factsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalTitle?: InputMaybe<Scalars['String']['input']>;
    internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
    internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalTitle_not?: InputMaybe<Scalars['String']['input']>;
    internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockNumberedBlocksLinkingCollections = {
    __typename?: 'BlockNumberedBlocksLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockNumberedBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>
    >;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockNumberedBlocksLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockNumberedBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockNumberedBlocksOrder {
    InternalTitleAsc = 'internalTitle_ASC',
    InternalTitleDesc = 'internalTitle_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntro = Entry &
    _Node & {
        __typename?: 'BlockPageIntro';
        _id: Scalars['ID']['output'];
        button?: Maybe<Button>;
        contentfulMetadata: ContentfulMetadata;
        headerParagraph?: Maybe<Scalars['String']['output']>;
        headerText?: Maybe<Scalars['String']['output']>;
        image?: Maybe<ImageWrapper>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockPageIntroLinkingCollections>;
        ntExperiencesCollection?: Maybe<BlockPageIntroNt_ExperiencesCollection>;
        ntExperiencesCursorCollection?: Maybe<BlockPageIntroNt_ExperiencesCursorCollection>;
        overline?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        tableOfContents?: Maybe<Scalars['JSON']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntroButtonArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ButtonFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntroHeaderParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntroHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntroImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntroInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntroLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntroNtExperiencesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageIntroNt_ExperiencesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntroNtExperiencesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageIntroNt_ExperiencesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntroOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageIntro) */
export type BlockPageIntroTableOfContentsArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageIntroCollection = {
    __typename?: 'BlockPageIntroCollection';
    items: Array<Maybe<BlockPageIntro>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockPageIntroCursorCollection = {
    __typename?: 'BlockPageIntroCursorCollection';
    items: Array<Maybe<BlockPageIntro>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockPageIntroFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockPageIntroFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockPageIntroFilter>>>;
    button?: InputMaybe<CfButtonNestedFilter>;
    button_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerParagraph?: InputMaybe<Scalars['String']['input']>;
    headerParagraph_contains?: InputMaybe<Scalars['String']['input']>;
    headerParagraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerParagraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerParagraph_not?: InputMaybe<Scalars['String']['input']>;
    headerParagraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerParagraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    image?: InputMaybe<CfImageWrapperNestedFilter>;
    image_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experiences?: InputMaybe<CfNtExperienceNestedFilter>;
    nt_experiencesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    tableOfContents_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageIntroLinkingCollections = {
    __typename?: 'BlockPageIntroLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
};

export type BlockPageIntroLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageIntroLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageIntroLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageIntroLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageIntroLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageIntroLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageIntroLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageIntroLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageIntroLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageIntroLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockPageIntroLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageIntroLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageIntroLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageIntroLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockPageIntroNt_ExperiencesCollection = {
    __typename?: 'BlockPageIntroNt_experiencesCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockPageIntroNt_ExperiencesCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockPageIntroNt_ExperiencesCursorCollection = {
    __typename?: 'BlockPageIntroNt_experiencesCursorCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockPageIntroNt_ExperiencesCursorCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockPageIntroOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageSection) */
export type BlockPageSection = Entry &
    _Node & {
        __typename?: 'BlockPageSection';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        image?: Maybe<ImageWrapper>;
        imagePlacement?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockPageSectionLinkingCollections>;
        linksCollection?: Maybe<BlockPageSectionLinksCollection>;
        linksCursorCollection?: Maybe<BlockPageSectionLinksCursorCollection>;
        overline?: Maybe<Scalars['String']['output']>;
        paragraph?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageSection) */
export type BlockPageSectionHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageSection) */
export type BlockPageSectionImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageSection) */
export type BlockPageSectionImagePlacementArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageSection) */
export type BlockPageSectionInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageSection) */
export type BlockPageSectionLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageSection) */
export type BlockPageSectionLinksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinksCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<InternalPageLinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageSection) */
export type BlockPageSectionLinksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinksCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<InternalPageLinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageSection) */
export type BlockPageSectionOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPageSection) */
export type BlockPageSectionParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionCollection = {
    __typename?: 'BlockPageSectionCollection';
    items: Array<Maybe<BlockPageSection>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockPageSectionCursorCollection = {
    __typename?: 'BlockPageSectionCursorCollection';
    items: Array<Maybe<BlockPageSection>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockPageSectionFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockPageSectionFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockPageSectionFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    image?: InputMaybe<CfImageWrapperNestedFilter>;
    imagePlacement?: InputMaybe<Scalars['String']['input']>;
    imagePlacement_contains?: InputMaybe<Scalars['String']['input']>;
    imagePlacement_exists?: InputMaybe<Scalars['Boolean']['input']>;
    imagePlacement_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    imagePlacement_not?: InputMaybe<Scalars['String']['input']>;
    imagePlacement_not_contains?: InputMaybe<Scalars['String']['input']>;
    imagePlacement_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    image_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    links?: InputMaybe<CfInternalPageLinkNestedFilter>;
    linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockPageSectionLinkingCollections = {
    __typename?: 'BlockPageSectionLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockPageSectionLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockPageSectionLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPageSectionLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockPageSectionLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockPageSectionLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPageSectionLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockPageSectionLinksCollection = {
    __typename?: 'BlockPageSectionLinksCollection';
    items: Array<Maybe<InternalPageLink>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockPageSectionLinksCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockPageSectionLinksCursorCollection = {
    __typename?: 'BlockPageSectionLinksCursorCollection';
    items: Array<Maybe<InternalPageLink>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockPageSectionLinksCursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockPageSectionOrder {
    ImagePlacementAsc = 'imagePlacement_ASC',
    ImagePlacementDesc = 'imagePlacement_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPeopleList) */
export type BlockPeopleList = Entry &
    _Node & {
        __typename?: 'BlockPeopleList';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockPeopleListLinkingCollections>;
        peoplePagesCollection?: Maybe<BlockPeopleListPeoplePagesCollection>;
        peoplePagesCursorCollection?: Maybe<BlockPeopleListPeoplePagesCursorCollection>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPeopleList) */
export type BlockPeopleListInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPeopleList) */
export type BlockPeopleListLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPeopleList) */
export type BlockPeopleListPeoplePagesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListPeoplePagesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PagePersonFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockPeopleList) */
export type BlockPeopleListPeoplePagesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListPeoplePagesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PagePersonFilter>;
};

export type BlockPeopleListCollection = {
    __typename?: 'BlockPeopleListCollection';
    items: Array<Maybe<BlockPeopleList>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockPeopleListCursorCollection = {
    __typename?: 'BlockPeopleListCursorCollection';
    items: Array<Maybe<BlockPeopleList>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockPeopleListFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockPeopleListFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockPeopleListFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    peoplePages?: InputMaybe<CfPagePersonNestedFilter>;
    peoplePagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockPeopleListLinkingCollections = {
    __typename?: 'BlockPeopleListLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockPeopleListLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockPeopleListLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleListLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockPeopleListLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockPeopleListLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockPeopleListOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockPeopleListPeoplePagesCollection = {
    __typename?: 'BlockPeopleListPeoplePagesCollection';
    items: Array<Maybe<PagePerson>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockPeopleListPeoplePagesCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockPeopleListPeoplePagesCursorCollection = {
    __typename?: 'BlockPeopleListPeoplePagesCursorCollection';
    items: Array<Maybe<PagePerson>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockPeopleListPeoplePagesCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockRichText) */
export type BlockRichText = Entry &
    _Node & {
        __typename?: 'BlockRichText';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockRichTextLinkingCollections>;
        richText?: Maybe<BlockRichTextRichText>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockRichText) */
export type BlockRichTextInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockRichText) */
export type BlockRichTextLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockRichText) */
export type BlockRichTextRichTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockRichTextCollection = {
    __typename?: 'BlockRichTextCollection';
    items: Array<Maybe<BlockRichText>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockRichTextCursorCollection = {
    __typename?: 'BlockRichTextCursorCollection';
    items: Array<Maybe<BlockRichText>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockRichTextFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockRichTextFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockRichTextFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    richText_contains?: InputMaybe<Scalars['String']['input']>;
    richText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    richText_not_contains?: InputMaybe<Scalars['String']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockRichTextLinkingCollections = {
    __typename?: 'BlockRichTextLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
};

export type BlockRichTextLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockRichTextLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockRichTextLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockRichTextLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockRichTextLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockRichTextLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockRichTextLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockRichTextLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockRichTextLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockRichTextLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockRichTextLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockRichTextLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockRichTextLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockRichTextLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockRichTextOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockRichTextRichText = {
    __typename?: 'BlockRichTextRichText';
    json: Scalars['JSON']['output'];
    links: BlockRichTextRichTextLinks;
};

export type BlockRichTextRichTextAssets = {
    __typename?: 'BlockRichTextRichTextAssets';
    block: Array<Maybe<Asset>>;
    hyperlink: Array<Maybe<Asset>>;
};

export type BlockRichTextRichTextEntries = {
    __typename?: 'BlockRichTextRichTextEntries';
    block: Array<Maybe<Entry>>;
    hyperlink: Array<Maybe<Entry>>;
    inline: Array<Maybe<Entry>>;
};

export type BlockRichTextRichTextLinks = {
    __typename?: 'BlockRichTextRichTextLinks';
    assets: BlockRichTextRichTextAssets;
    entries: BlockRichTextRichTextEntries;
    resources: BlockRichTextRichTextResources;
};

export type BlockRichTextRichTextResources = {
    __typename?: 'BlockRichTextRichTextResources';
    block: Array<BlockRichTextRichTextResourcesBlock>;
    hyperlink: Array<BlockRichTextRichTextResourcesHyperlink>;
    inline: Array<BlockRichTextRichTextResourcesInline>;
};

export type BlockRichTextRichTextResourcesBlock = ResourceLink & {
    __typename?: 'BlockRichTextRichTextResourcesBlock';
    sys: ResourceSys;
};

export type BlockRichTextRichTextResourcesHyperlink = ResourceLink & {
    __typename?: 'BlockRichTextRichTextResourcesHyperlink';
    sys: ResourceSys;
};

export type BlockRichTextRichTextResourcesInline = ResourceLink & {
    __typename?: 'BlockRichTextRichTextResourcesInline';
    sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockScrolljackSection) */
export type BlockScrolljackSection = Entry &
    _Node & {
        __typename?: 'BlockScrolljackSection';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        itemsCollection?: Maybe<BlockScrolljackSectionItemsCollection>;
        itemsCursorCollection?: Maybe<BlockScrolljackSectionItemsCursorCollection>;
        linkedFrom?: Maybe<BlockScrolljackSectionLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        paragraph?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockScrolljackSection) */
export type BlockScrolljackSectionHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockScrolljackSection) */
export type BlockScrolljackSectionInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockScrolljackSection) */
export type BlockScrolljackSectionItemsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockScrolljackSectionItemsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ScrolljackItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockScrolljackSection) */
export type BlockScrolljackSectionItemsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockScrolljackSectionItemsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ScrolljackItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockScrolljackSection) */
export type BlockScrolljackSectionLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockScrolljackSection) */
export type BlockScrolljackSectionOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockScrolljackSection) */
export type BlockScrolljackSectionParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockScrolljackSectionCollection = {
    __typename?: 'BlockScrolljackSectionCollection';
    items: Array<Maybe<BlockScrolljackSection>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockScrolljackSectionCursorCollection = {
    __typename?: 'BlockScrolljackSectionCursorCollection';
    items: Array<Maybe<BlockScrolljackSection>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockScrolljackSectionFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockScrolljackSectionFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockScrolljackSectionFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    items?: InputMaybe<CfScrolljackItemNestedFilter>;
    itemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockScrolljackSectionItemsCollection = {
    __typename?: 'BlockScrolljackSectionItemsCollection';
    items: Array<Maybe<ScrolljackItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockScrolljackSectionItemsCollectionOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockScrolljackSectionItemsCursorCollection = {
    __typename?: 'BlockScrolljackSectionItemsCursorCollection';
    items: Array<Maybe<ScrolljackItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockScrolljackSectionItemsCursorCollectionOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockScrolljackSectionLinkingCollections = {
    __typename?: 'BlockScrolljackSectionLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type BlockScrolljackSectionLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockScrolljackSectionLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>
    >;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockScrolljackSectionLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockScrolljackSectionLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockScrolljackSectionLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockScrolljackSectionLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockScrolljackSectionLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockScrolljackSectionLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockScrolljackSectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshow = Entry &
    _Node & {
        __typename?: 'BlockSlideshow';
        _id: Scalars['ID']['output'];
        button?: Maybe<Button>;
        companyTopic?: Maybe<CompanyTopic>;
        contentType?: Maybe<Scalars['String']['output']>;
        contentfulMetadata: ContentfulMetadata;
        entriesCollection?: Maybe<BlockSlideshowEntriesCollection>;
        entriesCursorCollection?: Maybe<BlockSlideshowEntriesCursorCollection>;
        headerText?: Maybe<Scalars['String']['output']>;
        industry?: Maybe<Industry>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockSlideshowLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        service?: Maybe<Service>;
        solution?: Maybe<Solution>;
        sys: Sys;
        technology?: Maybe<Technology>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowButtonArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ButtonFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowCompanyTopicArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CompanyTopicFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowContentTypeArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowEntriesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockSlideshowEntriesFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowEntriesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockSlideshowEntriesFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowIndustryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IndustryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowServiceArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ServiceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowSolutionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SolutionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockSlideshow) */
export type BlockSlideshowTechnologyArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TechnologyFilter>;
};

export type BlockSlideshowCollection = {
    __typename?: 'BlockSlideshowCollection';
    items: Array<Maybe<BlockSlideshow>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockSlideshowCursorCollection = {
    __typename?: 'BlockSlideshowCursorCollection';
    items: Array<Maybe<BlockSlideshow>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockSlideshowEntriesCollection = {
    __typename?: 'BlockSlideshowEntriesCollection';
    items: Array<Maybe<BlockSlideshowEntriesItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockSlideshowEntriesCursorCollection = {
    __typename?: 'BlockSlideshowEntriesCursorCollection';
    items: Array<Maybe<BlockSlideshowEntriesItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockSlideshowEntriesFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockSlideshowEntriesFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockSlideshowEntriesFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockSlideshowEntriesItem = BlockClientTestimonial | PageCaseStudy | PageJournal;

export type BlockSlideshowFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockSlideshowFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockSlideshowFilter>>>;
    button?: InputMaybe<CfButtonNestedFilter>;
    button_exists?: InputMaybe<Scalars['Boolean']['input']>;
    companyTopic?: InputMaybe<CfCompanyTopicNestedFilter>;
    companyTopic_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentType?: InputMaybe<Scalars['String']['input']>;
    contentType_contains?: InputMaybe<Scalars['String']['input']>;
    contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentType_not?: InputMaybe<Scalars['String']['input']>;
    contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
    contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    entries?: InputMaybe<CfentriesMultiTypeNestedFilter>;
    entriesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    industry?: InputMaybe<CfIndustryNestedFilter>;
    industry_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    service?: InputMaybe<CfServiceNestedFilter>;
    service_exists?: InputMaybe<Scalars['Boolean']['input']>;
    solution?: InputMaybe<CfSolutionNestedFilter>;
    solution_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
    technology?: InputMaybe<CfTechnologyNestedFilter>;
    technology_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollections = {
    __typename?: 'BlockSlideshowLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockSlideshowLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockSlideshowLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockSlideshowLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockSlideshowLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockSlideshowLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockSlideshowOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockStackedCards) */
export type BlockStackedCards = Entry &
    _Node & {
        __typename?: 'BlockStackedCards';
        _id: Scalars['ID']['output'];
        cardsCollection?: Maybe<BlockStackedCardsCardsCollection>;
        cardsCursorCollection?: Maybe<BlockStackedCardsCardsCursorCollection>;
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockStackedCardsLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        paragraph?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockStackedCards) */
export type BlockStackedCardsCardsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockStackedCardsCardsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<StackedCardItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockStackedCards) */
export type BlockStackedCardsCardsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockStackedCardsCardsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<StackedCardItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockStackedCards) */
export type BlockStackedCardsHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockStackedCards) */
export type BlockStackedCardsInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockStackedCards) */
export type BlockStackedCardsLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockStackedCards) */
export type BlockStackedCardsOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockStackedCards) */
export type BlockStackedCardsParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockStackedCardsCardsCollection = {
    __typename?: 'BlockStackedCardsCardsCollection';
    items: Array<Maybe<StackedCardItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockStackedCardsCardsCollectionOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockStackedCardsCardsCursorCollection = {
    __typename?: 'BlockStackedCardsCardsCursorCollection';
    items: Array<Maybe<StackedCardItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockStackedCardsCardsCursorCollectionOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockStackedCardsCollection = {
    __typename?: 'BlockStackedCardsCollection';
    items: Array<Maybe<BlockStackedCards>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockStackedCardsCursorCollection = {
    __typename?: 'BlockStackedCardsCursorCollection';
    items: Array<Maybe<BlockStackedCards>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockStackedCardsFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockStackedCardsFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockStackedCardsFilter>>>;
    cards?: InputMaybe<CfStackedCardItemNestedFilter>;
    cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockStackedCardsLinkingCollections = {
    __typename?: 'BlockStackedCardsLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type BlockStackedCardsLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockStackedCardsLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockStackedCardsLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockStackedCardsLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockStackedCardsLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockStackedCardsLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockStackedCardsLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockStackedCardsLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockStackedCardsOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTabbedContent) */
export type BlockTabbedContent = Entry &
    _Node & {
        __typename?: 'BlockTabbedContent';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockTabbedContentLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        paragraph?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        tabsCollection?: Maybe<BlockTabbedContentTabsCollection>;
        tabsCursorCollection?: Maybe<BlockTabbedContentTabsCursorCollection>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTabbedContent) */
export type BlockTabbedContentHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTabbedContent) */
export type BlockTabbedContentInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTabbedContent) */
export type BlockTabbedContentLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTabbedContent) */
export type BlockTabbedContentOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTabbedContent) */
export type BlockTabbedContentParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTabbedContent) */
export type BlockTabbedContentTabsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTabbedContentTabsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TabbedContentItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTabbedContent) */
export type BlockTabbedContentTabsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTabbedContentTabsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TabbedContentItemFilter>;
};

export type BlockTabbedContentCollection = {
    __typename?: 'BlockTabbedContentCollection';
    items: Array<Maybe<BlockTabbedContent>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockTabbedContentCursorCollection = {
    __typename?: 'BlockTabbedContentCursorCollection';
    items: Array<Maybe<BlockTabbedContent>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockTabbedContentFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockTabbedContentFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockTabbedContentFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    tabs?: InputMaybe<CfTabbedContentItemNestedFilter>;
    tabsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTabbedContentLinkingCollections = {
    __typename?: 'BlockTabbedContentLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type BlockTabbedContentLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTabbedContentLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTabbedContentLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockTabbedContentLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTabbedContentLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTabbedContentLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockTabbedContentLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockTabbedContentLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockTabbedContentOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockTabbedContentTabsCollection = {
    __typename?: 'BlockTabbedContentTabsCollection';
    items: Array<Maybe<TabbedContentItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockTabbedContentTabsCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TabLabelAsc = 'tabLabel_ASC',
    TabLabelDesc = 'tabLabel_DESC',
}

export type BlockTabbedContentTabsCursorCollection = {
    __typename?: 'BlockTabbedContentTabsCursorCollection';
    items: Array<Maybe<TabbedContentItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockTabbedContentTabsCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TabLabelAsc = 'tabLabel_ASC',
    TabLabelDesc = 'tabLabel_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTechnologyBlocks) */
export type BlockTechnologyBlocks = Entry &
    _Node & {
        __typename?: 'BlockTechnologyBlocks';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<BlockTechnologyBlocksLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        paragraph?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        technologiesCollection?: Maybe<BlockTechnologyBlocksTechnologiesCollection>;
        technologiesCursorCollection?: Maybe<BlockTechnologyBlocksTechnologiesCursorCollection>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTechnologyBlocks) */
export type BlockTechnologyBlocksHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTechnologyBlocks) */
export type BlockTechnologyBlocksLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTechnologyBlocks) */
export type BlockTechnologyBlocksOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTechnologyBlocks) */
export type BlockTechnologyBlocksParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTechnologyBlocks) */
export type BlockTechnologyBlocksTechnologiesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksTechnologiesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TechnologyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/blockTechnologyBlocks) */
export type BlockTechnologyBlocksTechnologiesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksTechnologiesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TechnologyFilter>;
};

export type BlockTechnologyBlocksCollection = {
    __typename?: 'BlockTechnologyBlocksCollection';
    items: Array<Maybe<BlockTechnologyBlocks>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type BlockTechnologyBlocksCursorCollection = {
    __typename?: 'BlockTechnologyBlocksCursorCollection';
    items: Array<Maybe<BlockTechnologyBlocks>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type BlockTechnologyBlocksFilter = {
    AND?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    technologies?: InputMaybe<CfTechnologyNestedFilter>;
    technologiesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollections = {
    __typename?: 'BlockTechnologyBlocksLinkingCollections';
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type BlockTechnologyBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder>>
    >;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTechnologyBlocksLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockTechnologyBlocksLinkingCollectionsBlockDarkCircleBackgroundCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsBlockDarkCircleBackgroundCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    StyleAsc = 'style_ASC',
    StyleDesc = 'style_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum BlockTechnologyBlocksOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type BlockTechnologyBlocksTechnologiesCollection = {
    __typename?: 'BlockTechnologyBlocksTechnologiesCollection';
    items: Array<Maybe<Technology>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum BlockTechnologyBlocksTechnologiesCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TechnologySummaryAsc = 'technologySummary_ASC',
    TechnologySummaryDesc = 'technologySummary_DESC',
    TechnologyTypeAsc = 'technologyType_ASC',
    TechnologyTypeDesc = 'technologyType_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type BlockTechnologyBlocksTechnologiesCursorCollection = {
    __typename?: 'BlockTechnologyBlocksTechnologiesCursorCollection';
    items: Array<Maybe<Technology>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum BlockTechnologyBlocksTechnologiesCursorCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TechnologySummaryAsc = 'technologySummary_ASC',
    TechnologySummaryDesc = 'technologySummary_DESC',
    TechnologyTypeAsc = 'technologyType_ASC',
    TechnologyTypeDesc = 'technologyType_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/button) */
export type Button = Entry &
    _Node & {
        __typename?: 'Button';
        _id: Scalars['ID']['output'];
        buttonText?: Maybe<Scalars['String']['output']>;
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkPage?: Maybe<ButtonLinkPage>;
        linkPath?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<ButtonLinkingCollections>;
        ntExperiencesCollection?: Maybe<ButtonNt_ExperiencesCollection>;
        ntExperiencesCursorCollection?: Maybe<ButtonNt_ExperiencesCursorCollection>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/button) */
export type ButtonButtonTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/button) */
export type ButtonInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/button) */
export type ButtonLinkPageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/button) */
export type ButtonLinkPathArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/button) */
export type ButtonLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/button) */
export type ButtonNtExperiencesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonNt_ExperiencesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/button) */
export type ButtonNtExperiencesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonNt_ExperiencesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

export type ButtonCollection = {
    __typename?: 'ButtonCollection';
    items: Array<Maybe<Button>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type ButtonCursorCollection = {
    __typename?: 'ButtonCursorCollection';
    items: Array<Maybe<Button>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type ButtonFilter = {
    AND?: InputMaybe<Array<InputMaybe<ButtonFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<ButtonFilter>>>;
    buttonText?: InputMaybe<Scalars['String']['input']>;
    buttonText_contains?: InputMaybe<Scalars['String']['input']>;
    buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    buttonText_not?: InputMaybe<Scalars['String']['input']>;
    buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
    buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkPath?: InputMaybe<Scalars['String']['input']>;
    linkPath_contains?: InputMaybe<Scalars['String']['input']>;
    linkPath_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkPath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkPath_not?: InputMaybe<Scalars['String']['input']>;
    linkPath_not_contains?: InputMaybe<Scalars['String']['input']>;
    linkPath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experiences?: InputMaybe<CfNtExperienceNestedFilter>;
    nt_experiencesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type ButtonLinkPage = PageCaseStudy | PageIndustry | PageLanding | PagePerson | PageService;

export type ButtonLinkingCollections = {
    __typename?: 'ButtonLinkingCollections';
    blockFeaturedCaseStudiesCollection?: Maybe<BlockFeaturedCaseStudiesCollection>;
    blockFeaturedCaseStudiesCursorCollection?: Maybe<BlockFeaturedCaseStudiesCursorCollection>;
    blockPageIntroCollection?: Maybe<BlockPageIntroCollection>;
    blockPageIntroCursorCollection?: Maybe<BlockPageIntroCursorCollection>;
    blockSlideshowCollection?: Maybe<BlockSlideshowCollection>;
    blockSlideshowCursorCollection?: Maybe<BlockSlideshowCursorCollection>;
    ctaSimpleCollection?: Maybe<CtaSimpleCollection>;
    ctaSimpleCursorCollection?: Maybe<CtaSimpleCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type ButtonLinkingCollectionsBlockFeaturedCaseStudiesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsBlockFeaturedCaseStudiesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkingCollectionsBlockFeaturedCaseStudiesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsBlockFeaturedCaseStudiesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkingCollectionsBlockPageIntroCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsBlockPageIntroCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkingCollectionsBlockPageIntroCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsBlockPageIntroCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkingCollectionsBlockSlideshowCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsBlockSlideshowCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkingCollectionsBlockSlideshowCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsBlockSlideshowCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkingCollectionsCtaSimpleCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsCtaSimpleCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkingCollectionsCtaSimpleCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsCtaSimpleCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ButtonLinkingCollectionsBlockFeaturedCaseStudiesCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ButtonLinkingCollectionsBlockFeaturedCaseStudiesCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ButtonLinkingCollectionsBlockPageIntroCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ButtonLinkingCollectionsBlockPageIntroCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ButtonLinkingCollectionsBlockSlideshowCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ButtonLinkingCollectionsBlockSlideshowCursorCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ButtonLinkingCollectionsCtaSimpleCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ButtonLinkingCollectionsCtaSimpleCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type ButtonNt_ExperiencesCollection = {
    __typename?: 'ButtonNt_experiencesCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum ButtonNt_ExperiencesCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type ButtonNt_ExperiencesCursorCollection = {
    __typename?: 'ButtonNt_experiencesCursorCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum ButtonNt_ExperiencesCursorCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ButtonOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/career) */
export type Career = Entry &
    _Node & {
        __typename?: 'Career';
        _id: Scalars['ID']['output'];
        breezyUrl?: Maybe<Scalars['String']['output']>;
        contentfulMetadata: ContentfulMetadata;
        icon?: Maybe<Icon>;
        linkedFrom?: Maybe<CareerLinkingCollections>;
        summary?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/career) */
export type CareerBreezyUrlArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/career) */
export type CareerIconArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IconFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/career) */
export type CareerLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/career) */
export type CareerSummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/career) */
export type CareerTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CareerCollection = {
    __typename?: 'CareerCollection';
    items: Array<Maybe<Career>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type CareerCursorCollection = {
    __typename?: 'CareerCursorCollection';
    items: Array<Maybe<Career>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type CareerFilter = {
    AND?: InputMaybe<Array<InputMaybe<CareerFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CareerFilter>>>;
    breezyUrl?: InputMaybe<Scalars['String']['input']>;
    breezyUrl_contains?: InputMaybe<Scalars['String']['input']>;
    breezyUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
    breezyUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    breezyUrl_not?: InputMaybe<Scalars['String']['input']>;
    breezyUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
    breezyUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    icon?: InputMaybe<CfIconNestedFilter>;
    icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CareerLinkingCollections = {
    __typename?: 'CareerLinkingCollections';
    blockJobListCollection?: Maybe<BlockJobListCollection>;
    blockJobListCursorCollection?: Maybe<BlockJobListCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type CareerLinkingCollectionsBlockJobListCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CareerLinkingCollectionsBlockJobListCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CareerLinkingCollectionsBlockJobListCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CareerLinkingCollectionsBlockJobListCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CareerLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CareerLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CareerLinkingCollectionsBlockJobListCollectionOrder {
    ExtraJobHeaderAsc = 'extraJobHeader_ASC',
    ExtraJobHeaderDesc = 'extraJobHeader_DESC',
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum CareerLinkingCollectionsBlockJobListCursorCollectionOrder {
    ExtraJobHeaderAsc = 'extraJobHeader_ASC',
    ExtraJobHeaderDesc = 'extraJobHeader_DESC',
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum CareerOrder {
    BreezyUrlAsc = 'breezyUrl_ASC',
    BreezyUrlDesc = 'breezyUrl_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/client) */
export type Client = Entry &
    _Node & {
        __typename?: 'Client';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        linkedFrom?: Maybe<ClientLinkingCollections>;
        name?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/client) */
export type ClientLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/client) */
export type ClientNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientCollection = {
    __typename?: 'ClientCollection';
    items: Array<Maybe<Client>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type ClientCursorCollection = {
    __typename?: 'ClientCursorCollection';
    items: Array<Maybe<Client>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type ClientFilter = {
    AND?: InputMaybe<Array<InputMaybe<ClientFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<ClientFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    name?: InputMaybe<Scalars['String']['input']>;
    name_contains?: InputMaybe<Scalars['String']['input']>;
    name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    name_not?: InputMaybe<Scalars['String']['input']>;
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type ClientLinkingCollections = {
    __typename?: 'ClientLinkingCollections';
    blockClientTestimonialCollection?: Maybe<BlockClientTestimonialCollection>;
    blockClientTestimonialCursorCollection?: Maybe<BlockClientTestimonialCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
};

export type ClientLinkingCollectionsBlockClientTestimonialCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ClientLinkingCollectionsBlockClientTestimonialCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientLinkingCollectionsBlockClientTestimonialCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ClientLinkingCollectionsBlockClientTestimonialCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ClientLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ClientLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ClientLinkingCollectionsBlockClientTestimonialCollectionOrder {
    AuthorNameAsc = 'authorName_ASC',
    AuthorNameDesc = 'authorName_DESC',
    AuthorTitleAsc = 'authorTitle_ASC',
    AuthorTitleDesc = 'authorTitle_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ClientLinkingCollectionsBlockClientTestimonialCursorCollectionOrder {
    AuthorNameAsc = 'authorName_ASC',
    AuthorNameDesc = 'authorName_DESC',
    AuthorTitleAsc = 'authorTitle_ASC',
    AuthorTitleDesc = 'authorTitle_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ClientLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum ClientLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum ClientOrder {
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type Cloudinary_Asset = {
    __typename?: 'Cloudinary_Asset';
    accessMode?: Maybe<Scalars['String']['output']>;
    bytes: Scalars['Int']['output'];
    context?: Maybe<Scalars['Cloudinary_JSON']['output']>;
    createdAt: Scalars['Cloudinary_DateTime']['output'];
    derived?: Maybe<Array<Maybe<Cloudinary_DerivedAsset>>>;
    etag?: Maybe<Scalars['String']['output']>;
    folder?: Maybe<Scalars['String']['output']>;
    format: Scalars['String']['output'];
    grayscale?: Maybe<Scalars['Boolean']['output']>;
    height?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    metadata?: Maybe<Scalars['Cloudinary_JSON']['output']>;
    publicId: Scalars['String']['output'];
    resourceType: Scalars['String']['output'];
    secureUrl?: Maybe<Scalars['String']['output']>;
    semiTransparent?: Maybe<Scalars['Boolean']['output']>;
    tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    type: Scalars['String']['output'];
    url?: Maybe<Scalars['String']['output']>;
    version: Scalars['Int']['output'];
    width?: Maybe<Scalars['Int']['output']>;
};

export type Cloudinary_DerivedAsset = {
    __typename?: 'Cloudinary_DerivedAsset';
    bytes: Scalars['Int']['output'];
    extension?: Maybe<Scalars['String']['output']>;
    format: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    secureUrl: Scalars['String']['output'];
    transformation: Scalars['String']['output'];
    url: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/codeBlock) */
export type CodeBlock = Entry &
    _Node & {
        __typename?: 'CodeBlock';
        _id: Scalars['ID']['output'];
        code?: Maybe<Scalars['String']['output']>;
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        language?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<CodeBlockLinkingCollections>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/codeBlock) */
export type CodeBlockCodeArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/codeBlock) */
export type CodeBlockInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/codeBlock) */
export type CodeBlockLanguageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/codeBlock) */
export type CodeBlockLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CodeBlockCollection = {
    __typename?: 'CodeBlockCollection';
    items: Array<Maybe<CodeBlock>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type CodeBlockCursorCollection = {
    __typename?: 'CodeBlockCursorCollection';
    items: Array<Maybe<CodeBlock>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type CodeBlockFilter = {
    AND?: InputMaybe<Array<InputMaybe<CodeBlockFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CodeBlockFilter>>>;
    code?: InputMaybe<Scalars['String']['input']>;
    code_contains?: InputMaybe<Scalars['String']['input']>;
    code_exists?: InputMaybe<Scalars['Boolean']['input']>;
    code_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    code_not?: InputMaybe<Scalars['String']['input']>;
    code_not_contains?: InputMaybe<Scalars['String']['input']>;
    code_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    language?: InputMaybe<Scalars['String']['input']>;
    language_contains?: InputMaybe<Scalars['String']['input']>;
    language_exists?: InputMaybe<Scalars['Boolean']['input']>;
    language_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    language_not?: InputMaybe<Scalars['String']['input']>;
    language_not_contains?: InputMaybe<Scalars['String']['input']>;
    language_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CodeBlockLinkingCollections = {
    __typename?: 'CodeBlockLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type CodeBlockLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CodeBlockLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CodeBlockOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LanguageAsc = 'language_ASC',
    LanguageDesc = 'language_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/companyTopic) */
export type CompanyTopic = Entry &
    _Node & {
        __typename?: 'CompanyTopic';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        linkedFrom?: Maybe<CompanyTopicLinkingCollections>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/companyTopic) */
export type CompanyTopicLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/companyTopic) */
export type CompanyTopicTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyTopicCollection = {
    __typename?: 'CompanyTopicCollection';
    items: Array<Maybe<CompanyTopic>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type CompanyTopicCursorCollection = {
    __typename?: 'CompanyTopicCursorCollection';
    items: Array<Maybe<CompanyTopic>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type CompanyTopicFilter = {
    AND?: InputMaybe<Array<InputMaybe<CompanyTopicFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CompanyTopicFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CompanyTopicLinkingCollections = {
    __typename?: 'CompanyTopicLinkingCollections';
    blockSlideshowCollection?: Maybe<BlockSlideshowCollection>;
    blockSlideshowCursorCollection?: Maybe<BlockSlideshowCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
};

export type CompanyTopicLinkingCollectionsBlockSlideshowCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CompanyTopicLinkingCollectionsBlockSlideshowCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyTopicLinkingCollectionsBlockSlideshowCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CompanyTopicLinkingCollectionsBlockSlideshowCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyTopicLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyTopicLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyTopicLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CompanyTopicLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyTopicLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CompanyTopicLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CompanyTopicLinkingCollectionsBlockSlideshowCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum CompanyTopicLinkingCollectionsBlockSlideshowCursorCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum CompanyTopicLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum CompanyTopicLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum CompanyTopicOrder {
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type ContentfulMetadata = {
    __typename?: 'ContentfulMetadata';
    concepts: Array<Maybe<TaxonomyConcept>>;
    tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
    id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataConceptsFilter = {
    descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
    id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataFilter = {
    concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
    concepts_exists?: InputMaybe<Scalars['Boolean']['input']>;
    tags?: InputMaybe<ContentfulMetadataTagsFilter>;
    tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMetadataTagsFilter = {
    id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
    __typename?: 'ContentfulTag';
    id?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/ctaSimple) */
export type CtaSimple = Entry &
    _Node & {
        __typename?: 'CtaSimple';
        _id: Scalars['ID']['output'];
        button?: Maybe<Button>;
        contentfulMetadata: ContentfulMetadata;
        form?: Maybe<Form>;
        headerText?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<CtaSimpleLinkingCollections>;
        ntExperiencesCollection?: Maybe<CtaSimpleNt_ExperiencesCollection>;
        ntExperiencesCursorCollection?: Maybe<CtaSimpleNt_ExperiencesCursorCollection>;
        overline?: Maybe<Scalars['String']['output']>;
        paragraphText?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/ctaSimple) */
export type CtaSimpleButtonArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ButtonFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/ctaSimple) */
export type CtaSimpleFormArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FormFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/ctaSimple) */
export type CtaSimpleHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/ctaSimple) */
export type CtaSimpleInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/ctaSimple) */
export type CtaSimpleLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/ctaSimple) */
export type CtaSimpleNtExperiencesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleNt_ExperiencesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/ctaSimple) */
export type CtaSimpleNtExperiencesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleNt_ExperiencesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/ctaSimple) */
export type CtaSimpleOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/ctaSimple) */
export type CtaSimpleParagraphTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleCollection = {
    __typename?: 'CtaSimpleCollection';
    items: Array<Maybe<CtaSimple>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type CtaSimpleCursorCollection = {
    __typename?: 'CtaSimpleCursorCollection';
    items: Array<Maybe<CtaSimple>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type CtaSimpleFilter = {
    AND?: InputMaybe<Array<InputMaybe<CtaSimpleFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CtaSimpleFilter>>>;
    button?: InputMaybe<CfButtonNestedFilter>;
    button_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    form?: InputMaybe<CfFormNestedFilter>;
    form_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experiences?: InputMaybe<CfNtExperienceNestedFilter>;
    nt_experiencesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraphText?: InputMaybe<Scalars['String']['input']>;
    paragraphText_contains?: InputMaybe<Scalars['String']['input']>;
    paragraphText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraphText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraphText_not?: InputMaybe<Scalars['String']['input']>;
    paragraphText_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraphText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CtaSimpleLinkingCollections = {
    __typename?: 'CtaSimpleLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type CtaSimpleLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CtaSimpleLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CtaSimpleLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum CtaSimpleLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum CtaSimpleLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum CtaSimpleLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum CtaSimpleLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum CtaSimpleLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type CtaSimpleNt_ExperiencesCollection = {
    __typename?: 'CtaSimpleNt_experiencesCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum CtaSimpleNt_ExperiencesCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type CtaSimpleNt_ExperiencesCursorCollection = {
    __typename?: 'CtaSimpleNt_experiencesCursorCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum CtaSimpleNt_ExperiencesCursorCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum CtaSimpleOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type CursorPages = {
    __typename?: 'CursorPages';
    next?: Maybe<Scalars['String']['output']>;
    prev?: Maybe<Scalars['String']['output']>;
};

export type Entry = {
    contentfulMetadata: ContentfulMetadata;
    sys: Sys;
};

export type EntryCollection = {
    __typename?: 'EntryCollection';
    items: Array<Maybe<Entry>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type EntryCursorCollection = {
    __typename?: 'EntryCursorCollection';
    items: Array<Maybe<Entry>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type EntryFilter = {
    AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/expertise) */
export type Expertise = Entry &
    _Node & {
        __typename?: 'Expertise';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        linkedFrom?: Maybe<ExpertiseLinkingCollections>;
        slug?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/expertise) */
export type ExpertiseLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/expertise) */
export type ExpertiseSlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/expertise) */
export type ExpertiseTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpertiseCollection = {
    __typename?: 'ExpertiseCollection';
    items: Array<Maybe<Expertise>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type ExpertiseCursorCollection = {
    __typename?: 'ExpertiseCursorCollection';
    items: Array<Maybe<Expertise>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type ExpertiseFilter = {
    AND?: InputMaybe<Array<InputMaybe<ExpertiseFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<ExpertiseFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExpertiseLinkingCollections = {
    __typename?: 'ExpertiseLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
};

export type ExpertiseLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpertiseLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpertiseLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ExpertiseLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpertiseLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ExpertiseLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ExpertiseLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ExpertiseLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ExpertiseOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/fact) */
export type Fact = Entry &
    _Node & {
        __typename?: 'Fact';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        fact?: Maybe<Scalars['String']['output']>;
        header?: Maybe<Scalars['String']['output']>;
        link?: Maybe<InternalPageLink>;
        linkedFrom?: Maybe<FactLinkingCollections>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/fact) */
export type FactFactArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/fact) */
export type FactHeaderArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/fact) */
export type FactLinkArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<InternalPageLinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/fact) */
export type FactLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FactCollection = {
    __typename?: 'FactCollection';
    items: Array<Maybe<Fact>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type FactCursorCollection = {
    __typename?: 'FactCursorCollection';
    items: Array<Maybe<Fact>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type FactFilter = {
    AND?: InputMaybe<Array<InputMaybe<FactFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<FactFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    fact?: InputMaybe<Scalars['String']['input']>;
    fact_contains?: InputMaybe<Scalars['String']['input']>;
    fact_exists?: InputMaybe<Scalars['Boolean']['input']>;
    fact_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    fact_not?: InputMaybe<Scalars['String']['input']>;
    fact_not_contains?: InputMaybe<Scalars['String']['input']>;
    fact_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    header?: InputMaybe<Scalars['String']['input']>;
    header_contains?: InputMaybe<Scalars['String']['input']>;
    header_exists?: InputMaybe<Scalars['Boolean']['input']>;
    header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    header_not?: InputMaybe<Scalars['String']['input']>;
    header_not_contains?: InputMaybe<Scalars['String']['input']>;
    header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    link?: InputMaybe<CfInternalPageLinkNestedFilter>;
    link_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type FactLinkingCollections = {
    __typename?: 'FactLinkingCollections';
    blockNumberedBlocksCollection?: Maybe<BlockNumberedBlocksCollection>;
    blockNumberedBlocksCursorCollection?: Maybe<BlockNumberedBlocksCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    personCollection?: Maybe<PersonCollection>;
    personCursorCollection?: Maybe<PersonCursorCollection>;
};

export type FactLinkingCollectionsBlockNumberedBlocksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FactLinkingCollectionsBlockNumberedBlocksCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FactLinkingCollectionsBlockNumberedBlocksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FactLinkingCollectionsBlockNumberedBlocksCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FactLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FactLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FactLinkingCollectionsPersonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FactLinkingCollectionsPersonCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FactLinkingCollectionsPersonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FactLinkingCollectionsPersonCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FactLinkingCollectionsBlockNumberedBlocksCollectionOrder {
    InternalTitleAsc = 'internalTitle_ASC',
    InternalTitleDesc = 'internalTitle_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum FactLinkingCollectionsBlockNumberedBlocksCursorCollectionOrder {
    InternalTitleAsc = 'internalTitle_ASC',
    InternalTitleDesc = 'internalTitle_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum FactLinkingCollectionsPersonCollectionOrder {
    EmailAsc = 'email_ASC',
    EmailDesc = 'email_DESC',
    FirstNameAsc = 'firstName_ASC',
    FirstNameDesc = 'firstName_DESC',
    JobTitleAsc = 'jobTitle_ASC',
    JobTitleDesc = 'jobTitle_DESC',
    LastNameAsc = 'lastName_ASC',
    LastNameDesc = 'lastName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum FactLinkingCollectionsPersonCursorCollectionOrder {
    EmailAsc = 'email_ASC',
    EmailDesc = 'email_DESC',
    FirstNameAsc = 'firstName_ASC',
    FirstNameDesc = 'firstName_DESC',
    JobTitleAsc = 'jobTitle_ASC',
    JobTitleDesc = 'jobTitle_DESC',
    LastNameAsc = 'lastName_ASC',
    LastNameDesc = 'lastName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum FactOrder {
    HeaderAsc = 'header_ASC',
    HeaderDesc = 'header_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/form) */
export type Form = Entry &
    _Node & {
        __typename?: 'Form';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        fieldsCollection?: Maybe<FormFieldsCollection>;
        fieldsCursorCollection?: Maybe<FormFieldsCursorCollection>;
        formErrorMessage?: Maybe<Scalars['String']['output']>;
        id?: Maybe<Scalars['String']['output']>;
        intro?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<FormLinkingCollections>;
        submitButtonText?: Maybe<Scalars['String']['output']>;
        successMessage?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/form) */
export type FormFieldsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormFieldsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FormFieldFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/form) */
export type FormFieldsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormFieldsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FormFieldFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/form) */
export type FormFormErrorMessageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/form) */
export type FormIdArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/form) */
export type FormIntroArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/form) */
export type FormLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/form) */
export type FormSubmitButtonTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/form) */
export type FormSuccessMessageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormCollection = {
    __typename?: 'FormCollection';
    items: Array<Maybe<Form>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type FormCursorCollection = {
    __typename?: 'FormCursorCollection';
    items: Array<Maybe<Form>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/formField) */
export type FormField = Entry &
    _Node & {
        __typename?: 'FormField';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        label?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<FormFieldLinkingCollections>;
        placeholder?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        value?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/formField) */
export type FormFieldLabelArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/formField) */
export type FormFieldLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/formField) */
export type FormFieldPlaceholderArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/formField) */
export type FormFieldValueArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormFieldCollection = {
    __typename?: 'FormFieldCollection';
    items: Array<Maybe<FormField>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type FormFieldCursorCollection = {
    __typename?: 'FormFieldCursorCollection';
    items: Array<Maybe<FormField>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type FormFieldFilter = {
    AND?: InputMaybe<Array<InputMaybe<FormFieldFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<FormFieldFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    label?: InputMaybe<Scalars['String']['input']>;
    label_contains?: InputMaybe<Scalars['String']['input']>;
    label_exists?: InputMaybe<Scalars['Boolean']['input']>;
    label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    label_not?: InputMaybe<Scalars['String']['input']>;
    label_not_contains?: InputMaybe<Scalars['String']['input']>;
    label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    placeholder?: InputMaybe<Scalars['String']['input']>;
    placeholder_contains?: InputMaybe<Scalars['String']['input']>;
    placeholder_exists?: InputMaybe<Scalars['Boolean']['input']>;
    placeholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    placeholder_not?: InputMaybe<Scalars['String']['input']>;
    placeholder_not_contains?: InputMaybe<Scalars['String']['input']>;
    placeholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    value?: InputMaybe<Scalars['String']['input']>;
    value_contains?: InputMaybe<Scalars['String']['input']>;
    value_exists?: InputMaybe<Scalars['Boolean']['input']>;
    value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    value_not?: InputMaybe<Scalars['String']['input']>;
    value_not_contains?: InputMaybe<Scalars['String']['input']>;
    value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormFieldLinkingCollections = {
    __typename?: 'FormFieldLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    formCollection?: Maybe<FormCollection>;
    formCursorCollection?: Maybe<FormCursorCollection>;
};

export type FormFieldLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormFieldLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormFieldLinkingCollectionsFormCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormFieldLinkingCollectionsFormCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormFieldLinkingCollectionsFormCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormFieldLinkingCollectionsFormCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FormFieldLinkingCollectionsFormCollectionOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    SubmitButtonTextAsc = 'submitButtonText_ASC',
    SubmitButtonTextDesc = 'submitButtonText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum FormFieldLinkingCollectionsFormCursorCollectionOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    SubmitButtonTextAsc = 'submitButtonText_ASC',
    SubmitButtonTextDesc = 'submitButtonText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum FormFieldOrder {
    LabelAsc = 'label_ASC',
    LabelDesc = 'label_DESC',
    PlaceholderAsc = 'placeholder_ASC',
    PlaceholderDesc = 'placeholder_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    ValueAsc = 'value_ASC',
    ValueDesc = 'value_DESC',
}

export type FormFieldsCollection = {
    __typename?: 'FormFieldsCollection';
    items: Array<Maybe<FormField>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum FormFieldsCollectionOrder {
    LabelAsc = 'label_ASC',
    LabelDesc = 'label_DESC',
    PlaceholderAsc = 'placeholder_ASC',
    PlaceholderDesc = 'placeholder_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    ValueAsc = 'value_ASC',
    ValueDesc = 'value_DESC',
}

export type FormFieldsCursorCollection = {
    __typename?: 'FormFieldsCursorCollection';
    items: Array<Maybe<FormField>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum FormFieldsCursorCollectionOrder {
    LabelAsc = 'label_ASC',
    LabelDesc = 'label_DESC',
    PlaceholderAsc = 'placeholder_ASC',
    PlaceholderDesc = 'placeholder_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    ValueAsc = 'value_ASC',
    ValueDesc = 'value_DESC',
}

export type FormFilter = {
    AND?: InputMaybe<Array<InputMaybe<FormFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<FormFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    fields?: InputMaybe<CfFormFieldNestedFilter>;
    fieldsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    formErrorMessage?: InputMaybe<Scalars['String']['input']>;
    formErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
    formErrorMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    formErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    formErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
    formErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
    formErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id?: InputMaybe<Scalars['String']['input']>;
    id_contains?: InputMaybe<Scalars['String']['input']>;
    id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_not?: InputMaybe<Scalars['String']['input']>;
    id_not_contains?: InputMaybe<Scalars['String']['input']>;
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    intro?: InputMaybe<Scalars['String']['input']>;
    intro_contains?: InputMaybe<Scalars['String']['input']>;
    intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
    intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    intro_not?: InputMaybe<Scalars['String']['input']>;
    intro_not_contains?: InputMaybe<Scalars['String']['input']>;
    intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    submitButtonText?: InputMaybe<Scalars['String']['input']>;
    submitButtonText_contains?: InputMaybe<Scalars['String']['input']>;
    submitButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    submitButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    submitButtonText_not?: InputMaybe<Scalars['String']['input']>;
    submitButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
    submitButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    successMessage?: InputMaybe<Scalars['String']['input']>;
    successMessage_contains?: InputMaybe<Scalars['String']['input']>;
    successMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    successMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    successMessage_not?: InputMaybe<Scalars['String']['input']>;
    successMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
    successMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type FormLinkingCollections = {
    __typename?: 'FormLinkingCollections';
    ctaSimpleCollection?: Maybe<CtaSimpleCollection>;
    ctaSimpleCursorCollection?: Maybe<CtaSimpleCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
};

export type FormLinkingCollectionsCtaSimpleCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormLinkingCollectionsCtaSimpleCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormLinkingCollectionsCtaSimpleCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormLinkingCollectionsCtaSimpleCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormLinkingCollectionsPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormLinkingCollectionsPageCompanyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormLinkingCollectionsPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormLinkingCollectionsPageCompanyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FormLinkingCollectionsCtaSimpleCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum FormLinkingCollectionsCtaSimpleCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum FormLinkingCollectionsPageCompanyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum FormLinkingCollectionsPageCompanyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum FormLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum FormLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum FormOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    SubmitButtonTextAsc = 'submitButtonText_ASC',
    SubmitButtonTextDesc = 'submitButtonText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/icon) */
export type Icon = Entry &
    _Node & {
        __typename?: 'Icon';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        iconCloudinary?: Maybe<Scalars['JSON']['output']>;
        iconImage?: Maybe<Asset>;
        keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
        linkedFrom?: Maybe<IconLinkingCollections>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/icon) */
export type IconIconCloudinaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/icon) */
export type IconIconImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/icon) */
export type IconKeywordsArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/icon) */
export type IconLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/icon) */
export type IconTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/iconBlock) */
export type IconBlock = Entry &
    _Node & {
        __typename?: 'IconBlock';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        icon?: Maybe<Icon>;
        link?: Maybe<IconBlockLink>;
        linkedFrom?: Maybe<IconBlockLinkingCollections>;
        paragraph?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/iconBlock) */
export type IconBlockHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/iconBlock) */
export type IconBlockIconArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IconFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/iconBlock) */
export type IconBlockLinkArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/iconBlock) */
export type IconBlockLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/iconBlock) */
export type IconBlockParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconBlockCollection = {
    __typename?: 'IconBlockCollection';
    items: Array<Maybe<IconBlock>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type IconBlockCursorCollection = {
    __typename?: 'IconBlockCursorCollection';
    items: Array<Maybe<IconBlock>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type IconBlockFilter = {
    AND?: InputMaybe<Array<InputMaybe<IconBlockFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<IconBlockFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    icon?: InputMaybe<CfIconNestedFilter>;
    icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
    link_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type IconBlockLink =
    | PageCaseStudy
    | PageCompany
    | PageIndustry
    | PageJournal
    | PageLanding
    | PagePerson
    | PageService
    | PageTechnology;

export type IconBlockLinkingCollections = {
    __typename?: 'IconBlockLinkingCollections';
    blockIconBlocksCollection?: Maybe<BlockIconBlocksCollection>;
    blockIconBlocksCursorCollection?: Maybe<BlockIconBlocksCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type IconBlockLinkingCollectionsBlockIconBlocksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconBlockLinkingCollectionsBlockIconBlocksCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconBlockLinkingCollectionsBlockIconBlocksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconBlockLinkingCollectionsBlockIconBlocksCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconBlockLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconBlockLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IconBlockLinkingCollectionsBlockIconBlocksCollectionOrder {
    BackgroundColorAsc = 'backgroundColor_ASC',
    BackgroundColorDesc = 'backgroundColor_DESC',
    IconColorAsc = 'iconColor_ASC',
    IconColorDesc = 'iconColor_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    NumberOfColumnsOfBlocksAsc = 'numberOfColumnsOfBlocks_ASC',
    NumberOfColumnsOfBlocksDesc = 'numberOfColumnsOfBlocks_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum IconBlockLinkingCollectionsBlockIconBlocksCursorCollectionOrder {
    BackgroundColorAsc = 'backgroundColor_ASC',
    BackgroundColorDesc = 'backgroundColor_DESC',
    IconColorAsc = 'iconColor_ASC',
    IconColorDesc = 'iconColor_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    NumberOfColumnsOfBlocksAsc = 'numberOfColumnsOfBlocks_ASC',
    NumberOfColumnsOfBlocksDesc = 'numberOfColumnsOfBlocks_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum IconBlockOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type IconCollection = {
    __typename?: 'IconCollection';
    items: Array<Maybe<Icon>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type IconCursorCollection = {
    __typename?: 'IconCursorCollection';
    items: Array<Maybe<Icon>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type IconFilter = {
    AND?: InputMaybe<Array<InputMaybe<IconFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<IconFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    iconCloudinary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    iconImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    keywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    keywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    keywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    keywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IconLinkingCollections = {
    __typename?: 'IconLinkingCollections';
    blockJobListCollection?: Maybe<BlockJobListCollection>;
    blockJobListCursorCollection?: Maybe<BlockJobListCursorCollection>;
    careerCollection?: Maybe<CareerCollection>;
    careerCursorCollection?: Maybe<CareerCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    iconBlockCollection?: Maybe<IconBlockCollection>;
    iconBlockCursorCollection?: Maybe<IconBlockCursorCollection>;
};

export type IconLinkingCollectionsBlockJobListCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconLinkingCollectionsBlockJobListCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconLinkingCollectionsBlockJobListCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconLinkingCollectionsBlockJobListCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconLinkingCollectionsCareerCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconLinkingCollectionsCareerCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconLinkingCollectionsCareerCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconLinkingCollectionsCareerCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconLinkingCollectionsIconBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconLinkingCollectionsIconBlockCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconLinkingCollectionsIconBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconLinkingCollectionsIconBlockCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IconLinkingCollectionsBlockJobListCollectionOrder {
    ExtraJobHeaderAsc = 'extraJobHeader_ASC',
    ExtraJobHeaderDesc = 'extraJobHeader_DESC',
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum IconLinkingCollectionsBlockJobListCursorCollectionOrder {
    ExtraJobHeaderAsc = 'extraJobHeader_ASC',
    ExtraJobHeaderDesc = 'extraJobHeader_DESC',
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum IconLinkingCollectionsCareerCollectionOrder {
    BreezyUrlAsc = 'breezyUrl_ASC',
    BreezyUrlDesc = 'breezyUrl_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum IconLinkingCollectionsCareerCursorCollectionOrder {
    BreezyUrlAsc = 'breezyUrl_ASC',
    BreezyUrlDesc = 'breezyUrl_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum IconLinkingCollectionsIconBlockCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum IconLinkingCollectionsIconBlockCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum IconOrder {
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageFormat {
    /** AVIF image format. */
    Avif = 'AVIF',
    /** JPG image format. */
    Jpg = 'JPG',
    /**
     * Progressive JPG format stores multiple passes of an image in progressively higher detail.
     *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
     *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
     *         early as possible to make the layout look as designed.
     */
    JpgProgressive = 'JPG_PROGRESSIVE',
    /** PNG image format */
    Png = 'PNG',
    /**
     * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
     *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
     */
    Png8 = 'PNG8',
    /** WebP image format. */
    Webp = 'WEBP',
}

export enum ImageResizeFocus {
    /** Focus the resizing on the bottom. */
    Bottom = 'BOTTOM',
    /** Focus the resizing on the bottom left. */
    BottomLeft = 'BOTTOM_LEFT',
    /** Focus the resizing on the bottom right. */
    BottomRight = 'BOTTOM_RIGHT',
    /** Focus the resizing on the center. */
    Center = 'CENTER',
    /** Focus the resizing on the largest face. */
    Face = 'FACE',
    /** Focus the resizing on the area containing all the faces. */
    Faces = 'FACES',
    /** Focus the resizing on the left. */
    Left = 'LEFT',
    /** Focus the resizing on the right. */
    Right = 'RIGHT',
    /** Focus the resizing on the top. */
    Top = 'TOP',
    /** Focus the resizing on the top left. */
    TopLeft = 'TOP_LEFT',
    /** Focus the resizing on the top right. */
    TopRight = 'TOP_RIGHT',
}

export enum ImageResizeStrategy {
    /** Crops a part of the original image to fit into the specified dimensions. */
    Crop = 'CROP',
    /** Resizes the image to the specified dimensions, cropping the image if needed. */
    Fill = 'FILL',
    /** Resizes the image to fit into the specified dimensions. */
    Fit = 'FIT',
    /**
     * Resizes the image to the specified dimensions, padding the image if needed.
     *         Uses desired background color as padding color.
     */
    Pad = 'PAD',
    /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
    Scale = 'SCALE',
    /** Creates a thumbnail from the image. */
    Thumb = 'THUMB',
}

export type ImageTransformOptions = {
    /**
     * Desired background color, used with corner radius or `PAD` resize strategy.
     *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
     */
    backgroundColor?: InputMaybe<Scalars['HexColor']['input']>;
    /**
     * Desired corner radius in pixels.
     *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
     *         Defaults to `0`. Uses desired background color as padding color,
     *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
     */
    cornerRadius?: InputMaybe<Scalars['Int']['input']>;
    /** Desired image format. Defaults to the original image format. */
    format?: InputMaybe<ImageFormat>;
    /** Desired height in pixels. Defaults to the original image height. */
    height?: InputMaybe<Scalars['Dimension']['input']>;
    /**
     * Desired quality of the image in percents.
     *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
     */
    quality?: InputMaybe<Scalars['Quality']['input']>;
    /** Desired resize focus area. Defaults to `CENTER`. */
    resizeFocus?: InputMaybe<ImageResizeFocus>;
    /** Desired resize strategy. Defaults to `FIT`. */
    resizeStrategy?: InputMaybe<ImageResizeStrategy>;
    /** Desired width in pixels. Defaults to the original image width. */
    width?: InputMaybe<Scalars['Dimension']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/imageWrapper) */
export type ImageWrapper = Entry &
    _Node & {
        __typename?: 'ImageWrapper';
        _id: Scalars['ID']['output'];
        altText?: Maybe<Scalars['String']['output']>;
        cloudinaryMedia?: Maybe<Scalars['JSON']['output']>;
        contentfulMetadata: ContentfulMetadata;
        description?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<ImageWrapperLinkingCollections>;
        media?: Maybe<Asset>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/imageWrapper) */
export type ImageWrapperAltTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/imageWrapper) */
export type ImageWrapperCloudinaryMediaArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/imageWrapper) */
export type ImageWrapperDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/imageWrapper) */
export type ImageWrapperLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/imageWrapper) */
export type ImageWrapperMediaArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/imageWrapper) */
export type ImageWrapperTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperCollection = {
    __typename?: 'ImageWrapperCollection';
    items: Array<Maybe<ImageWrapper>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type ImageWrapperCursorCollection = {
    __typename?: 'ImageWrapperCursorCollection';
    items: Array<Maybe<ImageWrapper>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type ImageWrapperFilter = {
    AND?: InputMaybe<Array<InputMaybe<ImageWrapperFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<ImageWrapperFilter>>>;
    altText?: InputMaybe<Scalars['String']['input']>;
    altText_contains?: InputMaybe<Scalars['String']['input']>;
    altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    altText_not?: InputMaybe<Scalars['String']['input']>;
    altText_not_contains?: InputMaybe<Scalars['String']['input']>;
    altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    cloudinaryMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    description?: InputMaybe<Scalars['String']['input']>;
    description_contains?: InputMaybe<Scalars['String']['input']>;
    description_exists?: InputMaybe<Scalars['Boolean']['input']>;
    description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    description_not?: InputMaybe<Scalars['String']['input']>;
    description_not_contains?: InputMaybe<Scalars['String']['input']>;
    description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    media_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ImageWrapperLinkingCollections = {
    __typename?: 'ImageWrapperLinkingCollections';
    accordionContentItemCollection?: Maybe<AccordionContentItemCollection>;
    accordionContentItemCursorCollection?: Maybe<AccordionContentItemCursorCollection>;
    blockClientTestimonialCollection?: Maybe<BlockClientTestimonialCollection>;
    blockClientTestimonialCursorCollection?: Maybe<BlockClientTestimonialCursorCollection>;
    blockImageCollection?: Maybe<BlockImageCollection>;
    blockImageCursorCollection?: Maybe<BlockImageCursorCollection>;
    blockImageWithPartialOverlayCollection?: Maybe<BlockImageWithPartialOverlayCollection>;
    blockImageWithPartialOverlayCursorCollection?: Maybe<BlockImageWithPartialOverlayCursorCollection>;
    blockLogoCarouselCollection?: Maybe<BlockLogoCarouselCollection>;
    blockLogoCarouselCursorCollection?: Maybe<BlockLogoCarouselCursorCollection>;
    blockLogoGridCollection?: Maybe<BlockLogoGridCollection>;
    blockLogoGridCursorCollection?: Maybe<BlockLogoGridCursorCollection>;
    blockPageIntroCollection?: Maybe<BlockPageIntroCollection>;
    blockPageIntroCursorCollection?: Maybe<BlockPageIntroCursorCollection>;
    blockPageSectionCollection?: Maybe<BlockPageSectionCollection>;
    blockPageSectionCursorCollection?: Maybe<BlockPageSectionCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pagePersonCollection?: Maybe<PagePersonCollection>;
    pagePersonCursorCollection?: Maybe<PagePersonCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    personCollection?: Maybe<PersonCollection>;
    personCursorCollection?: Maybe<PersonCursorCollection>;
    technologyCollection?: Maybe<TechnologyCollection>;
    technologyCursorCollection?: Maybe<TechnologyCursorCollection>;
};

export type ImageWrapperLinkingCollectionsAccordionContentItemCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsAccordionContentItemCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsAccordionContentItemCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsAccordionContentItemCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockClientTestimonialCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockClientTestimonialCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockClientTestimonialCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockClientTestimonialCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockImageCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockImageCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockImageCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockImageCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockImageWithPartialOverlayCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockImageWithPartialOverlayCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockImageWithPartialOverlayCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<
        Array<InputMaybe<ImageWrapperLinkingCollectionsBlockImageWithPartialOverlayCursorCollectionOrder>>
    >;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockLogoCarouselCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockLogoCarouselCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockLogoCarouselCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockLogoCarouselCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockLogoGridCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockLogoGridCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockLogoGridCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockLogoGridCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockPageIntroCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockPageIntroCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockPageIntroCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockPageIntroCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockPageSectionCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockPageSectionCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsBlockPageSectionCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsBlockPageSectionCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPagePersonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPagePersonCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPagePersonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPagePersonCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPersonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPersonCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsPersonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsPersonCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageWrapperLinkingCollectionsTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperLinkingCollectionsTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ImageWrapperLinkingCollectionsAccordionContentItemCollectionOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsAccordionContentItemCursorCollectionOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockClientTestimonialCollectionOrder {
    AuthorNameAsc = 'authorName_ASC',
    AuthorNameDesc = 'authorName_DESC',
    AuthorTitleAsc = 'authorTitle_ASC',
    AuthorTitleDesc = 'authorTitle_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockClientTestimonialCursorCollectionOrder {
    AuthorNameAsc = 'authorName_ASC',
    AuthorNameDesc = 'authorName_DESC',
    AuthorTitleAsc = 'authorTitle_ASC',
    AuthorTitleDesc = 'authorTitle_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockImageCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsFullBleedAsc = 'isFullBleed_ASC',
    IsFullBleedDesc = 'isFullBleed_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockImageCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsFullBleedAsc = 'isFullBleed_ASC',
    IsFullBleedDesc = 'isFullBleed_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockImageWithPartialOverlayCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockImageWithPartialOverlayCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockLogoCarouselCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockLogoCarouselCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockLogoGridCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsFullBleedAsc = 'isFullBleed_ASC',
    IsFullBleedDesc = 'isFullBleed_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockLogoGridCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsFullBleedAsc = 'isFullBleed_ASC',
    IsFullBleedDesc = 'isFullBleed_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockPageIntroCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockPageIntroCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockPageSectionCollectionOrder {
    ImagePlacementAsc = 'imagePlacement_ASC',
    ImagePlacementDesc = 'imagePlacement_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsBlockPageSectionCursorCollectionOrder {
    ImagePlacementAsc = 'imagePlacement_ASC',
    ImagePlacementDesc = 'imagePlacement_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum ImageWrapperLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum ImageWrapperLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageWrapperLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageWrapperLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum ImageWrapperLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum ImageWrapperLinkingCollectionsPagePersonCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageWrapperLinkingCollectionsPagePersonCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageWrapperLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageWrapperLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageWrapperLinkingCollectionsPersonCollectionOrder {
    EmailAsc = 'email_ASC',
    EmailDesc = 'email_DESC',
    FirstNameAsc = 'firstName_ASC',
    FirstNameDesc = 'firstName_DESC',
    JobTitleAsc = 'jobTitle_ASC',
    JobTitleDesc = 'jobTitle_DESC',
    LastNameAsc = 'lastName_ASC',
    LastNameDesc = 'lastName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsPersonCursorCollectionOrder {
    EmailAsc = 'email_ASC',
    EmailDesc = 'email_DESC',
    FirstNameAsc = 'firstName_ASC',
    FirstNameDesc = 'firstName_DESC',
    JobTitleAsc = 'jobTitle_ASC',
    JobTitleDesc = 'jobTitle_DESC',
    LastNameAsc = 'lastName_ASC',
    LastNameDesc = 'lastName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ImageWrapperLinkingCollectionsTechnologyCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TechnologySummaryAsc = 'technologySummary_ASC',
    TechnologySummaryDesc = 'technologySummary_DESC',
    TechnologyTypeAsc = 'technologyType_ASC',
    TechnologyTypeDesc = 'technologyType_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageWrapperLinkingCollectionsTechnologyCursorCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TechnologySummaryAsc = 'technologySummary_ASC',
    TechnologySummaryDesc = 'technologySummary_DESC',
    TechnologyTypeAsc = 'technologyType_ASC',
    TechnologyTypeDesc = 'technologyType_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ImageWrapperOrder {
    AltTextAsc = 'altText_ASC',
    AltTextDesc = 'altText_DESC',
    DescriptionAsc = 'description_ASC',
    DescriptionDesc = 'description_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/industry) */
export type Industry = Entry &
    _Node & {
        __typename?: 'Industry';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<IndustryLinkingCollections>;
        name?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/industry) */
export type IndustryInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/industry) */
export type IndustryLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/industry) */
export type IndustryNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndustryCollection = {
    __typename?: 'IndustryCollection';
    items: Array<Maybe<Industry>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type IndustryCursorCollection = {
    __typename?: 'IndustryCursorCollection';
    items: Array<Maybe<Industry>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type IndustryFilter = {
    AND?: InputMaybe<Array<InputMaybe<IndustryFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<IndustryFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    name?: InputMaybe<Scalars['String']['input']>;
    name_contains?: InputMaybe<Scalars['String']['input']>;
    name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    name_not?: InputMaybe<Scalars['String']['input']>;
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type IndustryLinkingCollections = {
    __typename?: 'IndustryLinkingCollections';
    blockSlideshowCollection?: Maybe<BlockSlideshowCollection>;
    blockSlideshowCursorCollection?: Maybe<BlockSlideshowCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    subIndustryCollection?: Maybe<SubIndustryCollection>;
    subIndustryCursorCollection?: Maybe<SubIndustryCursorCollection>;
};

export type IndustryLinkingCollectionsBlockSlideshowCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IndustryLinkingCollectionsBlockSlideshowCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndustryLinkingCollectionsBlockSlideshowCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IndustryLinkingCollectionsBlockSlideshowCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndustryLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndustryLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndustryLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IndustryLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndustryLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IndustryLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndustryLinkingCollectionsPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IndustryLinkingCollectionsPageIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndustryLinkingCollectionsPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IndustryLinkingCollectionsPageIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndustryLinkingCollectionsSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IndustryLinkingCollectionsSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndustryLinkingCollectionsSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IndustryLinkingCollectionsSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IndustryLinkingCollectionsBlockSlideshowCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum IndustryLinkingCollectionsBlockSlideshowCursorCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum IndustryLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum IndustryLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum IndustryLinkingCollectionsPageIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum IndustryLinkingCollectionsPageIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum IndustryLinkingCollectionsSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum IndustryLinkingCollectionsSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum IndustryOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/internalPageLink) */
export type InternalPageLink = Entry &
    _Node & {
        __typename?: 'InternalPageLink';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        linkPage?: Maybe<InternalPageLinkLinkPage>;
        linkText?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<InternalPageLinkLinkingCollections>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/internalPageLink) */
export type InternalPageLinkLinkPageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/internalPageLink) */
export type InternalPageLinkLinkTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/internalPageLink) */
export type InternalPageLinkLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InternalPageLinkCollection = {
    __typename?: 'InternalPageLinkCollection';
    items: Array<Maybe<InternalPageLink>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type InternalPageLinkCursorCollection = {
    __typename?: 'InternalPageLinkCursorCollection';
    items: Array<Maybe<InternalPageLink>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type InternalPageLinkFilter = {
    AND?: InputMaybe<Array<InputMaybe<InternalPageLinkFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<InternalPageLinkFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    linkPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkText?: InputMaybe<Scalars['String']['input']>;
    linkText_contains?: InputMaybe<Scalars['String']['input']>;
    linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkText_not?: InputMaybe<Scalars['String']['input']>;
    linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
    linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type InternalPageLinkLinkPage =
    | PageCaseStudy
    | PageCompany
    | PageIndustry
    | PageJournal
    | PageLanding
    | PagePerson
    | PageService
    | PageTechnology;

export type InternalPageLinkLinkingCollections = {
    __typename?: 'InternalPageLinkLinkingCollections';
    blockPageSectionCollection?: Maybe<BlockPageSectionCollection>;
    blockPageSectionCursorCollection?: Maybe<BlockPageSectionCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    factCollection?: Maybe<FactCollection>;
    factCursorCollection?: Maybe<FactCursorCollection>;
    navSectionCollection?: Maybe<NavSectionCollection>;
    navSectionCursorCollection?: Maybe<NavSectionCursorCollection>;
};

export type InternalPageLinkLinkingCollectionsBlockPageSectionCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<InternalPageLinkLinkingCollectionsBlockPageSectionCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InternalPageLinkLinkingCollectionsBlockPageSectionCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<InternalPageLinkLinkingCollectionsBlockPageSectionCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InternalPageLinkLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InternalPageLinkLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InternalPageLinkLinkingCollectionsFactCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<InternalPageLinkLinkingCollectionsFactCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InternalPageLinkLinkingCollectionsFactCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<InternalPageLinkLinkingCollectionsFactCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InternalPageLinkLinkingCollectionsNavSectionCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<InternalPageLinkLinkingCollectionsNavSectionCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InternalPageLinkLinkingCollectionsNavSectionCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<InternalPageLinkLinkingCollectionsNavSectionCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InternalPageLinkLinkingCollectionsBlockPageSectionCollectionOrder {
    ImagePlacementAsc = 'imagePlacement_ASC',
    ImagePlacementDesc = 'imagePlacement_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum InternalPageLinkLinkingCollectionsBlockPageSectionCursorCollectionOrder {
    ImagePlacementAsc = 'imagePlacement_ASC',
    ImagePlacementDesc = 'imagePlacement_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum InternalPageLinkLinkingCollectionsFactCollectionOrder {
    HeaderAsc = 'header_ASC',
    HeaderDesc = 'header_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum InternalPageLinkLinkingCollectionsFactCursorCollectionOrder {
    HeaderAsc = 'header_ASC',
    HeaderDesc = 'header_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum InternalPageLinkLinkingCollectionsNavSectionCollectionOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    JustLinkAsc = 'justLink_ASC',
    JustLinkDesc = 'justLink_DESC',
    LinkList1OverlineAsc = 'linkList1Overline_ASC',
    LinkList1OverlineDesc = 'linkList1Overline_DESC',
    LinkList2OverlineAsc = 'linkList2Overline_ASC',
    LinkList2OverlineDesc = 'linkList2Overline_DESC',
    MainLinkDescriptionAsc = 'mainLinkDescription_ASC',
    MainLinkDescriptionDesc = 'mainLinkDescription_DESC',
    ShowEntryAsc = 'showEntry_ASC',
    ShowEntryDesc = 'showEntry_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum InternalPageLinkLinkingCollectionsNavSectionCursorCollectionOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    JustLinkAsc = 'justLink_ASC',
    JustLinkDesc = 'justLink_DESC',
    LinkList1OverlineAsc = 'linkList1Overline_ASC',
    LinkList1OverlineDesc = 'linkList1Overline_DESC',
    LinkList2OverlineAsc = 'linkList2Overline_ASC',
    LinkList2OverlineDesc = 'linkList2Overline_DESC',
    MainLinkDescriptionAsc = 'mainLinkDescription_ASC',
    MainLinkDescriptionDesc = 'mainLinkDescription_DESC',
    ShowEntryAsc = 'showEntry_ASC',
    ShowEntryDesc = 'showEntry_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum InternalPageLinkOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/landingPage) */
export type LandingPage = Entry &
    _Node & {
        __typename?: 'LandingPage';
        _id: Scalars['ID']['output'];
        componentSettings?: Maybe<Scalars['JSON']['output']>;
        componentTree?: Maybe<Scalars['JSON']['output']>;
        contentfulMetadata: ContentfulMetadata;
        dataSource?: Maybe<Scalars['JSON']['output']>;
        linkedFrom?: Maybe<LandingPageLinkingCollections>;
        slug?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
        unboundValues?: Maybe<Scalars['JSON']['output']>;
        usedComponentsCollection?: Maybe<LandingPageUsedComponentsCollection>;
        usedComponentsCursorCollection?: Maybe<LandingPageUsedComponentsCursorCollection>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/landingPage) */
export type LandingPageComponentSettingsArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/landingPage) */
export type LandingPageComponentTreeArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/landingPage) */
export type LandingPageDataSourceArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/landingPage) */
export type LandingPageLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/landingPage) */
export type LandingPageSlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/landingPage) */
export type LandingPageTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/landingPage) */
export type LandingPageUnboundValuesArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/landingPage) */
export type LandingPageUsedComponentsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<LandingPageUsedComponentsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<LandingPageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/landingPage) */
export type LandingPageUsedComponentsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<LandingPageUsedComponentsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<LandingPageFilter>;
};

export type LandingPageCollection = {
    __typename?: 'LandingPageCollection';
    items: Array<Maybe<LandingPage>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type LandingPageCursorCollection = {
    __typename?: 'LandingPageCursorCollection';
    items: Array<Maybe<LandingPage>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type LandingPageFilter = {
    AND?: InputMaybe<Array<InputMaybe<LandingPageFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<LandingPageFilter>>>;
    componentSettings_exists?: InputMaybe<Scalars['Boolean']['input']>;
    componentTree_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    dataSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    unboundValues_exists?: InputMaybe<Scalars['Boolean']['input']>;
    usedComponents?: InputMaybe<CfLandingPageNestedFilter>;
    usedComponentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LandingPageLinkingCollections = {
    __typename?: 'LandingPageLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    landingPageCollection?: Maybe<LandingPageCollection>;
    landingPageCursorCollection?: Maybe<LandingPageCursorCollection>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
};

export type LandingPageLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LandingPageLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LandingPageLinkingCollectionsLandingPageCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<LandingPageLinkingCollectionsLandingPageCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LandingPageLinkingCollectionsLandingPageCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<LandingPageLinkingCollectionsLandingPageCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LandingPageLinkingCollectionsPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<LandingPageLinkingCollectionsPageLandingCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LandingPageLinkingCollectionsPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<LandingPageLinkingCollectionsPageLandingCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LandingPageLinkingCollectionsLandingPageCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum LandingPageLinkingCollectionsLandingPageCursorCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum LandingPageLinkingCollectionsPageLandingCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum LandingPageLinkingCollectionsPageLandingCursorCollectionOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum LandingPageOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type LandingPageUsedComponentsCollection = {
    __typename?: 'LandingPageUsedComponentsCollection';
    items: Array<Maybe<LandingPage>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum LandingPageUsedComponentsCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type LandingPageUsedComponentsCursorCollection = {
    __typename?: 'LandingPageUsedComponentsCursorCollection';
    items: Array<Maybe<LandingPage>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum LandingPageUsedComponentsCursorCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nav) */
export type Nav = Entry &
    _Node & {
        __typename?: 'Nav';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        id?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<NavLinkingCollections>;
        navSectionsCollection?: Maybe<NavNavSectionsCollection>;
        navSectionsCursorCollection?: Maybe<NavNavSectionsCursorCollection>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nav) */
export type NavIdArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nav) */
export type NavInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nav) */
export type NavLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nav) */
export type NavNavSectionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavNavSectionsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NavSectionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nav) */
export type NavNavSectionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavNavSectionsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NavSectionFilter>;
};

export type NavCollection = {
    __typename?: 'NavCollection';
    items: Array<Maybe<Nav>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type NavCursorCollection = {
    __typename?: 'NavCursorCollection';
    items: Array<Maybe<Nav>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type NavFilter = {
    AND?: InputMaybe<Array<InputMaybe<NavFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<NavFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    id_contains?: InputMaybe<Scalars['String']['input']>;
    id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_not?: InputMaybe<Scalars['String']['input']>;
    id_not_contains?: InputMaybe<Scalars['String']['input']>;
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    navSections?: InputMaybe<CfNavSectionNestedFilter>;
    navSectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type NavLinkingCollections = {
    __typename?: 'NavLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type NavLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavNavSectionsCollection = {
    __typename?: 'NavNavSectionsCollection';
    items: Array<Maybe<NavSection>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum NavNavSectionsCollectionOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    JustLinkAsc = 'justLink_ASC',
    JustLinkDesc = 'justLink_DESC',
    LinkList1OverlineAsc = 'linkList1Overline_ASC',
    LinkList1OverlineDesc = 'linkList1Overline_DESC',
    LinkList2OverlineAsc = 'linkList2Overline_ASC',
    LinkList2OverlineDesc = 'linkList2Overline_DESC',
    MainLinkDescriptionAsc = 'mainLinkDescription_ASC',
    MainLinkDescriptionDesc = 'mainLinkDescription_DESC',
    ShowEntryAsc = 'showEntry_ASC',
    ShowEntryDesc = 'showEntry_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type NavNavSectionsCursorCollection = {
    __typename?: 'NavNavSectionsCursorCollection';
    items: Array<Maybe<NavSection>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum NavNavSectionsCursorCollectionOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    JustLinkAsc = 'justLink_ASC',
    JustLinkDesc = 'justLink_DESC',
    LinkList1OverlineAsc = 'linkList1Overline_ASC',
    LinkList1OverlineDesc = 'linkList1Overline_DESC',
    LinkList2OverlineAsc = 'linkList2Overline_ASC',
    LinkList2OverlineDesc = 'linkList2Overline_DESC',
    MainLinkDescriptionAsc = 'mainLinkDescription_ASC',
    MainLinkDescriptionDesc = 'mainLinkDescription_DESC',
    ShowEntryAsc = 'showEntry_ASC',
    ShowEntryDesc = 'showEntry_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NavOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSection = Entry &
    _Node & {
        __typename?: 'NavSection';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        id?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        justLink?: Maybe<Scalars['Boolean']['output']>;
        linkList1Collection?: Maybe<NavSectionLinkList1Collection>;
        linkList1CursorCollection?: Maybe<NavSectionLinkList1CursorCollection>;
        linkList1Overline?: Maybe<Scalars['String']['output']>;
        linkList2Collection?: Maybe<NavSectionLinkList2Collection>;
        linkList2CursorCollection?: Maybe<NavSectionLinkList2CursorCollection>;
        linkList2Overline?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<NavSectionLinkingCollections>;
        mainLinkDescription?: Maybe<Scalars['String']['output']>;
        mainPageLink?: Maybe<InternalPageLink>;
        showEntry?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionIdArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionJustLinkArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionLinkList1CollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavSectionLinkList1CollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<InternalPageLinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionLinkList1CursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavSectionLinkList1CursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<InternalPageLinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionLinkList1OverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionLinkList2CollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavSectionLinkList2CollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<InternalPageLinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionLinkList2CursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavSectionLinkList2CursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<InternalPageLinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionLinkList2OverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionMainLinkDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionMainPageLinkArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<InternalPageLinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/navSection) */
export type NavSectionShowEntryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavSectionCollection = {
    __typename?: 'NavSectionCollection';
    items: Array<Maybe<NavSection>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type NavSectionCursorCollection = {
    __typename?: 'NavSectionCursorCollection';
    items: Array<Maybe<NavSection>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type NavSectionFilter = {
    AND?: InputMaybe<Array<InputMaybe<NavSectionFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<NavSectionFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    id_contains?: InputMaybe<Scalars['String']['input']>;
    id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_not?: InputMaybe<Scalars['String']['input']>;
    id_not_contains?: InputMaybe<Scalars['String']['input']>;
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    justLink?: InputMaybe<Scalars['Boolean']['input']>;
    justLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
    justLink_not?: InputMaybe<Scalars['Boolean']['input']>;
    linkList1?: InputMaybe<CfInternalPageLinkNestedFilter>;
    linkList1Collection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkList1Overline?: InputMaybe<Scalars['String']['input']>;
    linkList1Overline_contains?: InputMaybe<Scalars['String']['input']>;
    linkList1Overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkList1Overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkList1Overline_not?: InputMaybe<Scalars['String']['input']>;
    linkList1Overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    linkList1Overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkList2?: InputMaybe<CfInternalPageLinkNestedFilter>;
    linkList2Collection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkList2Overline?: InputMaybe<Scalars['String']['input']>;
    linkList2Overline_contains?: InputMaybe<Scalars['String']['input']>;
    linkList2Overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkList2Overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkList2Overline_not?: InputMaybe<Scalars['String']['input']>;
    linkList2Overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    linkList2Overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    mainLinkDescription?: InputMaybe<Scalars['String']['input']>;
    mainLinkDescription_contains?: InputMaybe<Scalars['String']['input']>;
    mainLinkDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    mainLinkDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    mainLinkDescription_not?: InputMaybe<Scalars['String']['input']>;
    mainLinkDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    mainLinkDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    mainPageLink?: InputMaybe<CfInternalPageLinkNestedFilter>;
    mainPageLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
    showEntry?: InputMaybe<Scalars['String']['input']>;
    showEntry_contains?: InputMaybe<Scalars['String']['input']>;
    showEntry_exists?: InputMaybe<Scalars['Boolean']['input']>;
    showEntry_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    showEntry_not?: InputMaybe<Scalars['String']['input']>;
    showEntry_not_contains?: InputMaybe<Scalars['String']['input']>;
    showEntry_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type NavSectionLinkList1Collection = {
    __typename?: 'NavSectionLinkList1Collection';
    items: Array<Maybe<InternalPageLink>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum NavSectionLinkList1CollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type NavSectionLinkList1CursorCollection = {
    __typename?: 'NavSectionLinkList1CursorCollection';
    items: Array<Maybe<InternalPageLink>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum NavSectionLinkList1CursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type NavSectionLinkList2Collection = {
    __typename?: 'NavSectionLinkList2Collection';
    items: Array<Maybe<InternalPageLink>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum NavSectionLinkList2CollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type NavSectionLinkList2CursorCollection = {
    __typename?: 'NavSectionLinkList2CursorCollection';
    items: Array<Maybe<InternalPageLink>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum NavSectionLinkList2CursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type NavSectionLinkingCollections = {
    __typename?: 'NavSectionLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    navCollection?: Maybe<NavCollection>;
    navCursorCollection?: Maybe<NavCursorCollection>;
};

export type NavSectionLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavSectionLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavSectionLinkingCollectionsNavCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavSectionLinkingCollectionsNavCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavSectionLinkingCollectionsNavCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavSectionLinkingCollectionsNavCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NavSectionLinkingCollectionsNavCollectionOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NavSectionLinkingCollectionsNavCursorCollectionOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NavSectionOrder {
    IdAsc = 'id_ASC',
    IdDesc = 'id_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    JustLinkAsc = 'justLink_ASC',
    JustLinkDesc = 'justLink_DESC',
    LinkList1OverlineAsc = 'linkList1Overline_ASC',
    LinkList1OverlineDesc = 'linkList1Overline_DESC',
    LinkList2OverlineAsc = 'linkList2Overline_ASC',
    LinkList2OverlineDesc = 'linkList2Overline_DESC',
    MainLinkDescriptionAsc = 'mainLinkDescription_ASC',
    MainLinkDescriptionDesc = 'mainLinkDescription_DESC',
    ShowEntryAsc = 'showEntry_ASC',
    ShowEntryDesc = 'showEntry_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_audience) */
export type NtAudience = Entry &
    _Node & {
        __typename?: 'NtAudience';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        linkedFrom?: Maybe<NtAudienceLinkingCollections>;
        ntAudienceId?: Maybe<Scalars['String']['output']>;
        ntDescription?: Maybe<Scalars['String']['output']>;
        ntMetadata?: Maybe<Scalars['JSON']['output']>;
        ntName?: Maybe<Scalars['String']['output']>;
        ntRules?: Maybe<Scalars['JSON']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_audience) */
export type NtAudienceLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_audience) */
export type NtAudienceNtAudienceIdArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_audience) */
export type NtAudienceNtDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_audience) */
export type NtAudienceNtMetadataArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_audience) */
export type NtAudienceNtNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_audience) */
export type NtAudienceNtRulesArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtAudienceCollection = {
    __typename?: 'NtAudienceCollection';
    items: Array<Maybe<NtAudience>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type NtAudienceCursorCollection = {
    __typename?: 'NtAudienceCursorCollection';
    items: Array<Maybe<NtAudience>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type NtAudienceFilter = {
    AND?: InputMaybe<Array<InputMaybe<NtAudienceFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<NtAudienceFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    nt_audience_id?: InputMaybe<Scalars['String']['input']>;
    nt_audience_id_contains?: InputMaybe<Scalars['String']['input']>;
    nt_audience_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_audience_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_audience_id_not?: InputMaybe<Scalars['String']['input']>;
    nt_audience_id_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_audience_id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_description?: InputMaybe<Scalars['String']['input']>;
    nt_description_contains?: InputMaybe<Scalars['String']['input']>;
    nt_description_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_description_not?: InputMaybe<Scalars['String']['input']>;
    nt_description_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_metadata_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_name?: InputMaybe<Scalars['String']['input']>;
    nt_name_contains?: InputMaybe<Scalars['String']['input']>;
    nt_name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_name_not?: InputMaybe<Scalars['String']['input']>;
    nt_name_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_rules_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type NtAudienceLinkingCollections = {
    __typename?: 'NtAudienceLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    ntExperienceCollection?: Maybe<NtExperienceCollection>;
    ntExperienceCursorCollection?: Maybe<NtExperienceCursorCollection>;
};

export type NtAudienceLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtAudienceLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtAudienceLinkingCollectionsNtExperienceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtAudienceLinkingCollectionsNtExperienceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtAudienceLinkingCollectionsNtExperienceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtAudienceLinkingCollectionsNtExperienceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NtAudienceLinkingCollectionsNtExperienceCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NtAudienceLinkingCollectionsNtExperienceCursorCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NtAudienceOrder {
    NtAudienceIdAsc = 'nt_audience_id_ASC',
    NtAudienceIdDesc = 'nt_audience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperience = Entry &
    _Node & {
        __typename?: 'NtExperience';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        linkedFrom?: Maybe<NtExperienceLinkingCollections>;
        ntAudience?: Maybe<NtAudience>;
        ntConfig?: Maybe<Scalars['JSON']['output']>;
        ntDescription?: Maybe<Scalars['String']['output']>;
        ntExperienceId?: Maybe<Scalars['String']['output']>;
        ntMetadata?: Maybe<Scalars['JSON']['output']>;
        ntName?: Maybe<Scalars['String']['output']>;
        ntType?: Maybe<Scalars['String']['output']>;
        ntVariantsCollection?: Maybe<NtExperienceNt_VariantsCollection>;
        ntVariantsCursorCollection?: Maybe<NtExperienceNt_VariantsCursorCollection>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperienceLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperienceNtAudienceArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtAudienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperienceNtConfigArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperienceNtDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperienceNtExperienceIdArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperienceNtMetadataArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperienceNtNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperienceNtTypeArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperienceNtVariantsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_experience) */
export type NtExperienceNtVariantsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceCollection = {
    __typename?: 'NtExperienceCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type NtExperienceCursorCollection = {
    __typename?: 'NtExperienceCursorCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type NtExperienceFilter = {
    AND?: InputMaybe<Array<InputMaybe<NtExperienceFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<NtExperienceFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    nt_audience?: InputMaybe<CfNtAudienceNestedFilter>;
    nt_audience_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_config_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_description?: InputMaybe<Scalars['String']['input']>;
    nt_description_contains?: InputMaybe<Scalars['String']['input']>;
    nt_description_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_description_not?: InputMaybe<Scalars['String']['input']>;
    nt_description_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experience_id?: InputMaybe<Scalars['String']['input']>;
    nt_experience_id_contains?: InputMaybe<Scalars['String']['input']>;
    nt_experience_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_experience_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experience_id_not?: InputMaybe<Scalars['String']['input']>;
    nt_experience_id_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_experience_id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_metadata_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_name?: InputMaybe<Scalars['String']['input']>;
    nt_name_contains?: InputMaybe<Scalars['String']['input']>;
    nt_name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_name_not?: InputMaybe<Scalars['String']['input']>;
    nt_name_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_type?: InputMaybe<Scalars['String']['input']>;
    nt_type_contains?: InputMaybe<Scalars['String']['input']>;
    nt_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_type_not?: InputMaybe<Scalars['String']['input']>;
    nt_type_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_variantsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type NtExperienceLinkingCollections = {
    __typename?: 'NtExperienceLinkingCollections';
    blockPageIntroCollection?: Maybe<BlockPageIntroCollection>;
    blockPageIntroCursorCollection?: Maybe<BlockPageIntroCursorCollection>;
    buttonCollection?: Maybe<ButtonCollection>;
    buttonCursorCollection?: Maybe<ButtonCursorCollection>;
    ctaSimpleCollection?: Maybe<CtaSimpleCollection>;
    ctaSimpleCursorCollection?: Maybe<CtaSimpleCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
};

export type NtExperienceLinkingCollectionsBlockPageIntroCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsBlockPageIntroCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsBlockPageIntroCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsBlockPageIntroCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsButtonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsButtonCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsButtonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsButtonCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsCtaSimpleCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsCtaSimpleCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsCtaSimpleCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsCtaSimpleCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsPageExpertiseCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsPageExpertiseCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtExperienceLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NtExperienceLinkingCollectionsBlockPageIntroCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NtExperienceLinkingCollectionsBlockPageIntroCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NtExperienceLinkingCollectionsButtonCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NtExperienceLinkingCollectionsButtonCursorCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NtExperienceLinkingCollectionsCtaSimpleCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NtExperienceLinkingCollectionsCtaSimpleCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum NtExperienceLinkingCollectionsPageExpertiseCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum NtExperienceLinkingCollectionsPageExpertiseCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum NtExperienceLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum NtExperienceLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum NtExperienceLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum NtExperienceLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type NtExperienceNt_VariantsCollection = {
    __typename?: 'NtExperienceNt_variantsCollection';
    items: Array<Maybe<Entry>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type NtExperienceNt_VariantsCursorCollection = {
    __typename?: 'NtExperienceNt_variantsCursorCollection';
    items: Array<Maybe<Entry>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum NtExperienceOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_mergetag) */
export type NtMergetag = Entry &
    _Node & {
        __typename?: 'NtMergetag';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        linkedFrom?: Maybe<NtMergetagLinkingCollections>;
        ntFallback?: Maybe<Scalars['String']['output']>;
        ntMergetagId?: Maybe<Scalars['String']['output']>;
        ntName?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_mergetag) */
export type NtMergetagLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_mergetag) */
export type NtMergetagNtFallbackArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_mergetag) */
export type NtMergetagNtMergetagIdArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/nt_mergetag) */
export type NtMergetagNtNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtMergetagCollection = {
    __typename?: 'NtMergetagCollection';
    items: Array<Maybe<NtMergetag>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type NtMergetagCursorCollection = {
    __typename?: 'NtMergetagCursorCollection';
    items: Array<Maybe<NtMergetag>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type NtMergetagFilter = {
    AND?: InputMaybe<Array<InputMaybe<NtMergetagFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<NtMergetagFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    nt_fallback?: InputMaybe<Scalars['String']['input']>;
    nt_fallback_contains?: InputMaybe<Scalars['String']['input']>;
    nt_fallback_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_fallback_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_fallback_not?: InputMaybe<Scalars['String']['input']>;
    nt_fallback_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_fallback_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_mergetag_id?: InputMaybe<Scalars['String']['input']>;
    nt_mergetag_id_contains?: InputMaybe<Scalars['String']['input']>;
    nt_mergetag_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_mergetag_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_mergetag_id_not?: InputMaybe<Scalars['String']['input']>;
    nt_mergetag_id_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_mergetag_id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_name?: InputMaybe<Scalars['String']['input']>;
    nt_name_contains?: InputMaybe<Scalars['String']['input']>;
    nt_name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_name_not?: InputMaybe<Scalars['String']['input']>;
    nt_name_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type NtMergetagLinkingCollections = {
    __typename?: 'NtMergetagLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type NtMergetagLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NtMergetagLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NtMergetagOrder {
    NtFallbackAsc = 'nt_fallback_ASC',
    NtFallbackDesc = 'nt_fallback_DESC',
    NtMergetagIdAsc = 'nt_mergetag_id_ASC',
    NtMergetagIdDesc = 'nt_mergetag_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudy = Entry &
    _Node & {
        __typename?: 'PageCaseStudy';
        _id: Scalars['ID']['output'];
        approach?: Maybe<Scalars['String']['output']>;
        challenge?: Maybe<Scalars['String']['output']>;
        client?: Maybe<Client>;
        clientIntroductionBody?: Maybe<Scalars['String']['output']>;
        clientIntroductionHeader?: Maybe<Scalars['String']['output']>;
        clientIntroductionImage?: Maybe<ImageWrapper>;
        contentfulMetadata: ContentfulMetadata;
        featured?: Maybe<Scalars['Boolean']['output']>;
        heroImage?: Maybe<ImageWrapper>;
        industriesCollection?: Maybe<PageCaseStudyIndustriesCollection>;
        industriesCursorCollection?: Maybe<PageCaseStudyIndustriesCursorCollection>;
        internalName?: Maybe<Scalars['String']['output']>;
        isSnapshot?: Maybe<Scalars['Boolean']['output']>;
        linkedFrom?: Maybe<PageCaseStudyLinkingCollections>;
        listImage?: Maybe<ImageWrapper>;
        outcome?: Maybe<Scalars['String']['output']>;
        publishDate?: Maybe<Scalars['DateTime']['output']>;
        sectionsCollection?: Maybe<PageCaseStudySectionsCollection>;
        sectionsCursorCollection?: Maybe<PageCaseStudySectionsCursorCollection>;
        seoDescription?: Maybe<Scalars['String']['output']>;
        seoTitle?: Maybe<Scalars['String']['output']>;
        servicesCollection?: Maybe<PageCaseStudyServicesCollection>;
        servicesCursorCollection?: Maybe<PageCaseStudyServicesCursorCollection>;
        slideshowPage?: Maybe<PageCaseStudySlideshowPage>;
        slug?: Maybe<Scalars['String']['output']>;
        solutionsCollection?: Maybe<PageCaseStudySolutionsCollection>;
        solutionsCursorCollection?: Maybe<PageCaseStudySolutionsCursorCollection>;
        summary?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        technologiesCollection?: Maybe<PageCaseStudyTechnologiesCollection>;
        technologiesCursorCollection?: Maybe<PageCaseStudyTechnologiesCursorCollection>;
        title?: Maybe<Scalars['String']['output']>;
        year?: Maybe<Scalars['Int']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyApproachArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyChallengeArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyClientArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ClientFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyClientIntroductionBodyArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyClientIntroductionHeaderArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyClientIntroductionImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyFeaturedArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyHeroImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyIndustriesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyIndustriesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IndustryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyIndustriesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyIndustriesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IndustryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyIsSnapshotArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyListImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyOutcomeArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyPublishDateArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudySectionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageCaseStudySectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudySectionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageCaseStudySectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudySeoDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudySeoTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyServicesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyServicesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ServiceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyServicesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyServicesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ServiceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudySlideshowPageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudySlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudySolutionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudySolutionsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SolutionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudySolutionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudySolutionsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SolutionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudySummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyTechnologiesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyTechnologiesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TechnologyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyTechnologiesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyTechnologiesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TechnologyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCaseStudy) */
export type PageCaseStudyYearArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyCollection = {
    __typename?: 'PageCaseStudyCollection';
    items: Array<Maybe<PageCaseStudy>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageCaseStudyCursorCollection = {
    __typename?: 'PageCaseStudyCursorCollection';
    items: Array<Maybe<PageCaseStudy>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageCaseStudyFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageCaseStudyFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageCaseStudyFilter>>>;
    approach?: InputMaybe<Scalars['String']['input']>;
    approach_contains?: InputMaybe<Scalars['String']['input']>;
    approach_exists?: InputMaybe<Scalars['Boolean']['input']>;
    approach_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    approach_not?: InputMaybe<Scalars['String']['input']>;
    approach_not_contains?: InputMaybe<Scalars['String']['input']>;
    approach_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    challenge?: InputMaybe<Scalars['String']['input']>;
    challenge_contains?: InputMaybe<Scalars['String']['input']>;
    challenge_exists?: InputMaybe<Scalars['Boolean']['input']>;
    challenge_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    challenge_not?: InputMaybe<Scalars['String']['input']>;
    challenge_not_contains?: InputMaybe<Scalars['String']['input']>;
    challenge_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    client?: InputMaybe<CfClientNestedFilter>;
    clientIntroductionBody?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionBody_contains?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionBody_exists?: InputMaybe<Scalars['Boolean']['input']>;
    clientIntroductionBody_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    clientIntroductionBody_not?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionBody_not_contains?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionBody_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    clientIntroductionHeader?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionHeader_contains?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
    clientIntroductionHeader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    clientIntroductionHeader_not?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionHeader_not_contains?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionHeader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    clientIntroductionImage?: InputMaybe<CfImageWrapperNestedFilter>;
    clientIntroductionImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    client_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    featured?: InputMaybe<Scalars['Boolean']['input']>;
    featured_exists?: InputMaybe<Scalars['Boolean']['input']>;
    featured_not?: InputMaybe<Scalars['Boolean']['input']>;
    heroImage?: InputMaybe<CfImageWrapperNestedFilter>;
    heroImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    industries?: InputMaybe<CfIndustryNestedFilter>;
    industriesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    isSnapshot?: InputMaybe<Scalars['Boolean']['input']>;
    isSnapshot_exists?: InputMaybe<Scalars['Boolean']['input']>;
    isSnapshot_not?: InputMaybe<Scalars['Boolean']['input']>;
    listImage?: InputMaybe<CfImageWrapperNestedFilter>;
    listImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    outcome?: InputMaybe<Scalars['String']['input']>;
    outcome_contains?: InputMaybe<Scalars['String']['input']>;
    outcome_exists?: InputMaybe<Scalars['Boolean']['input']>;
    outcome_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    outcome_not?: InputMaybe<Scalars['String']['input']>;
    outcome_not_contains?: InputMaybe<Scalars['String']['input']>;
    outcome_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    publishDate?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
    publishDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_not?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    sections?: InputMaybe<CfsectionsMultiTypeNestedFilter>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    services?: InputMaybe<CfServiceNestedFilter>;
    servicesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slideshowPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    solutions?: InputMaybe<CfSolutionNestedFilter>;
    solutionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    technologies?: InputMaybe<CfTechnologyNestedFilter>;
    technologiesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    year?: InputMaybe<Scalars['Int']['input']>;
    year_exists?: InputMaybe<Scalars['Boolean']['input']>;
    year_gt?: InputMaybe<Scalars['Int']['input']>;
    year_gte?: InputMaybe<Scalars['Int']['input']>;
    year_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    year_lt?: InputMaybe<Scalars['Int']['input']>;
    year_lte?: InputMaybe<Scalars['Int']['input']>;
    year_not?: InputMaybe<Scalars['Int']['input']>;
    year_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type PageCaseStudyIndustriesCollection = {
    __typename?: 'PageCaseStudyIndustriesCollection';
    items: Array<Maybe<Industry>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageCaseStudyIndustriesCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type PageCaseStudyIndustriesCursorCollection = {
    __typename?: 'PageCaseStudyIndustriesCursorCollection';
    items: Array<Maybe<Industry>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageCaseStudyIndustriesCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type PageCaseStudyLinkingCollections = {
    __typename?: 'PageCaseStudyLinkingCollections';
    blockFeaturedCaseStudiesCollection?: Maybe<BlockFeaturedCaseStudiesCollection>;
    blockFeaturedCaseStudiesCursorCollection?: Maybe<BlockFeaturedCaseStudiesCursorCollection>;
    blockSlideshowCollection?: Maybe<BlockSlideshowCollection>;
    blockSlideshowCursorCollection?: Maybe<BlockSlideshowCursorCollection>;
    buttonCollection?: Maybe<ButtonCollection>;
    buttonCursorCollection?: Maybe<ButtonCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    iconBlockCollection?: Maybe<IconBlockCollection>;
    iconBlockCursorCollection?: Maybe<IconBlockCursorCollection>;
    internalPageLinkCollection?: Maybe<InternalPageLinkCollection>;
    internalPageLinkCursorCollection?: Maybe<InternalPageLinkCursorCollection>;
};

export type PageCaseStudyLinkingCollectionsBlockFeaturedCaseStudiesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyLinkingCollectionsBlockFeaturedCaseStudiesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsBlockFeaturedCaseStudiesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyLinkingCollectionsBlockFeaturedCaseStudiesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsBlockSlideshowCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyLinkingCollectionsBlockSlideshowCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsBlockSlideshowCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyLinkingCollectionsBlockSlideshowCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsButtonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyLinkingCollectionsButtonCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsButtonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyLinkingCollectionsButtonCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsIconBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyLinkingCollectionsIconBlockCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsIconBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyLinkingCollectionsIconBlockCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsInternalPageLinkCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyLinkingCollectionsInternalPageLinkCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCaseStudyLinkingCollectionsInternalPageLinkCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyLinkingCollectionsInternalPageLinkCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PageCaseStudyLinkingCollectionsBlockFeaturedCaseStudiesCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCaseStudyLinkingCollectionsBlockFeaturedCaseStudiesCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCaseStudyLinkingCollectionsBlockSlideshowCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCaseStudyLinkingCollectionsBlockSlideshowCursorCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCaseStudyLinkingCollectionsButtonCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCaseStudyLinkingCollectionsButtonCursorCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCaseStudyLinkingCollectionsIconBlockCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCaseStudyLinkingCollectionsIconBlockCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCaseStudyLinkingCollectionsInternalPageLinkCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCaseStudyLinkingCollectionsInternalPageLinkCursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCaseStudyOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export type PageCaseStudySectionsCollection = {
    __typename?: 'PageCaseStudySectionsCollection';
    items: Array<Maybe<PageCaseStudySectionsItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageCaseStudySectionsCursorCollection = {
    __typename?: 'PageCaseStudySectionsCursorCollection';
    items: Array<Maybe<PageCaseStudySectionsItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageCaseStudySectionsFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageCaseStudySectionsFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageCaseStudySectionsFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type PageCaseStudySectionsItem =
    | BlockClientTestimonial
    | BlockDarkCircleBackground
    | BlockFeaturedCaseStudies
    | BlockIconBlocks
    | BlockImage
    | BlockImageWithPartialOverlay
    | BlockIndustryBlocks
    | BlockLogoGrid
    | BlockNumberedBlocks
    | BlockPageSection
    | BlockPeopleList
    | BlockSlideshow
    | BlockTechnologyBlocks
    | CtaSimple;

export type PageCaseStudyServicesCollection = {
    __typename?: 'PageCaseStudyServicesCollection';
    items: Array<Maybe<Service>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageCaseStudyServicesCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageCaseStudyServicesCursorCollection = {
    __typename?: 'PageCaseStudyServicesCursorCollection';
    items: Array<Maybe<Service>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageCaseStudyServicesCursorCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageCaseStudySlideshowPage = Service | Solution | Technology;

export type PageCaseStudySolutionsCollection = {
    __typename?: 'PageCaseStudySolutionsCollection';
    items: Array<Maybe<Solution>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageCaseStudySolutionsCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageCaseStudySolutionsCursorCollection = {
    __typename?: 'PageCaseStudySolutionsCursorCollection';
    items: Array<Maybe<Solution>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageCaseStudySolutionsCursorCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageCaseStudyTechnologiesCollection = {
    __typename?: 'PageCaseStudyTechnologiesCollection';
    items: Array<Maybe<Technology>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageCaseStudyTechnologiesCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TechnologySummaryAsc = 'technologySummary_ASC',
    TechnologySummaryDesc = 'technologySummary_DESC',
    TechnologyTypeAsc = 'technologyType_ASC',
    TechnologyTypeDesc = 'technologyType_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageCaseStudyTechnologiesCursorCollection = {
    __typename?: 'PageCaseStudyTechnologiesCursorCollection';
    items: Array<Maybe<Technology>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageCaseStudyTechnologiesCursorCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TechnologySummaryAsc = 'technologySummary_ASC',
    TechnologySummaryDesc = 'technologySummary_DESC',
    TechnologyTypeAsc = 'technologyType_ASC',
    TechnologyTypeDesc = 'technologyType_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompany = Entry &
    _Node & {
        __typename?: 'PageCompany';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<PageCompanyLinkingCollections>;
        pageIntro?: Maybe<BlockPageIntro>;
        sectionsCollection?: Maybe<PageCompanySectionsCollection>;
        sectionsCursorCollection?: Maybe<PageCompanySectionsCursorCollection>;
        seoDescription?: Maybe<Scalars['String']['output']>;
        seoTitle?: Maybe<Scalars['String']['output']>;
        slug?: Maybe<Scalars['String']['output']>;
        summary?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompanyInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompanyLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompanyPageIntroArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockPageIntroFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompanySectionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageCompanySectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompanySectionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageCompanySectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompanySeoDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompanySeoTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompanySlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompanySummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageCompany) */
export type PageCompanyTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCompanyCollection = {
    __typename?: 'PageCompanyCollection';
    items: Array<Maybe<PageCompany>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageCompanyCursorCollection = {
    __typename?: 'PageCompanyCursorCollection';
    items: Array<Maybe<PageCompany>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageCompanyFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageCompanyFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageCompanyFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    pageIntro?: InputMaybe<CfBlockPageIntroNestedFilter>;
    pageIntro_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sections?: InputMaybe<CfsectionsMultiTypeNestedFilter>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageCompanyLinkingCollections = {
    __typename?: 'PageCompanyLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    iconBlockCollection?: Maybe<IconBlockCollection>;
    iconBlockCursorCollection?: Maybe<IconBlockCursorCollection>;
    internalPageLinkCollection?: Maybe<InternalPageLinkCollection>;
    internalPageLinkCursorCollection?: Maybe<InternalPageLinkCursorCollection>;
};

export type PageCompanyLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCompanyLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCompanyLinkingCollectionsIconBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCompanyLinkingCollectionsIconBlockCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCompanyLinkingCollectionsIconBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCompanyLinkingCollectionsIconBlockCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCompanyLinkingCollectionsInternalPageLinkCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCompanyLinkingCollectionsInternalPageLinkCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCompanyLinkingCollectionsInternalPageLinkCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCompanyLinkingCollectionsInternalPageLinkCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PageCompanyLinkingCollectionsIconBlockCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCompanyLinkingCollectionsIconBlockCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCompanyLinkingCollectionsInternalPageLinkCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCompanyLinkingCollectionsInternalPageLinkCursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageCompanyOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageCompanySectionsCollection = {
    __typename?: 'PageCompanySectionsCollection';
    items: Array<Maybe<PageCompanySectionsItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageCompanySectionsCursorCollection = {
    __typename?: 'PageCompanySectionsCursorCollection';
    items: Array<Maybe<PageCompanySectionsItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageCompanySectionsFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageCompanySectionsFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageCompanySectionsFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type PageCompanySectionsItem =
    | BlockClientTestimonial
    | BlockDarkCircleBackground
    | BlockFeaturedCaseStudies
    | BlockIconBlocks
    | BlockImage
    | BlockImageWithPartialOverlay
    | BlockIndustryBlocks
    | BlockJobList
    | BlockLogoGrid
    | BlockNumberedBlocks
    | BlockPageSection
    | BlockPeopleList
    | BlockRichText
    | BlockSlideshow
    | BlockTechnologyBlocks
    | CtaSimple
    | Form;

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertise = Entry &
    _Node & {
        __typename?: 'PageExpertise';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        expertise?: Maybe<Expertise>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<PageExpertiseLinkingCollections>;
        ntExperiencesCollection?: Maybe<PageExpertiseNt_ExperiencesCollection>;
        ntExperiencesCursorCollection?: Maybe<PageExpertiseNt_ExperiencesCursorCollection>;
        sectionsCollection?: Maybe<PageExpertiseSectionsCollection>;
        sectionsCursorCollection?: Maybe<PageExpertiseSectionsCursorCollection>;
        seoDescription?: Maybe<Scalars['String']['output']>;
        seoTitle?: Maybe<Scalars['String']['output']>;
        slug?: Maybe<Scalars['String']['output']>;
        summary?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        tableOfContents?: Maybe<Scalars['JSON']['output']>;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseExpertiseArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ExpertiseFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseNtExperiencesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageExpertiseNt_ExperiencesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseNtExperiencesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageExpertiseNt_ExperiencesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseSectionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageExpertiseSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseSectionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageExpertiseSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseSeoDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseSeoTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseSlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseSummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseTableOfContentsArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageExpertise) */
export type PageExpertiseTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageExpertiseCollection = {
    __typename?: 'PageExpertiseCollection';
    items: Array<Maybe<PageExpertise>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageExpertiseCursorCollection = {
    __typename?: 'PageExpertiseCursorCollection';
    items: Array<Maybe<PageExpertise>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageExpertiseFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageExpertiseFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageExpertiseFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    expertise?: InputMaybe<CfExpertiseNestedFilter>;
    expertise_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experiences?: InputMaybe<CfNtExperienceNestedFilter>;
    nt_experiencesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sections?: InputMaybe<CfsectionsMultiTypeNestedFilter>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    tableOfContents_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageExpertiseLinkingCollections = {
    __typename?: 'PageExpertiseLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type PageExpertiseLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageExpertiseLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageExpertiseNt_ExperiencesCollection = {
    __typename?: 'PageExpertiseNt_experiencesCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageExpertiseNt_ExperiencesCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type PageExpertiseNt_ExperiencesCursorCollection = {
    __typename?: 'PageExpertiseNt_experiencesCursorCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageExpertiseNt_ExperiencesCursorCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageExpertiseOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageExpertiseSectionsCollection = {
    __typename?: 'PageExpertiseSectionsCollection';
    items: Array<Maybe<PageExpertiseSectionsItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageExpertiseSectionsCursorCollection = {
    __typename?: 'PageExpertiseSectionsCursorCollection';
    items: Array<Maybe<PageExpertiseSectionsItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageExpertiseSectionsFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageExpertiseSectionsFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageExpertiseSectionsFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type PageExpertiseSectionsItem =
    | BlockClientTestimonial
    | BlockDarkCircleBackground
    | BlockFeaturedCaseStudies
    | BlockIconBlocks
    | BlockImage
    | BlockImageWithPartialOverlay
    | BlockIndustryBlocks
    | BlockJobList
    | BlockLogoGrid
    | BlockNumberedBlocks
    | BlockPageSection
    | BlockPeopleList
    | BlockSlideshow
    | BlockTechnologyBlocks
    | CtaSimple;

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustry = Entry &
    _Node & {
        __typename?: 'PageIndustry';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        industry?: Maybe<Industry>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<PageIndustryLinkingCollections>;
        listImage?: Maybe<ImageWrapper>;
        sectionsCollection?: Maybe<PageIndustrySectionsCollection>;
        sectionsCursorCollection?: Maybe<PageIndustrySectionsCursorCollection>;
        seoDescription?: Maybe<Scalars['String']['output']>;
        seoTitle?: Maybe<Scalars['String']['output']>;
        slug?: Maybe<Scalars['String']['output']>;
        summary?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustryIndustryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IndustryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustryInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustryLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustryListImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustrySectionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageIndustrySectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustrySectionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageIndustrySectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustrySeoDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustrySeoTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustrySlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustrySummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageIndustry) */
export type PageIndustryTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageIndustryCollection = {
    __typename?: 'PageIndustryCollection';
    items: Array<Maybe<PageIndustry>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageIndustryCursorCollection = {
    __typename?: 'PageIndustryCursorCollection';
    items: Array<Maybe<PageIndustry>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageIndustryFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageIndustryFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageIndustryFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    industry?: InputMaybe<CfIndustryNestedFilter>;
    industry_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    listImage?: InputMaybe<CfImageWrapperNestedFilter>;
    listImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sections?: InputMaybe<CfsectionsMultiTypeNestedFilter>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageIndustryLinkingCollections = {
    __typename?: 'PageIndustryLinkingCollections';
    blockIndustryBlocksCollection?: Maybe<BlockIndustryBlocksCollection>;
    blockIndustryBlocksCursorCollection?: Maybe<BlockIndustryBlocksCursorCollection>;
    buttonCollection?: Maybe<ButtonCollection>;
    buttonCursorCollection?: Maybe<ButtonCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    iconBlockCollection?: Maybe<IconBlockCollection>;
    iconBlockCursorCollection?: Maybe<IconBlockCursorCollection>;
    internalPageLinkCollection?: Maybe<InternalPageLinkCollection>;
    internalPageLinkCursorCollection?: Maybe<InternalPageLinkCursorCollection>;
};

export type PageIndustryLinkingCollectionsBlockIndustryBlocksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageIndustryLinkingCollectionsBlockIndustryBlocksCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageIndustryLinkingCollectionsBlockIndustryBlocksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageIndustryLinkingCollectionsBlockIndustryBlocksCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageIndustryLinkingCollectionsButtonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageIndustryLinkingCollectionsButtonCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageIndustryLinkingCollectionsButtonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageIndustryLinkingCollectionsButtonCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageIndustryLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageIndustryLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageIndustryLinkingCollectionsIconBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageIndustryLinkingCollectionsIconBlockCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageIndustryLinkingCollectionsIconBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageIndustryLinkingCollectionsIconBlockCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageIndustryLinkingCollectionsInternalPageLinkCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageIndustryLinkingCollectionsInternalPageLinkCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageIndustryLinkingCollectionsInternalPageLinkCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageIndustryLinkingCollectionsInternalPageLinkCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PageIndustryLinkingCollectionsBlockIndustryBlocksCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageIndustryLinkingCollectionsBlockIndustryBlocksCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageIndustryLinkingCollectionsButtonCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageIndustryLinkingCollectionsButtonCursorCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageIndustryLinkingCollectionsIconBlockCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageIndustryLinkingCollectionsIconBlockCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageIndustryLinkingCollectionsInternalPageLinkCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageIndustryLinkingCollectionsInternalPageLinkCursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageIndustryOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageIndustrySectionsCollection = {
    __typename?: 'PageIndustrySectionsCollection';
    items: Array<Maybe<PageIndustrySectionsItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageIndustrySectionsCursorCollection = {
    __typename?: 'PageIndustrySectionsCursorCollection';
    items: Array<Maybe<PageIndustrySectionsItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageIndustrySectionsFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageIndustrySectionsFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageIndustrySectionsFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type PageIndustrySectionsItem =
    | BlockClientTestimonial
    | BlockDarkCircleBackground
    | BlockFeaturedCaseStudies
    | BlockIconBlocks
    | BlockImage
    | BlockImageWithPartialOverlay
    | BlockIndustryBlocks
    | BlockJobList
    | BlockLogoGrid
    | BlockNumberedBlocks
    | BlockPageSection
    | BlockPeopleList
    | BlockSlideshow
    | BlockTechnologyBlocks
    | CtaSimple;

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournal = Entry &
    _Node & {
        __typename?: 'PageJournal';
        _id: Scalars['ID']['output'];
        authorsCollection?: Maybe<PageJournalAuthorsCollection>;
        authorsCursorCollection?: Maybe<PageJournalAuthorsCursorCollection>;
        body?: Maybe<PageJournalBody>;
        companyTopicsCollection?: Maybe<PageJournalCompanyTopicsCollection>;
        companyTopicsCursorCollection?: Maybe<PageJournalCompanyTopicsCursorCollection>;
        contentfulMetadata: ContentfulMetadata;
        heroImage?: Maybe<ImageWrapper>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<PageJournalLinkingCollections>;
        ntExperiencesCollection?: Maybe<PageJournalNt_ExperiencesCollection>;
        ntExperiencesCursorCollection?: Maybe<PageJournalNt_ExperiencesCursorCollection>;
        publishDate?: Maybe<Scalars['DateTime']['output']>;
        sectionsCollection?: Maybe<PageJournalSectionsCollection>;
        sectionsCursorCollection?: Maybe<PageJournalSectionsCursorCollection>;
        seoDescription?: Maybe<Scalars['String']['output']>;
        seoTitle?: Maybe<Scalars['String']['output']>;
        servicesCollection?: Maybe<PageJournalServicesCollection>;
        servicesCursorCollection?: Maybe<PageJournalServicesCursorCollection>;
        slug?: Maybe<Scalars['String']['output']>;
        solutionsCollection?: Maybe<PageJournalSolutionsCollection>;
        solutionsCursorCollection?: Maybe<PageJournalSolutionsCursorCollection>;
        summary?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        technologiesCollection?: Maybe<PageJournalTechnologiesCollection>;
        technologiesCursorCollection?: Maybe<PageJournalTechnologiesCursorCollection>;
        title?: Maybe<Scalars['String']['output']>;
        updatedDate?: Maybe<Scalars['DateTime']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalAuthorsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalAuthorsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PagePersonFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalAuthorsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalAuthorsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PagePersonFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalBodyArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalCompanyTopicsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalCompanyTopicsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CompanyTopicFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalCompanyTopicsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalCompanyTopicsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CompanyTopicFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalHeroImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalNtExperiencesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalNt_ExperiencesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalNtExperiencesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalNt_ExperiencesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalPublishDateArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalSectionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageJournalSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalSectionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageJournalSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalSeoDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalSeoTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalServicesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalServicesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ServiceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalServicesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalServicesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ServiceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalSlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalSolutionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalSolutionsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SolutionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalSolutionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalSolutionsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SolutionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalSummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalTechnologiesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalTechnologiesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TechnologyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalTechnologiesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalTechnologiesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TechnologyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageJournal) */
export type PageJournalUpdatedDateArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageJournalAuthorsCollection = {
    __typename?: 'PageJournalAuthorsCollection';
    items: Array<Maybe<PagePerson>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageJournalAuthorsCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageJournalAuthorsCursorCollection = {
    __typename?: 'PageJournalAuthorsCursorCollection';
    items: Array<Maybe<PagePerson>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageJournalAuthorsCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageJournalBody = {
    __typename?: 'PageJournalBody';
    json: Scalars['JSON']['output'];
    links: PageJournalBodyLinks;
};

export type PageJournalBodyAssets = {
    __typename?: 'PageJournalBodyAssets';
    block: Array<Maybe<Asset>>;
    hyperlink: Array<Maybe<Asset>>;
};

export type PageJournalBodyEntries = {
    __typename?: 'PageJournalBodyEntries';
    block: Array<Maybe<Entry>>;
    hyperlink: Array<Maybe<Entry>>;
    inline: Array<Maybe<Entry>>;
};

export type PageJournalBodyLinks = {
    __typename?: 'PageJournalBodyLinks';
    assets: PageJournalBodyAssets;
    entries: PageJournalBodyEntries;
    resources: PageJournalBodyResources;
};

export type PageJournalBodyResources = {
    __typename?: 'PageJournalBodyResources';
    block: Array<PageJournalBodyResourcesBlock>;
    hyperlink: Array<PageJournalBodyResourcesHyperlink>;
    inline: Array<PageJournalBodyResourcesInline>;
};

export type PageJournalBodyResourcesBlock = ResourceLink & {
    __typename?: 'PageJournalBodyResourcesBlock';
    sys: ResourceSys;
};

export type PageJournalBodyResourcesHyperlink = ResourceLink & {
    __typename?: 'PageJournalBodyResourcesHyperlink';
    sys: ResourceSys;
};

export type PageJournalBodyResourcesInline = ResourceLink & {
    __typename?: 'PageJournalBodyResourcesInline';
    sys: ResourceSys;
};

export type PageJournalCollection = {
    __typename?: 'PageJournalCollection';
    items: Array<Maybe<PageJournal>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageJournalCompanyTopicsCollection = {
    __typename?: 'PageJournalCompanyTopicsCollection';
    items: Array<Maybe<CompanyTopic>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageJournalCompanyTopicsCollectionOrder {
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageJournalCompanyTopicsCursorCollection = {
    __typename?: 'PageJournalCompanyTopicsCursorCollection';
    items: Array<Maybe<CompanyTopic>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageJournalCompanyTopicsCursorCollectionOrder {
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageJournalCursorCollection = {
    __typename?: 'PageJournalCursorCollection';
    items: Array<Maybe<PageJournal>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageJournalFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageJournalFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageJournalFilter>>>;
    authors?: InputMaybe<CfPagePersonNestedFilter>;
    authorsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    body_contains?: InputMaybe<Scalars['String']['input']>;
    body_exists?: InputMaybe<Scalars['Boolean']['input']>;
    body_not_contains?: InputMaybe<Scalars['String']['input']>;
    companyTopics?: InputMaybe<CfCompanyTopicNestedFilter>;
    companyTopicsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    heroImage?: InputMaybe<CfImageWrapperNestedFilter>;
    heroImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experiences?: InputMaybe<CfNtExperienceNestedFilter>;
    nt_experiencesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    publishDate?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
    publishDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_not?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    sections?: InputMaybe<CfsectionsMultiTypeNestedFilter>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    services?: InputMaybe<CfServiceNestedFilter>;
    servicesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    solutions?: InputMaybe<CfSolutionNestedFilter>;
    solutionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    technologies?: InputMaybe<CfTechnologyNestedFilter>;
    technologiesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    updatedDate?: InputMaybe<Scalars['DateTime']['input']>;
    updatedDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
    updatedDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
    updatedDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
    updatedDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    updatedDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
    updatedDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
    updatedDate_not?: InputMaybe<Scalars['DateTime']['input']>;
    updatedDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type PageJournalLinkingCollections = {
    __typename?: 'PageJournalLinkingCollections';
    blockSlideshowCollection?: Maybe<BlockSlideshowCollection>;
    blockSlideshowCursorCollection?: Maybe<BlockSlideshowCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    iconBlockCollection?: Maybe<IconBlockCollection>;
    iconBlockCursorCollection?: Maybe<IconBlockCursorCollection>;
    internalPageLinkCollection?: Maybe<InternalPageLinkCollection>;
    internalPageLinkCursorCollection?: Maybe<InternalPageLinkCursorCollection>;
};

export type PageJournalLinkingCollectionsBlockSlideshowCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalLinkingCollectionsBlockSlideshowCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageJournalLinkingCollectionsBlockSlideshowCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalLinkingCollectionsBlockSlideshowCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageJournalLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageJournalLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageJournalLinkingCollectionsIconBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalLinkingCollectionsIconBlockCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageJournalLinkingCollectionsIconBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalLinkingCollectionsIconBlockCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageJournalLinkingCollectionsInternalPageLinkCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalLinkingCollectionsInternalPageLinkCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageJournalLinkingCollectionsInternalPageLinkCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalLinkingCollectionsInternalPageLinkCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PageJournalLinkingCollectionsBlockSlideshowCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageJournalLinkingCollectionsBlockSlideshowCursorCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageJournalLinkingCollectionsIconBlockCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageJournalLinkingCollectionsIconBlockCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageJournalLinkingCollectionsInternalPageLinkCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageJournalLinkingCollectionsInternalPageLinkCursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type PageJournalNt_ExperiencesCollection = {
    __typename?: 'PageJournalNt_experiencesCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageJournalNt_ExperiencesCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type PageJournalNt_ExperiencesCursorCollection = {
    __typename?: 'PageJournalNt_experiencesCursorCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageJournalNt_ExperiencesCursorCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageJournalOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export type PageJournalSectionsCollection = {
    __typename?: 'PageJournalSectionsCollection';
    items: Array<Maybe<PageJournalSectionsItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageJournalSectionsCursorCollection = {
    __typename?: 'PageJournalSectionsCursorCollection';
    items: Array<Maybe<PageJournalSectionsItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageJournalSectionsFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageJournalSectionsFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageJournalSectionsFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type PageJournalSectionsItem =
    | BlockDarkCircleBackground
    | BlockFeaturedCaseStudies
    | BlockIconBlocks
    | BlockImage
    | BlockImageWithPartialOverlay
    | BlockIndustryBlocks
    | BlockJobList
    | BlockLogoGrid
    | BlockNumberedBlocks
    | BlockPageSection
    | BlockPeopleList
    | BlockSlideshow
    | BlockTechnologyBlocks
    | CtaSimple;

export type PageJournalServicesCollection = {
    __typename?: 'PageJournalServicesCollection';
    items: Array<Maybe<Service>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageJournalServicesCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageJournalServicesCursorCollection = {
    __typename?: 'PageJournalServicesCursorCollection';
    items: Array<Maybe<Service>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageJournalServicesCursorCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageJournalSolutionsCollection = {
    __typename?: 'PageJournalSolutionsCollection';
    items: Array<Maybe<Solution>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageJournalSolutionsCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageJournalSolutionsCursorCollection = {
    __typename?: 'PageJournalSolutionsCursorCollection';
    items: Array<Maybe<Solution>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageJournalSolutionsCursorCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageJournalTechnologiesCollection = {
    __typename?: 'PageJournalTechnologiesCollection';
    items: Array<Maybe<Technology>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageJournalTechnologiesCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TechnologySummaryAsc = 'technologySummary_ASC',
    TechnologySummaryDesc = 'technologySummary_DESC',
    TechnologyTypeAsc = 'technologyType_ASC',
    TechnologyTypeDesc = 'technologyType_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageJournalTechnologiesCursorCollection = {
    __typename?: 'PageJournalTechnologiesCursorCollection';
    items: Array<Maybe<Technology>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageJournalTechnologiesCursorCollectionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TechnologySummaryAsc = 'technologySummary_ASC',
    TechnologySummaryDesc = 'technologySummary_DESC',
    TechnologyTypeAsc = 'technologyType_ASC',
    TechnologyTypeDesc = 'technologyType_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLanding = Entry &
    _Node & {
        __typename?: 'PageLanding';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        excludeFromSearch?: Maybe<Scalars['Boolean']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<PageLandingLinkingCollections>;
        pageIntro?: Maybe<BlockPageIntro>;
        sectionsCollection?: Maybe<PageLandingSectionsCollection>;
        sectionsCursorCollection?: Maybe<PageLandingSectionsCursorCollection>;
        seoDescription?: Maybe<Scalars['String']['output']>;
        seoTitle?: Maybe<Scalars['String']['output']>;
        slug?: Maybe<Scalars['String']['output']>;
        summary?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingExcludeFromSearchArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingPageIntroArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockPageIntroFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingSectionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageLandingSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingSectionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageLandingSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingSeoDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingSeoTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingSlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingSummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageLanding) */
export type PageLandingTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLandingCollection = {
    __typename?: 'PageLandingCollection';
    items: Array<Maybe<PageLanding>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageLandingCursorCollection = {
    __typename?: 'PageLandingCursorCollection';
    items: Array<Maybe<PageLanding>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageLandingFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageLandingFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageLandingFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    excludeFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
    excludeFromSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
    excludeFromSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    pageIntro?: InputMaybe<CfBlockPageIntroNestedFilter>;
    pageIntro_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sections?: InputMaybe<CfsectionsMultiTypeNestedFilter>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageLandingLinkingCollections = {
    __typename?: 'PageLandingLinkingCollections';
    buttonCollection?: Maybe<ButtonCollection>;
    buttonCursorCollection?: Maybe<ButtonCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    iconBlockCollection?: Maybe<IconBlockCollection>;
    iconBlockCursorCollection?: Maybe<IconBlockCursorCollection>;
    internalPageLinkCollection?: Maybe<InternalPageLinkCollection>;
    internalPageLinkCursorCollection?: Maybe<InternalPageLinkCursorCollection>;
};

export type PageLandingLinkingCollectionsButtonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageLandingLinkingCollectionsButtonCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLandingLinkingCollectionsButtonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageLandingLinkingCollectionsButtonCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLandingLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLandingLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLandingLinkingCollectionsIconBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageLandingLinkingCollectionsIconBlockCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLandingLinkingCollectionsIconBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageLandingLinkingCollectionsIconBlockCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLandingLinkingCollectionsInternalPageLinkCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageLandingLinkingCollectionsInternalPageLinkCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLandingLinkingCollectionsInternalPageLinkCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageLandingLinkingCollectionsInternalPageLinkCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PageLandingLinkingCollectionsButtonCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageLandingLinkingCollectionsButtonCursorCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageLandingLinkingCollectionsIconBlockCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageLandingLinkingCollectionsIconBlockCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageLandingLinkingCollectionsInternalPageLinkCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageLandingLinkingCollectionsInternalPageLinkCursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageLandingOrder {
    ExcludeFromSearchAsc = 'excludeFromSearch_ASC',
    ExcludeFromSearchDesc = 'excludeFromSearch_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageLandingSectionsCollection = {
    __typename?: 'PageLandingSectionsCollection';
    items: Array<Maybe<PageLandingSectionsItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageLandingSectionsCursorCollection = {
    __typename?: 'PageLandingSectionsCursorCollection';
    items: Array<Maybe<PageLandingSectionsItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageLandingSectionsFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageLandingSectionsFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageLandingSectionsFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type PageLandingSectionsItem =
    | BlockClientTestimonial
    | BlockDarkCircleBackground
    | BlockFeaturedCaseStudies
    | BlockIconBlocks
    | BlockImage
    | BlockImageWithPartialOverlay
    | BlockIndustryBlocks
    | BlockJobList
    | BlockLogoCarousel
    | BlockLogoGrid
    | BlockNumberedBlocks
    | BlockPageSection
    | BlockPeopleList
    | BlockSlideshow
    | BlockTechnologyBlocks
    | CtaSimple
    | Form
    | LandingPage;

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pagePerson) */
export type PagePerson = Entry &
    _Node & {
        __typename?: 'PagePerson';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        heroImage?: Maybe<ImageWrapper>;
        internalName?: Maybe<Scalars['String']['output']>;
        isActive?: Maybe<Scalars['Boolean']['output']>;
        linkedFrom?: Maybe<PagePersonLinkingCollections>;
        person?: Maybe<Person>;
        seoDescription?: Maybe<Scalars['String']['output']>;
        seoTitle?: Maybe<Scalars['String']['output']>;
        slug?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pagePerson) */
export type PagePersonHeroImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pagePerson) */
export type PagePersonInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pagePerson) */
export type PagePersonIsActiveArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pagePerson) */
export type PagePersonLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pagePerson) */
export type PagePersonPersonArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PersonFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pagePerson) */
export type PagePersonSeoDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pagePerson) */
export type PagePersonSeoTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pagePerson) */
export type PagePersonSlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pagePerson) */
export type PagePersonTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonCollection = {
    __typename?: 'PagePersonCollection';
    items: Array<Maybe<PagePerson>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PagePersonCursorCollection = {
    __typename?: 'PagePersonCursorCollection';
    items: Array<Maybe<PagePerson>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PagePersonFilter = {
    AND?: InputMaybe<Array<InputMaybe<PagePersonFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PagePersonFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    heroImage?: InputMaybe<CfImageWrapperNestedFilter>;
    heroImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    isActive_exists?: InputMaybe<Scalars['Boolean']['input']>;
    isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
    person?: InputMaybe<CfPersonNestedFilter>;
    person_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PagePersonLinkingCollections = {
    __typename?: 'PagePersonLinkingCollections';
    blockPeopleListCollection?: Maybe<BlockPeopleListCollection>;
    blockPeopleListCursorCollection?: Maybe<BlockPeopleListCursorCollection>;
    buttonCollection?: Maybe<ButtonCollection>;
    buttonCursorCollection?: Maybe<ButtonCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    iconBlockCollection?: Maybe<IconBlockCollection>;
    iconBlockCursorCollection?: Maybe<IconBlockCursorCollection>;
    internalPageLinkCollection?: Maybe<InternalPageLinkCollection>;
    internalPageLinkCursorCollection?: Maybe<InternalPageLinkCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
};

export type PagePersonLinkingCollectionsBlockPeopleListCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonLinkingCollectionsBlockPeopleListCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsBlockPeopleListCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonLinkingCollectionsBlockPeopleListCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsButtonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonLinkingCollectionsButtonCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsButtonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonLinkingCollectionsButtonCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsIconBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonLinkingCollectionsIconBlockCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsIconBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonLinkingCollectionsIconBlockCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsInternalPageLinkCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonLinkingCollectionsInternalPageLinkCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsInternalPageLinkCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonLinkingCollectionsInternalPageLinkCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PagePersonLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PagePersonLinkingCollectionsBlockPeopleListCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PagePersonLinkingCollectionsBlockPeopleListCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PagePersonLinkingCollectionsButtonCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PagePersonLinkingCollectionsButtonCursorCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PagePersonLinkingCollectionsIconBlockCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PagePersonLinkingCollectionsIconBlockCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PagePersonLinkingCollectionsInternalPageLinkCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PagePersonLinkingCollectionsInternalPageLinkCursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PagePersonLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum PagePersonLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum PagePersonOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageService = Entry &
    _Node & {
        __typename?: 'PageService';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<PageServiceLinkingCollections>;
        ntExperiencesCollection?: Maybe<PageServiceNt_ExperiencesCollection>;
        ntExperiencesCursorCollection?: Maybe<PageServiceNt_ExperiencesCursorCollection>;
        sectionsCollection?: Maybe<PageServiceSectionsCollection>;
        sectionsCursorCollection?: Maybe<PageServiceSectionsCursorCollection>;
        seoDescription?: Maybe<Scalars['String']['output']>;
        seoTitle?: Maybe<Scalars['String']['output']>;
        service?: Maybe<Service>;
        slug?: Maybe<Scalars['String']['output']>;
        summary?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceNtExperiencesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageServiceNt_ExperiencesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceNtExperiencesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageServiceNt_ExperiencesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceSectionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageServiceSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceSectionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageServiceSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceSeoDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceSeoTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceServiceArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ServiceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceSlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceSummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageService) */
export type PageServiceTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageServiceCollection = {
    __typename?: 'PageServiceCollection';
    items: Array<Maybe<PageService>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageServiceCursorCollection = {
    __typename?: 'PageServiceCursorCollection';
    items: Array<Maybe<PageService>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageServiceFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageServiceFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageServiceFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experiences?: InputMaybe<CfNtExperienceNestedFilter>;
    nt_experiencesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sections?: InputMaybe<CfsectionsMultiTypeNestedFilter>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    service?: InputMaybe<CfServiceNestedFilter>;
    service_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageServiceLinkingCollections = {
    __typename?: 'PageServiceLinkingCollections';
    buttonCollection?: Maybe<ButtonCollection>;
    buttonCursorCollection?: Maybe<ButtonCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    iconBlockCollection?: Maybe<IconBlockCollection>;
    iconBlockCursorCollection?: Maybe<IconBlockCursorCollection>;
    internalPageLinkCollection?: Maybe<InternalPageLinkCollection>;
    internalPageLinkCursorCollection?: Maybe<InternalPageLinkCursorCollection>;
};

export type PageServiceLinkingCollectionsButtonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageServiceLinkingCollectionsButtonCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageServiceLinkingCollectionsButtonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageServiceLinkingCollectionsButtonCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageServiceLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageServiceLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageServiceLinkingCollectionsIconBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageServiceLinkingCollectionsIconBlockCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageServiceLinkingCollectionsIconBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageServiceLinkingCollectionsIconBlockCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageServiceLinkingCollectionsInternalPageLinkCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageServiceLinkingCollectionsInternalPageLinkCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageServiceLinkingCollectionsInternalPageLinkCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageServiceLinkingCollectionsInternalPageLinkCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PageServiceLinkingCollectionsButtonCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageServiceLinkingCollectionsButtonCursorCollectionOrder {
    ButtonTextAsc = 'buttonText_ASC',
    ButtonTextDesc = 'buttonText_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    LinkPathAsc = 'linkPath_ASC',
    LinkPathDesc = 'linkPath_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageServiceLinkingCollectionsIconBlockCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageServiceLinkingCollectionsIconBlockCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageServiceLinkingCollectionsInternalPageLinkCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageServiceLinkingCollectionsInternalPageLinkCursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type PageServiceNt_ExperiencesCollection = {
    __typename?: 'PageServiceNt_experiencesCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PageServiceNt_ExperiencesCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type PageServiceNt_ExperiencesCursorCollection = {
    __typename?: 'PageServiceNt_experiencesCursorCollection';
    items: Array<Maybe<NtExperience>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PageServiceNt_ExperiencesCursorCollectionOrder {
    NtExperienceIdAsc = 'nt_experience_id_ASC',
    NtExperienceIdDesc = 'nt_experience_id_DESC',
    NtNameAsc = 'nt_name_ASC',
    NtNameDesc = 'nt_name_DESC',
    NtTypeAsc = 'nt_type_ASC',
    NtTypeDesc = 'nt_type_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageServiceOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageServiceSectionsCollection = {
    __typename?: 'PageServiceSectionsCollection';
    items: Array<Maybe<PageServiceSectionsItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageServiceSectionsCursorCollection = {
    __typename?: 'PageServiceSectionsCursorCollection';
    items: Array<Maybe<PageServiceSectionsItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageServiceSectionsFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageServiceSectionsFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageServiceSectionsFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type PageServiceSectionsItem =
    | BlockClientTestimonial
    | BlockDarkCircleBackground
    | BlockFeaturedCaseStudies
    | BlockIconBlocks
    | BlockImage
    | BlockImageWithPartialOverlay
    | BlockIndustryBlocks
    | BlockJobList
    | BlockLogoGrid
    | BlockNumberedBlocks
    | BlockPageSection
    | BlockPeopleList
    | BlockSlideshow
    | BlockTechnologyBlocks
    | CtaSimple;

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustry = Entry &
    _Node & {
        __typename?: 'PageSubIndustry';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<PageSubIndustryLinkingCollections>;
        listImage?: Maybe<ImageWrapper>;
        sectionsCollection?: Maybe<PageSubIndustrySectionsCollection>;
        sectionsCursorCollection?: Maybe<PageSubIndustrySectionsCursorCollection>;
        seoDescription?: Maybe<Scalars['String']['output']>;
        seoTitle?: Maybe<Scalars['String']['output']>;
        slug?: Maybe<Scalars['String']['output']>;
        subIndustry?: Maybe<SubIndustry>;
        summary?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustryInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustryLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustryListImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustrySectionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageSubIndustrySectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustrySectionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageSubIndustrySectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustrySeoDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustrySeoTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustrySlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustrySubIndustryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SubIndustryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustrySummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageSubIndustry) */
export type PageSubIndustryTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageSubIndustryCollection = {
    __typename?: 'PageSubIndustryCollection';
    items: Array<Maybe<PageSubIndustry>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageSubIndustryCursorCollection = {
    __typename?: 'PageSubIndustryCursorCollection';
    items: Array<Maybe<PageSubIndustry>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageSubIndustryFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageSubIndustryFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageSubIndustryFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    listImage?: InputMaybe<CfImageWrapperNestedFilter>;
    listImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sections?: InputMaybe<CfsectionsMultiTypeNestedFilter>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    subIndustry?: InputMaybe<CfSubIndustryNestedFilter>;
    subIndustry_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageSubIndustryLinkingCollections = {
    __typename?: 'PageSubIndustryLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type PageSubIndustryLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageSubIndustryLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PageSubIndustryOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageSubIndustrySectionsCollection = {
    __typename?: 'PageSubIndustrySectionsCollection';
    items: Array<Maybe<PageSubIndustrySectionsItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageSubIndustrySectionsCursorCollection = {
    __typename?: 'PageSubIndustrySectionsCursorCollection';
    items: Array<Maybe<PageSubIndustrySectionsItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageSubIndustrySectionsFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageSubIndustrySectionsFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageSubIndustrySectionsFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type PageSubIndustrySectionsItem =
    | BlockClientTestimonial
    | BlockDarkCircleBackground
    | BlockFeaturedCaseStudies
    | BlockIconBlocks
    | BlockImage
    | BlockImageWithPartialOverlay
    | BlockIndustryBlocks
    | BlockJobList
    | BlockLogoGrid
    | BlockNumberedBlocks
    | BlockPageSection
    | BlockPeopleList
    | BlockSlideshow
    | BlockTechnologyBlocks
    | CtaSimple;

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnology = Entry &
    _Node & {
        __typename?: 'PageTechnology';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<PageTechnologyLinkingCollections>;
        sectionsCollection?: Maybe<PageTechnologySectionsCollection>;
        sectionsCursorCollection?: Maybe<PageTechnologySectionsCursorCollection>;
        seoDescription?: Maybe<Scalars['String']['output']>;
        seoTitle?: Maybe<Scalars['String']['output']>;
        slug?: Maybe<Scalars['String']['output']>;
        summary?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        technology?: Maybe<Technology>;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnologyInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnologyLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnologySectionsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageTechnologySectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnologySectionsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageTechnologySectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnologySeoDescriptionArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnologySeoTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnologySlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnologySummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnologyTechnologyArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TechnologyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/pageTechnology) */
export type PageTechnologyTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageTechnologyCollection = {
    __typename?: 'PageTechnologyCollection';
    items: Array<Maybe<PageTechnology>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageTechnologyCursorCollection = {
    __typename?: 'PageTechnologyCursorCollection';
    items: Array<Maybe<PageTechnology>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageTechnologyFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageTechnologyFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageTechnologyFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sections?: InputMaybe<CfsectionsMultiTypeNestedFilter>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    technology?: InputMaybe<CfTechnologyNestedFilter>;
    technology_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageTechnologyLinkingCollections = {
    __typename?: 'PageTechnologyLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    iconBlockCollection?: Maybe<IconBlockCollection>;
    iconBlockCursorCollection?: Maybe<IconBlockCursorCollection>;
    internalPageLinkCollection?: Maybe<InternalPageLinkCollection>;
    internalPageLinkCursorCollection?: Maybe<InternalPageLinkCursorCollection>;
};

export type PageTechnologyLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageTechnologyLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageTechnologyLinkingCollectionsIconBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageTechnologyLinkingCollectionsIconBlockCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageTechnologyLinkingCollectionsIconBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageTechnologyLinkingCollectionsIconBlockCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageTechnologyLinkingCollectionsInternalPageLinkCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageTechnologyLinkingCollectionsInternalPageLinkCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageTechnologyLinkingCollectionsInternalPageLinkCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageTechnologyLinkingCollectionsInternalPageLinkCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PageTechnologyLinkingCollectionsIconBlockCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageTechnologyLinkingCollectionsIconBlockCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    ParagraphAsc = 'paragraph_ASC',
    ParagraphDesc = 'paragraph_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageTechnologyLinkingCollectionsInternalPageLinkCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageTechnologyLinkingCollectionsInternalPageLinkCursorCollectionOrder {
    LinkTextAsc = 'linkText_ASC',
    LinkTextDesc = 'linkText_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum PageTechnologyOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type PageTechnologySectionsCollection = {
    __typename?: 'PageTechnologySectionsCollection';
    items: Array<Maybe<PageTechnologySectionsItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PageTechnologySectionsCursorCollection = {
    __typename?: 'PageTechnologySectionsCursorCollection';
    items: Array<Maybe<PageTechnologySectionsItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PageTechnologySectionsFilter = {
    AND?: InputMaybe<Array<InputMaybe<PageTechnologySectionsFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PageTechnologySectionsFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type PageTechnologySectionsItem =
    | BlockClientTestimonial
    | BlockDarkCircleBackground
    | BlockFeaturedCaseStudies
    | BlockIconBlocks
    | BlockImage
    | BlockImageWithPartialOverlay
    | BlockIndustryBlocks
    | BlockJobList
    | BlockLogoGrid
    | BlockNumberedBlocks
    | BlockPageSection
    | BlockPeopleList
    | BlockSlideshow
    | BlockTechnologyBlocks
    | CtaSimple;

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type Person = Entry &
    _Node & {
        __typename?: 'Person';
        _id: Scalars['ID']['output'];
        atAGlance?: Maybe<Scalars['String']['output']>;
        atFosterMade?: Maybe<Scalars['String']['output']>;
        beyondIntroductions?: Maybe<Scalars['String']['output']>;
        bio?: Maybe<Scalars['String']['output']>;
        contentfulMetadata: ContentfulMetadata;
        email?: Maybe<Scalars['String']['output']>;
        expertise?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
        firstName?: Maybe<Scalars['String']['output']>;
        funFactsCollection?: Maybe<PersonFunFactsCollection>;
        funFactsCursorCollection?: Maybe<PersonFunFactsCursorCollection>;
        jobTitle?: Maybe<Scalars['String']['output']>;
        lastName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<PersonLinkingCollections>;
        profileImage?: Maybe<ImageWrapper>;
        socialLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
        sys: Sys;
        testimonial?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonAtAGlanceArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonAtFosterMadeArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonBeyondIntroductionsArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonBioArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonEmailArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonExpertiseArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonFirstNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonFunFactsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PersonFunFactsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FactFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonFunFactsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PersonFunFactsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FactFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonJobTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonLastNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonProfileImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonSocialLinksArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/person) */
export type PersonTestimonialArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonCollection = {
    __typename?: 'PersonCollection';
    items: Array<Maybe<Person>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type PersonCursorCollection = {
    __typename?: 'PersonCursorCollection';
    items: Array<Maybe<Person>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type PersonFilter = {
    AND?: InputMaybe<Array<InputMaybe<PersonFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<PersonFilter>>>;
    atAGlance?: InputMaybe<Scalars['String']['input']>;
    atAGlance_contains?: InputMaybe<Scalars['String']['input']>;
    atAGlance_exists?: InputMaybe<Scalars['Boolean']['input']>;
    atAGlance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    atAGlance_not?: InputMaybe<Scalars['String']['input']>;
    atAGlance_not_contains?: InputMaybe<Scalars['String']['input']>;
    atAGlance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    atFosterMade?: InputMaybe<Scalars['String']['input']>;
    atFosterMade_contains?: InputMaybe<Scalars['String']['input']>;
    atFosterMade_exists?: InputMaybe<Scalars['Boolean']['input']>;
    atFosterMade_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    atFosterMade_not?: InputMaybe<Scalars['String']['input']>;
    atFosterMade_not_contains?: InputMaybe<Scalars['String']['input']>;
    atFosterMade_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    beyondIntroductions?: InputMaybe<Scalars['String']['input']>;
    beyondIntroductions_contains?: InputMaybe<Scalars['String']['input']>;
    beyondIntroductions_exists?: InputMaybe<Scalars['Boolean']['input']>;
    beyondIntroductions_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    beyondIntroductions_not?: InputMaybe<Scalars['String']['input']>;
    beyondIntroductions_not_contains?: InputMaybe<Scalars['String']['input']>;
    beyondIntroductions_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    bio?: InputMaybe<Scalars['String']['input']>;
    bio_contains?: InputMaybe<Scalars['String']['input']>;
    bio_exists?: InputMaybe<Scalars['Boolean']['input']>;
    bio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    bio_not?: InputMaybe<Scalars['String']['input']>;
    bio_not_contains?: InputMaybe<Scalars['String']['input']>;
    bio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    email?: InputMaybe<Scalars['String']['input']>;
    email_contains?: InputMaybe<Scalars['String']['input']>;
    email_exists?: InputMaybe<Scalars['Boolean']['input']>;
    email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    email_not?: InputMaybe<Scalars['String']['input']>;
    email_not_contains?: InputMaybe<Scalars['String']['input']>;
    email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    expertise_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    expertise_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    expertise_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    expertise_exists?: InputMaybe<Scalars['Boolean']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    firstName_contains?: InputMaybe<Scalars['String']['input']>;
    firstName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    firstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    firstName_not?: InputMaybe<Scalars['String']['input']>;
    firstName_not_contains?: InputMaybe<Scalars['String']['input']>;
    firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    funFacts?: InputMaybe<CfFactNestedFilter>;
    funFactsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    jobTitle?: InputMaybe<Scalars['String']['input']>;
    jobTitle_contains?: InputMaybe<Scalars['String']['input']>;
    jobTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    jobTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    jobTitle_not?: InputMaybe<Scalars['String']['input']>;
    jobTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    jobTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    lastName_contains?: InputMaybe<Scalars['String']['input']>;
    lastName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    lastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    lastName_not?: InputMaybe<Scalars['String']['input']>;
    lastName_not_contains?: InputMaybe<Scalars['String']['input']>;
    lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    profileImage?: InputMaybe<CfImageWrapperNestedFilter>;
    profileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    socialLinks_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    socialLinks_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    socialLinks_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    socialLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
    testimonial?: InputMaybe<Scalars['String']['input']>;
    testimonial_contains?: InputMaybe<Scalars['String']['input']>;
    testimonial_exists?: InputMaybe<Scalars['Boolean']['input']>;
    testimonial_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    testimonial_not?: InputMaybe<Scalars['String']['input']>;
    testimonial_not_contains?: InputMaybe<Scalars['String']['input']>;
    testimonial_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PersonFunFactsCollection = {
    __typename?: 'PersonFunFactsCollection';
    items: Array<Maybe<Fact>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum PersonFunFactsCollectionOrder {
    HeaderAsc = 'header_ASC',
    HeaderDesc = 'header_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type PersonFunFactsCursorCollection = {
    __typename?: 'PersonFunFactsCursorCollection';
    items: Array<Maybe<Fact>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum PersonFunFactsCursorCollectionOrder {
    HeaderAsc = 'header_ASC',
    HeaderDesc = 'header_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type PersonLinkingCollections = {
    __typename?: 'PersonLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pagePersonCollection?: Maybe<PagePersonCollection>;
    pagePersonCursorCollection?: Maybe<PagePersonCursorCollection>;
};

export type PersonLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonLinkingCollectionsPagePersonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsPagePersonCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonLinkingCollectionsPagePersonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsPagePersonCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PersonLinkingCollectionsPagePersonCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum PersonLinkingCollectionsPagePersonCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsActiveAsc = 'isActive_ASC',
    IsActiveDesc = 'isActive_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum PersonOrder {
    EmailAsc = 'email_ASC',
    EmailDesc = 'email_DESC',
    FirstNameAsc = 'firstName_ASC',
    FirstNameDesc = 'firstName_DESC',
    JobTitleAsc = 'jobTitle_ASC',
    JobTitleDesc = 'jobTitle_DESC',
    LastNameAsc = 'lastName_ASC',
    LastNameDesc = 'lastName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type Query = {
    __typename?: 'Query';
    _node?: Maybe<_Node>;
    _nodes: Array<Maybe<_Node>>;
    accordionContentItem?: Maybe<AccordionContentItem>;
    accordionContentItemCollection?: Maybe<AccordionContentItemCollection>;
    accordionContentItemCursorCollection?: Maybe<AccordionContentItemCursorCollection>;
    asset?: Maybe<Asset>;
    assetCollection?: Maybe<AssetCollection>;
    assetCursorCollection?: Maybe<AssetCursorCollection>;
    blockAccordionContent?: Maybe<BlockAccordionContent>;
    blockAccordionContentCollection?: Maybe<BlockAccordionContentCollection>;
    blockAccordionContentCursorCollection?: Maybe<BlockAccordionContentCursorCollection>;
    blockClientTestimonial?: Maybe<BlockClientTestimonial>;
    blockClientTestimonialCollection?: Maybe<BlockClientTestimonialCollection>;
    blockClientTestimonialCursorCollection?: Maybe<BlockClientTestimonialCursorCollection>;
    blockDarkCircleBackground?: Maybe<BlockDarkCircleBackground>;
    blockDarkCircleBackgroundCollection?: Maybe<BlockDarkCircleBackgroundCollection>;
    blockDarkCircleBackgroundCursorCollection?: Maybe<BlockDarkCircleBackgroundCursorCollection>;
    blockFeaturedCaseStudies?: Maybe<BlockFeaturedCaseStudies>;
    blockFeaturedCaseStudiesCollection?: Maybe<BlockFeaturedCaseStudiesCollection>;
    blockFeaturedCaseStudiesCursorCollection?: Maybe<BlockFeaturedCaseStudiesCursorCollection>;
    blockIconBlocks?: Maybe<BlockIconBlocks>;
    blockIconBlocksCollection?: Maybe<BlockIconBlocksCollection>;
    blockIconBlocksCursorCollection?: Maybe<BlockIconBlocksCursorCollection>;
    blockImage?: Maybe<BlockImage>;
    blockImageCollection?: Maybe<BlockImageCollection>;
    blockImageCursorCollection?: Maybe<BlockImageCursorCollection>;
    blockImageWithPartialOverlay?: Maybe<BlockImageWithPartialOverlay>;
    blockImageWithPartialOverlayCollection?: Maybe<BlockImageWithPartialOverlayCollection>;
    blockImageWithPartialOverlayCursorCollection?: Maybe<BlockImageWithPartialOverlayCursorCollection>;
    blockIndustryBlocks?: Maybe<BlockIndustryBlocks>;
    blockIndustryBlocksCollection?: Maybe<BlockIndustryBlocksCollection>;
    blockIndustryBlocksCursorCollection?: Maybe<BlockIndustryBlocksCursorCollection>;
    blockJobList?: Maybe<BlockJobList>;
    blockJobListCollection?: Maybe<BlockJobListCollection>;
    blockJobListCursorCollection?: Maybe<BlockJobListCursorCollection>;
    blockLogoCarousel?: Maybe<BlockLogoCarousel>;
    blockLogoCarouselCollection?: Maybe<BlockLogoCarouselCollection>;
    blockLogoCarouselCursorCollection?: Maybe<BlockLogoCarouselCursorCollection>;
    blockLogoGrid?: Maybe<BlockLogoGrid>;
    blockLogoGridCollection?: Maybe<BlockLogoGridCollection>;
    blockLogoGridCursorCollection?: Maybe<BlockLogoGridCursorCollection>;
    blockNumberedBlocks?: Maybe<BlockNumberedBlocks>;
    blockNumberedBlocksCollection?: Maybe<BlockNumberedBlocksCollection>;
    blockNumberedBlocksCursorCollection?: Maybe<BlockNumberedBlocksCursorCollection>;
    blockPageIntro?: Maybe<BlockPageIntro>;
    blockPageIntroCollection?: Maybe<BlockPageIntroCollection>;
    blockPageIntroCursorCollection?: Maybe<BlockPageIntroCursorCollection>;
    blockPageSection?: Maybe<BlockPageSection>;
    blockPageSectionCollection?: Maybe<BlockPageSectionCollection>;
    blockPageSectionCursorCollection?: Maybe<BlockPageSectionCursorCollection>;
    blockPeopleList?: Maybe<BlockPeopleList>;
    blockPeopleListCollection?: Maybe<BlockPeopleListCollection>;
    blockPeopleListCursorCollection?: Maybe<BlockPeopleListCursorCollection>;
    blockRichText?: Maybe<BlockRichText>;
    blockRichTextCollection?: Maybe<BlockRichTextCollection>;
    blockRichTextCursorCollection?: Maybe<BlockRichTextCursorCollection>;
    blockScrolljackSection?: Maybe<BlockScrolljackSection>;
    blockScrolljackSectionCollection?: Maybe<BlockScrolljackSectionCollection>;
    blockScrolljackSectionCursorCollection?: Maybe<BlockScrolljackSectionCursorCollection>;
    blockSlideshow?: Maybe<BlockSlideshow>;
    blockSlideshowCollection?: Maybe<BlockSlideshowCollection>;
    blockSlideshowCursorCollection?: Maybe<BlockSlideshowCursorCollection>;
    blockStackedCards?: Maybe<BlockStackedCards>;
    blockStackedCardsCollection?: Maybe<BlockStackedCardsCollection>;
    blockStackedCardsCursorCollection?: Maybe<BlockStackedCardsCursorCollection>;
    blockTabbedContent?: Maybe<BlockTabbedContent>;
    blockTabbedContentCollection?: Maybe<BlockTabbedContentCollection>;
    blockTabbedContentCursorCollection?: Maybe<BlockTabbedContentCursorCollection>;
    blockTechnologyBlocks?: Maybe<BlockTechnologyBlocks>;
    blockTechnologyBlocksCollection?: Maybe<BlockTechnologyBlocksCollection>;
    blockTechnologyBlocksCursorCollection?: Maybe<BlockTechnologyBlocksCursorCollection>;
    button?: Maybe<Button>;
    buttonCollection?: Maybe<ButtonCollection>;
    buttonCursorCollection?: Maybe<ButtonCursorCollection>;
    career?: Maybe<Career>;
    careerCollection?: Maybe<CareerCollection>;
    careerCursorCollection?: Maybe<CareerCursorCollection>;
    client?: Maybe<Client>;
    clientCollection?: Maybe<ClientCollection>;
    clientCursorCollection?: Maybe<ClientCursorCollection>;
    codeBlock?: Maybe<CodeBlock>;
    codeBlockCollection?: Maybe<CodeBlockCollection>;
    codeBlockCursorCollection?: Maybe<CodeBlockCursorCollection>;
    companyTopic?: Maybe<CompanyTopic>;
    companyTopicCollection?: Maybe<CompanyTopicCollection>;
    companyTopicCursorCollection?: Maybe<CompanyTopicCursorCollection>;
    ctaSimple?: Maybe<CtaSimple>;
    ctaSimpleCollection?: Maybe<CtaSimpleCollection>;
    ctaSimpleCursorCollection?: Maybe<CtaSimpleCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    expertise?: Maybe<Expertise>;
    expertiseCollection?: Maybe<ExpertiseCollection>;
    expertiseCursorCollection?: Maybe<ExpertiseCursorCollection>;
    fact?: Maybe<Fact>;
    factCollection?: Maybe<FactCollection>;
    factCursorCollection?: Maybe<FactCursorCollection>;
    form?: Maybe<Form>;
    formCollection?: Maybe<FormCollection>;
    formCursorCollection?: Maybe<FormCursorCollection>;
    formField?: Maybe<FormField>;
    formFieldCollection?: Maybe<FormFieldCollection>;
    formFieldCursorCollection?: Maybe<FormFieldCursorCollection>;
    icon?: Maybe<Icon>;
    iconBlock?: Maybe<IconBlock>;
    iconBlockCollection?: Maybe<IconBlockCollection>;
    iconBlockCursorCollection?: Maybe<IconBlockCursorCollection>;
    iconCollection?: Maybe<IconCollection>;
    iconCursorCollection?: Maybe<IconCursorCollection>;
    imageWrapper?: Maybe<ImageWrapper>;
    imageWrapperCollection?: Maybe<ImageWrapperCollection>;
    imageWrapperCursorCollection?: Maybe<ImageWrapperCursorCollection>;
    industry?: Maybe<Industry>;
    industryCollection?: Maybe<IndustryCollection>;
    industryCursorCollection?: Maybe<IndustryCursorCollection>;
    internalPageLink?: Maybe<InternalPageLink>;
    internalPageLinkCollection?: Maybe<InternalPageLinkCollection>;
    internalPageLinkCursorCollection?: Maybe<InternalPageLinkCursorCollection>;
    landingPage?: Maybe<LandingPage>;
    landingPageCollection?: Maybe<LandingPageCollection>;
    landingPageCursorCollection?: Maybe<LandingPageCursorCollection>;
    nav?: Maybe<Nav>;
    navCollection?: Maybe<NavCollection>;
    navCursorCollection?: Maybe<NavCursorCollection>;
    navSection?: Maybe<NavSection>;
    navSectionCollection?: Maybe<NavSectionCollection>;
    navSectionCursorCollection?: Maybe<NavSectionCursorCollection>;
    ntAudience?: Maybe<NtAudience>;
    ntAudienceCollection?: Maybe<NtAudienceCollection>;
    ntAudienceCursorCollection?: Maybe<NtAudienceCursorCollection>;
    ntExperience?: Maybe<NtExperience>;
    ntExperienceCollection?: Maybe<NtExperienceCollection>;
    ntExperienceCursorCollection?: Maybe<NtExperienceCursorCollection>;
    ntMergetag?: Maybe<NtMergetag>;
    ntMergetagCollection?: Maybe<NtMergetagCollection>;
    ntMergetagCursorCollection?: Maybe<NtMergetagCursorCollection>;
    pageCaseStudy?: Maybe<PageCaseStudy>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageCompany?: Maybe<PageCompany>;
    pageCompanyCollection?: Maybe<PageCompanyCollection>;
    pageCompanyCursorCollection?: Maybe<PageCompanyCursorCollection>;
    pageExpertise?: Maybe<PageExpertise>;
    pageExpertiseCollection?: Maybe<PageExpertiseCollection>;
    pageExpertiseCursorCollection?: Maybe<PageExpertiseCursorCollection>;
    pageIndustry?: Maybe<PageIndustry>;
    pageIndustryCollection?: Maybe<PageIndustryCollection>;
    pageIndustryCursorCollection?: Maybe<PageIndustryCursorCollection>;
    pageJournal?: Maybe<PageJournal>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageLanding?: Maybe<PageLanding>;
    pageLandingCollection?: Maybe<PageLandingCollection>;
    pageLandingCursorCollection?: Maybe<PageLandingCursorCollection>;
    pagePerson?: Maybe<PagePerson>;
    pagePersonCollection?: Maybe<PagePersonCollection>;
    pagePersonCursorCollection?: Maybe<PagePersonCursorCollection>;
    pageService?: Maybe<PageService>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
    pageSubIndustry?: Maybe<PageSubIndustry>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
    pageTechnology?: Maybe<PageTechnology>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
    person?: Maybe<Person>;
    personCollection?: Maybe<PersonCollection>;
    personCursorCollection?: Maybe<PersonCursorCollection>;
    resource?: Maybe<Resource>;
    resourceCollection?: Maybe<ResourceCollection>;
    resourceCursorCollection?: Maybe<ResourceCursorCollection>;
    resourceSet?: Maybe<ResourceSet>;
    resourceSetCollection?: Maybe<ResourceSetCollection>;
    resourceSetCursorCollection?: Maybe<ResourceSetCursorCollection>;
    scrolljackItem?: Maybe<ScrolljackItem>;
    scrolljackItemCollection?: Maybe<ScrolljackItemCollection>;
    scrolljackItemCursorCollection?: Maybe<ScrolljackItemCursorCollection>;
    service?: Maybe<Service>;
    serviceCollection?: Maybe<ServiceCollection>;
    serviceCursorCollection?: Maybe<ServiceCursorCollection>;
    socialLinks?: Maybe<SocialLinks>;
    socialLinksCollection?: Maybe<SocialLinksCollection>;
    socialLinksCursorCollection?: Maybe<SocialLinksCursorCollection>;
    solution?: Maybe<Solution>;
    solutionCollection?: Maybe<SolutionCollection>;
    solutionCursorCollection?: Maybe<SolutionCursorCollection>;
    stackedCardItem?: Maybe<StackedCardItem>;
    stackedCardItemCollection?: Maybe<StackedCardItemCollection>;
    stackedCardItemCursorCollection?: Maybe<StackedCardItemCursorCollection>;
    subIndustry?: Maybe<SubIndustry>;
    subIndustryCollection?: Maybe<SubIndustryCollection>;
    subIndustryCursorCollection?: Maybe<SubIndustryCursorCollection>;
    tabbedContentItem?: Maybe<TabbedContentItem>;
    tabbedContentItemCollection?: Maybe<TabbedContentItemCollection>;
    tabbedContentItemCursorCollection?: Maybe<TabbedContentItemCursorCollection>;
    technology?: Maybe<Technology>;
    technologyCollection?: Maybe<TechnologyCollection>;
    technologyCursorCollection?: Maybe<TechnologyCursorCollection>;
};

export type Query_NodeArgs = {
    id: Scalars['ID']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query_NodesArgs = {
    ids: Array<Scalars['ID']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAccordionContentItemArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAccordionContentItemCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<AccordionContentItemOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<AccordionContentItemFilter>;
};

export type QueryAccordionContentItemCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<AccordionContentItemOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<AccordionContentItemFilter>;
};

export type QueryAssetArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAssetCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<AssetFilter>;
};

export type QueryAssetCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<AssetFilter>;
};

export type QueryBlockAccordionContentArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockAccordionContentCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockAccordionContentOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockAccordionContentFilter>;
};

export type QueryBlockAccordionContentCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockAccordionContentOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockAccordionContentFilter>;
};

export type QueryBlockClientTestimonialArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockClientTestimonialCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockClientTestimonialFilter>;
};

export type QueryBlockClientTestimonialCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockClientTestimonialOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockClientTestimonialFilter>;
};

export type QueryBlockDarkCircleBackgroundArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockDarkCircleBackgroundCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockDarkCircleBackgroundFilter>;
};

export type QueryBlockDarkCircleBackgroundCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockDarkCircleBackgroundOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockDarkCircleBackgroundFilter>;
};

export type QueryBlockFeaturedCaseStudiesArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockFeaturedCaseStudiesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockFeaturedCaseStudiesFilter>;
};

export type QueryBlockFeaturedCaseStudiesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockFeaturedCaseStudiesOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockFeaturedCaseStudiesFilter>;
};

export type QueryBlockIconBlocksArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockIconBlocksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockIconBlocksFilter>;
};

export type QueryBlockIconBlocksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIconBlocksOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockIconBlocksFilter>;
};

export type QueryBlockImageArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockImageCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockImageFilter>;
};

export type QueryBlockImageCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockImageFilter>;
};

export type QueryBlockImageWithPartialOverlayArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockImageWithPartialOverlayCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockImageWithPartialOverlayFilter>;
};

export type QueryBlockImageWithPartialOverlayCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockImageWithPartialOverlayOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockImageWithPartialOverlayFilter>;
};

export type QueryBlockIndustryBlocksArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockIndustryBlocksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockIndustryBlocksFilter>;
};

export type QueryBlockIndustryBlocksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockIndustryBlocksOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockIndustryBlocksFilter>;
};

export type QueryBlockJobListArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockJobListCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockJobListFilter>;
};

export type QueryBlockJobListCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockJobListOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockJobListFilter>;
};

export type QueryBlockLogoCarouselArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockLogoCarouselCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoCarouselOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockLogoCarouselFilter>;
};

export type QueryBlockLogoCarouselCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoCarouselOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockLogoCarouselFilter>;
};

export type QueryBlockLogoGridArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockLogoGridCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockLogoGridFilter>;
};

export type QueryBlockLogoGridCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockLogoGridOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockLogoGridFilter>;
};

export type QueryBlockNumberedBlocksArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockNumberedBlocksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockNumberedBlocksFilter>;
};

export type QueryBlockNumberedBlocksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockNumberedBlocksOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockNumberedBlocksFilter>;
};

export type QueryBlockPageIntroArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockPageIntroCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageIntroOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockPageIntroFilter>;
};

export type QueryBlockPageIntroCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageIntroOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockPageIntroFilter>;
};

export type QueryBlockPageSectionArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockPageSectionCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockPageSectionFilter>;
};

export type QueryBlockPageSectionCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPageSectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockPageSectionFilter>;
};

export type QueryBlockPeopleListArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockPeopleListCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockPeopleListFilter>;
};

export type QueryBlockPeopleListCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockPeopleListOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockPeopleListFilter>;
};

export type QueryBlockRichTextArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockRichTextCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockRichTextOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockRichTextFilter>;
};

export type QueryBlockRichTextCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockRichTextOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockRichTextFilter>;
};

export type QueryBlockScrolljackSectionArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockScrolljackSectionCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockScrolljackSectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockScrolljackSectionFilter>;
};

export type QueryBlockScrolljackSectionCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockScrolljackSectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockScrolljackSectionFilter>;
};

export type QueryBlockSlideshowArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockSlideshowCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockSlideshowFilter>;
};

export type QueryBlockSlideshowCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockSlideshowOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockSlideshowFilter>;
};

export type QueryBlockStackedCardsArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockStackedCardsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockStackedCardsOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockStackedCardsFilter>;
};

export type QueryBlockStackedCardsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockStackedCardsOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockStackedCardsFilter>;
};

export type QueryBlockTabbedContentArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockTabbedContentCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTabbedContentOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockTabbedContentFilter>;
};

export type QueryBlockTabbedContentCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTabbedContentOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockTabbedContentFilter>;
};

export type QueryBlockTechnologyBlocksArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBlockTechnologyBlocksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockTechnologyBlocksFilter>;
};

export type QueryBlockTechnologyBlocksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<BlockTechnologyBlocksOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<BlockTechnologyBlocksFilter>;
};

export type QueryButtonArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryButtonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ButtonFilter>;
};

export type QueryButtonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ButtonOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ButtonFilter>;
};

export type QueryCareerArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCareerCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CareerOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CareerFilter>;
};

export type QueryCareerCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CareerOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CareerFilter>;
};

export type QueryClientArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryClientCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ClientOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ClientFilter>;
};

export type QueryClientCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ClientOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ClientFilter>;
};

export type QueryCodeBlockArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCodeBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CodeBlockOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CodeBlockFilter>;
};

export type QueryCodeBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CodeBlockOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CodeBlockFilter>;
};

export type QueryCompanyTopicArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCompanyTopicCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CompanyTopicOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CompanyTopicFilter>;
};

export type QueryCompanyTopicCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CompanyTopicOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CompanyTopicFilter>;
};

export type QueryCtaSimpleArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCtaSimpleCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CtaSimpleFilter>;
};

export type QueryCtaSimpleCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<CtaSimpleOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<CtaSimpleFilter>;
};

export type QueryEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<EntryFilter>;
};

export type QueryEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<EntryFilter>;
};

export type QueryExpertiseArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ExpertiseOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ExpertiseFilter>;
};

export type QueryExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ExpertiseOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ExpertiseFilter>;
};

export type QueryFactArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFactCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FactOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FactFilter>;
};

export type QueryFactCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FactOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FactFilter>;
};

export type QueryFormArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFormCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FormFilter>;
};

export type QueryFormCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FormFilter>;
};

export type QueryFormFieldArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFormFieldCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormFieldOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FormFieldFilter>;
};

export type QueryFormFieldCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<FormFieldOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<FormFieldFilter>;
};

export type QueryIconArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryIconBlockArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryIconBlockCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconBlockOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IconBlockFilter>;
};

export type QueryIconBlockCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconBlockOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IconBlockFilter>;
};

export type QueryIconCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IconFilter>;
};

export type QueryIconCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IconOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IconFilter>;
};

export type QueryImageWrapperArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryImageWrapperCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

export type QueryImageWrapperCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ImageWrapperOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

export type QueryIndustryArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IndustryOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IndustryFilter>;
};

export type QueryIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<IndustryOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IndustryFilter>;
};

export type QueryInternalPageLinkArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryInternalPageLinkCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<InternalPageLinkOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<InternalPageLinkFilter>;
};

export type QueryInternalPageLinkCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<InternalPageLinkOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<InternalPageLinkFilter>;
};

export type QueryLandingPageArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryLandingPageCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<LandingPageOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<LandingPageFilter>;
};

export type QueryLandingPageCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<LandingPageOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<LandingPageFilter>;
};

export type QueryNavArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryNavCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NavFilter>;
};

export type QueryNavCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NavFilter>;
};

export type QueryNavSectionArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryNavSectionCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavSectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NavSectionFilter>;
};

export type QueryNavSectionCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NavSectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NavSectionFilter>;
};

export type QueryNtAudienceArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryNtAudienceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtAudienceOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtAudienceFilter>;
};

export type QueryNtAudienceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtAudienceOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtAudienceFilter>;
};

export type QueryNtExperienceArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryNtExperienceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

export type QueryNtExperienceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtExperienceOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtExperienceFilter>;
};

export type QueryNtMergetagArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryNtMergetagCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtMergetagOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtMergetagFilter>;
};

export type QueryNtMergetagCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<NtMergetagOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<NtMergetagFilter>;
};

export type QueryPageCaseStudyArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageCaseStudyFilter>;
};

export type QueryPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCaseStudyOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageCaseStudyFilter>;
};

export type QueryPageCompanyArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPageCompanyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCompanyOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageCompanyFilter>;
};

export type QueryPageCompanyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageCompanyOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageCompanyFilter>;
};

export type QueryPageExpertiseArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPageExpertiseCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageExpertiseOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageExpertiseFilter>;
};

export type QueryPageExpertiseCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageExpertiseOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageExpertiseFilter>;
};

export type QueryPageIndustryArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPageIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageIndustryOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageIndustryFilter>;
};

export type QueryPageIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageIndustryOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageIndustryFilter>;
};

export type QueryPageJournalArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageJournalFilter>;
};

export type QueryPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageJournalOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageJournalFilter>;
};

export type QueryPageLandingArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPageLandingCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageLandingOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageLandingFilter>;
};

export type QueryPageLandingCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageLandingOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageLandingFilter>;
};

export type QueryPagePersonArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPagePersonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PagePersonFilter>;
};

export type QueryPagePersonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PagePersonOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PagePersonFilter>;
};

export type QueryPageServiceArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageServiceOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageServiceFilter>;
};

export type QueryPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageServiceOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageServiceFilter>;
};

export type QueryPageSubIndustryArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageSubIndustryOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageSubIndustryFilter>;
};

export type QueryPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageSubIndustryOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageSubIndustryFilter>;
};

export type QueryPageTechnologyArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageTechnologyOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageTechnologyFilter>;
};

export type QueryPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PageTechnologyOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PageTechnologyFilter>;
};

export type QueryPersonArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPersonCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PersonOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PersonFilter>;
};

export type QueryPersonCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<PersonOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<PersonFilter>;
};

export type QueryResourceArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryResourceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ResourceOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ResourceFilter>;
};

export type QueryResourceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ResourceOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ResourceFilter>;
};

export type QueryResourceSetArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryResourceSetCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ResourceSetOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ResourceSetFilter>;
};

export type QueryResourceSetCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ResourceSetOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ResourceSetFilter>;
};

export type QueryScrolljackItemArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryScrolljackItemCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ScrolljackItemOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ScrolljackItemFilter>;
};

export type QueryScrolljackItemCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ScrolljackItemOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ScrolljackItemFilter>;
};

export type QueryServiceArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ServiceOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ServiceFilter>;
};

export type QueryServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ServiceOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ServiceFilter>;
};

export type QuerySocialLinksArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySocialLinksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SocialLinksOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SocialLinksFilter>;
};

export type QuerySocialLinksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SocialLinksOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SocialLinksFilter>;
};

export type QuerySolutionArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySolutionCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SolutionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SolutionFilter>;
};

export type QuerySolutionCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SolutionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SolutionFilter>;
};

export type QueryStackedCardItemArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryStackedCardItemCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<StackedCardItemOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<StackedCardItemFilter>;
};

export type QueryStackedCardItemCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<StackedCardItemOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<StackedCardItemFilter>;
};

export type QuerySubIndustryArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SubIndustryOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SubIndustryFilter>;
};

export type QuerySubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SubIndustryOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<SubIndustryFilter>;
};

export type QueryTabbedContentItemArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryTabbedContentItemCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TabbedContentItemOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TabbedContentItemFilter>;
};

export type QueryTabbedContentItemCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TabbedContentItemOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TabbedContentItemFilter>;
};

export type QueryTechnologyArgs = {
    id: Scalars['String']['input'];
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TechnologyFilter>;
};

export type QueryTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<TechnologyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/resource) */
export type Resource = Entry &
    _Node & {
        __typename?: 'Resource';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        key?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<ResourceLinkingCollections>;
        sys: Sys;
        value?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/resource) */
export type ResourceKeyArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/resource) */
export type ResourceLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/resource) */
export type ResourceValueArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceCollection = {
    __typename?: 'ResourceCollection';
    items: Array<Maybe<Resource>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type ResourceCursorCollection = {
    __typename?: 'ResourceCursorCollection';
    items: Array<Maybe<Resource>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type ResourceFilter = {
    AND?: InputMaybe<Array<InputMaybe<ResourceFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<ResourceFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    key?: InputMaybe<Scalars['String']['input']>;
    key_contains?: InputMaybe<Scalars['String']['input']>;
    key_exists?: InputMaybe<Scalars['Boolean']['input']>;
    key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    key_not?: InputMaybe<Scalars['String']['input']>;
    key_not_contains?: InputMaybe<Scalars['String']['input']>;
    key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    value?: InputMaybe<Scalars['String']['input']>;
    value_contains?: InputMaybe<Scalars['String']['input']>;
    value_exists?: InputMaybe<Scalars['Boolean']['input']>;
    value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    value_not?: InputMaybe<Scalars['String']['input']>;
    value_not_contains?: InputMaybe<Scalars['String']['input']>;
    value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResourceLink = {
    sys: ResourceSys;
};

export type ResourceLinkingCollections = {
    __typename?: 'ResourceLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    resourceSetCollection?: Maybe<ResourceSetCollection>;
    resourceSetCursorCollection?: Maybe<ResourceSetCursorCollection>;
};

export type ResourceLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceLinkingCollectionsResourceSetCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ResourceLinkingCollectionsResourceSetCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceLinkingCollectionsResourceSetCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ResourceLinkingCollectionsResourceSetCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ResourceLinkingCollectionsResourceSetCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ResourceLinkingCollectionsResourceSetCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ResourceOrder {
    KeyAsc = 'key_ASC',
    KeyDesc = 'key_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/resourceSet) */
export type ResourceSet = Entry &
    _Node & {
        __typename?: 'ResourceSet';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<ResourceSetLinkingCollections>;
        resourcesCollection?: Maybe<ResourceSetResourcesCollection>;
        resourcesCursorCollection?: Maybe<ResourceSetResourcesCursorCollection>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/resourceSet) */
export type ResourceSetInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/resourceSet) */
export type ResourceSetLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/resourceSet) */
export type ResourceSetResourcesCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ResourceSetResourcesCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ResourceFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/resourceSet) */
export type ResourceSetResourcesCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ResourceSetResourcesCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ResourceFilter>;
};

export type ResourceSetCollection = {
    __typename?: 'ResourceSetCollection';
    items: Array<Maybe<ResourceSet>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type ResourceSetCursorCollection = {
    __typename?: 'ResourceSetCursorCollection';
    items: Array<Maybe<ResourceSet>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type ResourceSetFilter = {
    AND?: InputMaybe<Array<InputMaybe<ResourceSetFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<ResourceSetFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    resources?: InputMaybe<CfResourceNestedFilter>;
    resourcesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type ResourceSetLinkingCollections = {
    __typename?: 'ResourceSetLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type ResourceSetLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceSetLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ResourceSetOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type ResourceSetResourcesCollection = {
    __typename?: 'ResourceSetResourcesCollection';
    items: Array<Maybe<Resource>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export enum ResourceSetResourcesCollectionOrder {
    KeyAsc = 'key_ASC',
    KeyDesc = 'key_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type ResourceSetResourcesCursorCollection = {
    __typename?: 'ResourceSetResourcesCursorCollection';
    items: Array<Maybe<Resource>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export enum ResourceSetResourcesCursorCollectionOrder {
    KeyAsc = 'key_ASC',
    KeyDesc = 'key_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type ResourceSys = {
    __typename?: 'ResourceSys';
    linkType: Scalars['String']['output'];
    urn: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/scrolljackItem) */
export type ScrolljackItem = Entry &
    _Node & {
        __typename?: 'ScrolljackItem';
        _id: Scalars['ID']['output'];
        bodyText?: Maybe<Scalars['String']['output']>;
        contentfulMetadata: ContentfulMetadata;
        headline?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<ScrolljackItemLinkingCollections>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/scrolljackItem) */
export type ScrolljackItemBodyTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/scrolljackItem) */
export type ScrolljackItemHeadlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/scrolljackItem) */
export type ScrolljackItemInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/scrolljackItem) */
export type ScrolljackItemLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ScrolljackItemCollection = {
    __typename?: 'ScrolljackItemCollection';
    items: Array<Maybe<ScrolljackItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type ScrolljackItemCursorCollection = {
    __typename?: 'ScrolljackItemCursorCollection';
    items: Array<Maybe<ScrolljackItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type ScrolljackItemFilter = {
    AND?: InputMaybe<Array<InputMaybe<ScrolljackItemFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<ScrolljackItemFilter>>>;
    bodyText?: InputMaybe<Scalars['String']['input']>;
    bodyText_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    bodyText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    bodyText_not?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headline?: InputMaybe<Scalars['String']['input']>;
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headline_not?: InputMaybe<Scalars['String']['input']>;
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type ScrolljackItemLinkingCollections = {
    __typename?: 'ScrolljackItemLinkingCollections';
    blockScrolljackSectionCollection?: Maybe<BlockScrolljackSectionCollection>;
    blockScrolljackSectionCursorCollection?: Maybe<BlockScrolljackSectionCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type ScrolljackItemLinkingCollectionsBlockScrolljackSectionCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ScrolljackItemLinkingCollectionsBlockScrolljackSectionCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScrolljackItemLinkingCollectionsBlockScrolljackSectionCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ScrolljackItemLinkingCollectionsBlockScrolljackSectionCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScrolljackItemLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScrolljackItemLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ScrolljackItemLinkingCollectionsBlockScrolljackSectionCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ScrolljackItemLinkingCollectionsBlockScrolljackSectionCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ScrolljackItemOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/service) */
export type Service = Entry &
    _Node & {
        __typename?: 'Service';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        linkedFrom?: Maybe<ServiceLinkingCollections>;
        slug?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/service) */
export type ServiceLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/service) */
export type ServiceSlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/service) */
export type ServiceTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceCollection = {
    __typename?: 'ServiceCollection';
    items: Array<Maybe<Service>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type ServiceCursorCollection = {
    __typename?: 'ServiceCursorCollection';
    items: Array<Maybe<Service>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type ServiceFilter = {
    AND?: InputMaybe<Array<InputMaybe<ServiceFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<ServiceFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceLinkingCollections = {
    __typename?: 'ServiceLinkingCollections';
    blockSlideshowCollection?: Maybe<BlockSlideshowCollection>;
    blockSlideshowCursorCollection?: Maybe<BlockSlideshowCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageServiceCollection?: Maybe<PageServiceCollection>;
    pageServiceCursorCollection?: Maybe<PageServiceCursorCollection>;
};

export type ServiceLinkingCollectionsBlockSlideshowCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsBlockSlideshowCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLinkingCollectionsBlockSlideshowCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsBlockSlideshowCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLinkingCollectionsPageServiceCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsPageServiceCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLinkingCollectionsPageServiceCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsPageServiceCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ServiceLinkingCollectionsBlockSlideshowCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ServiceLinkingCollectionsBlockSlideshowCursorCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum ServiceLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum ServiceLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum ServiceLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum ServiceLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum ServiceLinkingCollectionsPageServiceCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ServiceLinkingCollectionsPageServiceCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum ServiceOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/socialLinks) */
export type SocialLinks = Entry &
    _Node & {
        __typename?: 'SocialLinks';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<SocialLinksLinkingCollections>;
        links?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/socialLinks) */
export type SocialLinksInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/socialLinks) */
export type SocialLinksLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/socialLinks) */
export type SocialLinksLinksArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SocialLinksCollection = {
    __typename?: 'SocialLinksCollection';
    items: Array<Maybe<SocialLinks>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type SocialLinksCursorCollection = {
    __typename?: 'SocialLinksCursorCollection';
    items: Array<Maybe<SocialLinks>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type SocialLinksFilter = {
    AND?: InputMaybe<Array<InputMaybe<SocialLinksFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<SocialLinksFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    links_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    links_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    links_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    links_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type SocialLinksLinkingCollections = {
    __typename?: 'SocialLinksLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type SocialLinksLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SocialLinksLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SocialLinksOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/solution) */
export type Solution = Entry &
    _Node & {
        __typename?: 'Solution';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        linkedFrom?: Maybe<SolutionLinkingCollections>;
        slug?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/solution) */
export type SolutionLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/solution) */
export type SolutionSlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/solution) */
export type SolutionTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionCollection = {
    __typename?: 'SolutionCollection';
    items: Array<Maybe<Solution>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type SolutionCursorCollection = {
    __typename?: 'SolutionCursorCollection';
    items: Array<Maybe<Solution>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type SolutionFilter = {
    AND?: InputMaybe<Array<InputMaybe<SolutionFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<SolutionFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SolutionLinkingCollections = {
    __typename?: 'SolutionLinkingCollections';
    blockSlideshowCollection?: Maybe<BlockSlideshowCollection>;
    blockSlideshowCursorCollection?: Maybe<BlockSlideshowCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
};

export type SolutionLinkingCollectionsBlockSlideshowCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SolutionLinkingCollectionsBlockSlideshowCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionLinkingCollectionsBlockSlideshowCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SolutionLinkingCollectionsBlockSlideshowCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SolutionLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SolutionLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SolutionLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SolutionLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SolutionLinkingCollectionsBlockSlideshowCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum SolutionLinkingCollectionsBlockSlideshowCursorCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum SolutionLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum SolutionLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum SolutionLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum SolutionLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum SolutionOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/stackedCardItem) */
export type StackedCardItem = Entry &
    _Node & {
        __typename?: 'StackedCardItem';
        _id: Scalars['ID']['output'];
        bodyText?: Maybe<Scalars['String']['output']>;
        contentfulMetadata: ContentfulMetadata;
        headline?: Maybe<Scalars['String']['output']>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<StackedCardItemLinkingCollections>;
        overline?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/stackedCardItem) */
export type StackedCardItemBodyTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/stackedCardItem) */
export type StackedCardItemHeadlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/stackedCardItem) */
export type StackedCardItemInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/stackedCardItem) */
export type StackedCardItemLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/stackedCardItem) */
export type StackedCardItemOverlineArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StackedCardItemCollection = {
    __typename?: 'StackedCardItemCollection';
    items: Array<Maybe<StackedCardItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type StackedCardItemCursorCollection = {
    __typename?: 'StackedCardItemCursorCollection';
    items: Array<Maybe<StackedCardItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type StackedCardItemFilter = {
    AND?: InputMaybe<Array<InputMaybe<StackedCardItemFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<StackedCardItemFilter>>>;
    bodyText?: InputMaybe<Scalars['String']['input']>;
    bodyText_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    bodyText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    bodyText_not?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headline?: InputMaybe<Scalars['String']['input']>;
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headline_not?: InputMaybe<Scalars['String']['input']>;
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type StackedCardItemLinkingCollections = {
    __typename?: 'StackedCardItemLinkingCollections';
    blockStackedCardsCollection?: Maybe<BlockStackedCardsCollection>;
    blockStackedCardsCursorCollection?: Maybe<BlockStackedCardsCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type StackedCardItemLinkingCollectionsBlockStackedCardsCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<StackedCardItemLinkingCollectionsBlockStackedCardsCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StackedCardItemLinkingCollectionsBlockStackedCardsCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<StackedCardItemLinkingCollectionsBlockStackedCardsCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StackedCardItemLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StackedCardItemLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StackedCardItemLinkingCollectionsBlockStackedCardsCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum StackedCardItemLinkingCollectionsBlockStackedCardsCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum StackedCardItemOrder {
    HeadlineAsc = 'headline_ASC',
    HeadlineDesc = 'headline_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/subIndustry) */
export type SubIndustry = Entry &
    _Node & {
        __typename?: 'SubIndustry';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<SubIndustryLinkingCollections>;
        name?: Maybe<Scalars['String']['output']>;
        parentIndustry?: Maybe<Industry>;
        slug?: Maybe<Scalars['String']['output']>;
        sys: Sys;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/subIndustry) */
export type SubIndustryInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/subIndustry) */
export type SubIndustryLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/subIndustry) */
export type SubIndustryNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/subIndustry) */
export type SubIndustryParentIndustryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<IndustryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/subIndustry) */
export type SubIndustrySlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubIndustryCollection = {
    __typename?: 'SubIndustryCollection';
    items: Array<Maybe<SubIndustry>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type SubIndustryCursorCollection = {
    __typename?: 'SubIndustryCursorCollection';
    items: Array<Maybe<SubIndustry>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type SubIndustryFilter = {
    AND?: InputMaybe<Array<InputMaybe<SubIndustryFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<SubIndustryFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    name?: InputMaybe<Scalars['String']['input']>;
    name_contains?: InputMaybe<Scalars['String']['input']>;
    name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    name_not?: InputMaybe<Scalars['String']['input']>;
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    parentIndustry?: InputMaybe<CfIndustryNestedFilter>;
    parentIndustry_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type SubIndustryLinkingCollections = {
    __typename?: 'SubIndustryLinkingCollections';
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageSubIndustryCollection?: Maybe<PageSubIndustryCollection>;
    pageSubIndustryCursorCollection?: Maybe<PageSubIndustryCursorCollection>;
};

export type SubIndustryLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubIndustryLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubIndustryLinkingCollectionsPageSubIndustryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SubIndustryLinkingCollectionsPageSubIndustryCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubIndustryLinkingCollectionsPageSubIndustryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<SubIndustryLinkingCollectionsPageSubIndustryCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SubIndustryLinkingCollectionsPageSubIndustryCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum SubIndustryLinkingCollectionsPageSubIndustryCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum SubIndustryOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    NameAsc = 'name_ASC',
    NameDesc = 'name_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export type Sys = {
    __typename?: 'Sys';
    environmentId: Scalars['String']['output'];
    firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
    id: Scalars['String']['output'];
    /** The locale that was requested. */
    locale?: Maybe<Scalars['String']['output']>;
    publishedAt?: Maybe<Scalars['DateTime']['output']>;
    publishedVersion?: Maybe<Scalars['Int']['output']>;
    spaceId: Scalars['String']['output'];
};

export type SysFilter = {
    firstPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
    firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    firstPublishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    id?: InputMaybe<Scalars['String']['input']>;
    id_contains?: InputMaybe<Scalars['String']['input']>;
    id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_not?: InputMaybe<Scalars['String']['input']>;
    id_not_contains?: InputMaybe<Scalars['String']['input']>;
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
    publishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
    publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
    publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
    publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
    publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
    publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
    publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishedVersion?: InputMaybe<Scalars['Float']['input']>;
    publishedVersion_exists?: InputMaybe<Scalars['Boolean']['input']>;
    publishedVersion_gt?: InputMaybe<Scalars['Float']['input']>;
    publishedVersion_gte?: InputMaybe<Scalars['Float']['input']>;
    publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
    publishedVersion_lt?: InputMaybe<Scalars['Float']['input']>;
    publishedVersion_lte?: InputMaybe<Scalars['Float']['input']>;
    publishedVersion_not?: InputMaybe<Scalars['Float']['input']>;
    publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/tabbedContentItem) */
export type TabbedContentItem = Entry &
    _Node & {
        __typename?: 'TabbedContentItem';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        headerText?: Maybe<Scalars['String']['output']>;
        image?: Maybe<Scalars['JSON']['output']>;
        image_data?: Maybe<Array<Maybe<Cloudinary_Asset>>>;
        internalName?: Maybe<Scalars['String']['output']>;
        linkedFrom?: Maybe<TabbedContentItemLinkingCollections>;
        paragraph?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        tabLabel?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/tabbedContentItem) */
export type TabbedContentItemHeaderTextArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/tabbedContentItem) */
export type TabbedContentItemImageArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/tabbedContentItem) */
export type TabbedContentItemInternalNameArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/tabbedContentItem) */
export type TabbedContentItemLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/tabbedContentItem) */
export type TabbedContentItemParagraphArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/tabbedContentItem) */
export type TabbedContentItemTabLabelArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabbedContentItemCollection = {
    __typename?: 'TabbedContentItemCollection';
    items: Array<Maybe<TabbedContentItem>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type TabbedContentItemCursorCollection = {
    __typename?: 'TabbedContentItemCursorCollection';
    items: Array<Maybe<TabbedContentItem>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type TabbedContentItemFilter = {
    AND?: InputMaybe<Array<InputMaybe<TabbedContentItemFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<TabbedContentItemFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    image_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    tabLabel?: InputMaybe<Scalars['String']['input']>;
    tabLabel_contains?: InputMaybe<Scalars['String']['input']>;
    tabLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
    tabLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    tabLabel_not?: InputMaybe<Scalars['String']['input']>;
    tabLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
    tabLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TabbedContentItemLinkingCollections = {
    __typename?: 'TabbedContentItemLinkingCollections';
    blockTabbedContentCollection?: Maybe<BlockTabbedContentCollection>;
    blockTabbedContentCursorCollection?: Maybe<BlockTabbedContentCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type TabbedContentItemLinkingCollectionsBlockTabbedContentCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TabbedContentItemLinkingCollectionsBlockTabbedContentCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabbedContentItemLinkingCollectionsBlockTabbedContentCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TabbedContentItemLinkingCollectionsBlockTabbedContentCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabbedContentItemLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabbedContentItemLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TabbedContentItemLinkingCollectionsBlockTabbedContentCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum TabbedContentItemLinkingCollectionsBlockTabbedContentCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum TabbedContentItemOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TabLabelAsc = 'tabLabel_ASC',
    TabLabelDesc = 'tabLabel_DESC',
}

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
    __typename?: 'TaxonomyConcept';
    id?: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/technology) */
export type Technology = Entry &
    _Node & {
        __typename?: 'Technology';
        _id: Scalars['ID']['output'];
        contentfulMetadata: ContentfulMetadata;
        linkedFrom?: Maybe<TechnologyLinkingCollections>;
        logo?: Maybe<ImageWrapper>;
        slug?: Maybe<Scalars['String']['output']>;
        sys: Sys;
        technologySummary?: Maybe<Scalars['String']['output']>;
        technologyType?: Maybe<Scalars['String']['output']>;
        title?: Maybe<Scalars['String']['output']>;
    };

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/technology) */
export type TechnologyLinkedFromArgs = {
    allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/technology) */
export type TechnologyLogoArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
    where?: InputMaybe<ImageWrapperFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/technology) */
export type TechnologySlugArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/technology) */
export type TechnologyTechnologySummaryArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/technology) */
export type TechnologyTechnologyTypeArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lsenpmh0le5q/content_types/technology) */
export type TechnologyTitleArgs = {
    locale?: InputMaybe<Scalars['String']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyCollection = {
    __typename?: 'TechnologyCollection';
    items: Array<Maybe<Technology>>;
    limit: Scalars['Int']['output'];
    skip: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
};

export type TechnologyCursorCollection = {
    __typename?: 'TechnologyCursorCollection';
    items: Array<Maybe<Technology>>;
    limit: Scalars['Int']['output'];
    pages: CursorPages;
};

export type TechnologyFilter = {
    AND?: InputMaybe<Array<InputMaybe<TechnologyFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<TechnologyFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    logo?: InputMaybe<CfImageWrapperNestedFilter>;
    logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    technologySummary?: InputMaybe<Scalars['String']['input']>;
    technologySummary_contains?: InputMaybe<Scalars['String']['input']>;
    technologySummary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    technologySummary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    technologySummary_not?: InputMaybe<Scalars['String']['input']>;
    technologySummary_not_contains?: InputMaybe<Scalars['String']['input']>;
    technologySummary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    technologyType?: InputMaybe<Scalars['String']['input']>;
    technologyType_contains?: InputMaybe<Scalars['String']['input']>;
    technologyType_exists?: InputMaybe<Scalars['Boolean']['input']>;
    technologyType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    technologyType_not?: InputMaybe<Scalars['String']['input']>;
    technologyType_not_contains?: InputMaybe<Scalars['String']['input']>;
    technologyType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TechnologyLinkingCollections = {
    __typename?: 'TechnologyLinkingCollections';
    blockSlideshowCollection?: Maybe<BlockSlideshowCollection>;
    blockSlideshowCursorCollection?: Maybe<BlockSlideshowCursorCollection>;
    blockTechnologyBlocksCollection?: Maybe<BlockTechnologyBlocksCollection>;
    blockTechnologyBlocksCursorCollection?: Maybe<BlockTechnologyBlocksCursorCollection>;
    entryCollection?: Maybe<EntryCollection>;
    entryCursorCollection?: Maybe<EntryCursorCollection>;
    pageCaseStudyCollection?: Maybe<PageCaseStudyCollection>;
    pageCaseStudyCursorCollection?: Maybe<PageCaseStudyCursorCollection>;
    pageJournalCollection?: Maybe<PageJournalCollection>;
    pageJournalCursorCollection?: Maybe<PageJournalCursorCollection>;
    pageTechnologyCollection?: Maybe<PageTechnologyCollection>;
    pageTechnologyCursorCollection?: Maybe<PageTechnologyCursorCollection>;
};

export type TechnologyLinkingCollectionsBlockSlideshowCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyLinkingCollectionsBlockSlideshowCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsBlockSlideshowCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyLinkingCollectionsBlockSlideshowCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsBlockTechnologyBlocksCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyLinkingCollectionsBlockTechnologyBlocksCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsBlockTechnologyBlocksCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyLinkingCollectionsBlockTechnologyBlocksCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsEntryCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsEntryCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsPageCaseStudyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyLinkingCollectionsPageCaseStudyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsPageCaseStudyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyLinkingCollectionsPageCaseStudyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsPageJournalCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyLinkingCollectionsPageJournalCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsPageJournalCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyLinkingCollectionsPageJournalCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsPageTechnologyCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyLinkingCollectionsPageTechnologyCollectionOrder>>>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnologyLinkingCollectionsPageTechnologyCursorCollectionArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    locale?: InputMaybe<Scalars['String']['input']>;
    order?: InputMaybe<Array<InputMaybe<TechnologyLinkingCollectionsPageTechnologyCursorCollectionOrder>>>;
    pageNext?: InputMaybe<Scalars['String']['input']>;
    pagePrev?: InputMaybe<Scalars['String']['input']>;
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TechnologyLinkingCollectionsBlockSlideshowCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum TechnologyLinkingCollectionsBlockSlideshowCursorCollectionOrder {
    ContentTypeAsc = 'contentType_ASC',
    ContentTypeDesc = 'contentType_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum TechnologyLinkingCollectionsBlockTechnologyBlocksCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum TechnologyLinkingCollectionsBlockTechnologyBlocksCursorCollectionOrder {
    HeaderTextAsc = 'headerText_ASC',
    HeaderTextDesc = 'headerText_DESC',
    OverlineAsc = 'overline_ASC',
    OverlineDesc = 'overline_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
}

export enum TechnologyLinkingCollectionsPageCaseStudyCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum TechnologyLinkingCollectionsPageCaseStudyCursorCollectionOrder {
    ClientIntroductionHeaderAsc = 'clientIntroductionHeader_ASC',
    ClientIntroductionHeaderDesc = 'clientIntroductionHeader_DESC',
    FeaturedAsc = 'featured_ASC',
    FeaturedDesc = 'featured_DESC',
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    IsSnapshotAsc = 'isSnapshot_ASC',
    IsSnapshotDesc = 'isSnapshot_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    YearAsc = 'year_ASC',
    YearDesc = 'year_DESC',
}

export enum TechnologyLinkingCollectionsPageJournalCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum TechnologyLinkingCollectionsPageJournalCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    PublishDateAsc = 'publishDate_ASC',
    PublishDateDesc = 'publishDate_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
    UpdatedDateAsc = 'updatedDate_ASC',
    UpdatedDateDesc = 'updatedDate_DESC',
}

export enum TechnologyLinkingCollectionsPageTechnologyCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum TechnologyLinkingCollectionsPageTechnologyCursorCollectionOrder {
    InternalNameAsc = 'internalName_ASC',
    InternalNameDesc = 'internalName_DESC',
    SeoDescriptionAsc = 'seoDescription_ASC',
    SeoDescriptionDesc = 'seoDescription_DESC',
    SeoTitleAsc = 'seoTitle_ASC',
    SeoTitleDesc = 'seoTitle_DESC',
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export enum TechnologyOrder {
    SlugAsc = 'slug_ASC',
    SlugDesc = 'slug_DESC',
    SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
    SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
    SysIdAsc = 'sys_id_ASC',
    SysIdDesc = 'sys_id_DESC',
    SysPublishedAtAsc = 'sys_publishedAt_ASC',
    SysPublishedAtDesc = 'sys_publishedAt_DESC',
    SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
    SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
    TechnologySummaryAsc = 'technologySummary_ASC',
    TechnologySummaryDesc = 'technologySummary_DESC',
    TechnologyTypeAsc = 'technologyType_ASC',
    TechnologyTypeDesc = 'technologyType_DESC',
    TitleAsc = 'title_ASC',
    TitleDesc = 'title_DESC',
}

export type TimelineFilterInput = {
    /** Preview content starting from a given release date */
    release_lte?: InputMaybe<Scalars['String']['input']>;
    /** Preview content starting from a given timestamp */
    timestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type _Node = {
    _id: Scalars['ID']['output'];
};

export type CfAccordionContentItemNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfAccordionContentItemNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfAccordionContentItemNestedFilter>>>;
    bodyText?: InputMaybe<Scalars['String']['input']>;
    bodyText_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    bodyText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    bodyText_not?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headline?: InputMaybe<Scalars['String']['input']>;
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headline_not?: InputMaybe<Scalars['String']['input']>;
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    imagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfBlockPageIntroNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfBlockPageIntroNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfBlockPageIntroNestedFilter>>>;
    button_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerParagraph?: InputMaybe<Scalars['String']['input']>;
    headerParagraph_contains?: InputMaybe<Scalars['String']['input']>;
    headerParagraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerParagraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerParagraph_not?: InputMaybe<Scalars['String']['input']>;
    headerParagraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerParagraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    image_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experiencesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    tableOfContents_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfButtonNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfButtonNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfButtonNestedFilter>>>;
    buttonText?: InputMaybe<Scalars['String']['input']>;
    buttonText_contains?: InputMaybe<Scalars['String']['input']>;
    buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    buttonText_not?: InputMaybe<Scalars['String']['input']>;
    buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
    buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkPath?: InputMaybe<Scalars['String']['input']>;
    linkPath_contains?: InputMaybe<Scalars['String']['input']>;
    linkPath_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkPath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkPath_not?: InputMaybe<Scalars['String']['input']>;
    linkPath_not_contains?: InputMaybe<Scalars['String']['input']>;
    linkPath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experiencesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type CfCareerNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfCareerNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfCareerNestedFilter>>>;
    breezyUrl?: InputMaybe<Scalars['String']['input']>;
    breezyUrl_contains?: InputMaybe<Scalars['String']['input']>;
    breezyUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
    breezyUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    breezyUrl_not?: InputMaybe<Scalars['String']['input']>;
    breezyUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
    breezyUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfClientNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfClientNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfClientNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    name?: InputMaybe<Scalars['String']['input']>;
    name_contains?: InputMaybe<Scalars['String']['input']>;
    name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    name_not?: InputMaybe<Scalars['String']['input']>;
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfCompanyTopicNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfCompanyTopicNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfCompanyTopicNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfExpertiseNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfExpertiseNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfExpertiseNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfFactNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfFactNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfFactNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    fact?: InputMaybe<Scalars['String']['input']>;
    fact_contains?: InputMaybe<Scalars['String']['input']>;
    fact_exists?: InputMaybe<Scalars['Boolean']['input']>;
    fact_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    fact_not?: InputMaybe<Scalars['String']['input']>;
    fact_not_contains?: InputMaybe<Scalars['String']['input']>;
    fact_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    header?: InputMaybe<Scalars['String']['input']>;
    header_contains?: InputMaybe<Scalars['String']['input']>;
    header_exists?: InputMaybe<Scalars['Boolean']['input']>;
    header_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    header_not?: InputMaybe<Scalars['String']['input']>;
    header_not_contains?: InputMaybe<Scalars['String']['input']>;
    header_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    link_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type CfFormFieldNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfFormFieldNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfFormFieldNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    label?: InputMaybe<Scalars['String']['input']>;
    label_contains?: InputMaybe<Scalars['String']['input']>;
    label_exists?: InputMaybe<Scalars['Boolean']['input']>;
    label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    label_not?: InputMaybe<Scalars['String']['input']>;
    label_not_contains?: InputMaybe<Scalars['String']['input']>;
    label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    placeholder?: InputMaybe<Scalars['String']['input']>;
    placeholder_contains?: InputMaybe<Scalars['String']['input']>;
    placeholder_exists?: InputMaybe<Scalars['Boolean']['input']>;
    placeholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    placeholder_not?: InputMaybe<Scalars['String']['input']>;
    placeholder_not_contains?: InputMaybe<Scalars['String']['input']>;
    placeholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    value?: InputMaybe<Scalars['String']['input']>;
    value_contains?: InputMaybe<Scalars['String']['input']>;
    value_exists?: InputMaybe<Scalars['Boolean']['input']>;
    value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    value_not?: InputMaybe<Scalars['String']['input']>;
    value_not_contains?: InputMaybe<Scalars['String']['input']>;
    value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfFormNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfFormNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfFormNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    fieldsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    formErrorMessage?: InputMaybe<Scalars['String']['input']>;
    formErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
    formErrorMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    formErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    formErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
    formErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
    formErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id?: InputMaybe<Scalars['String']['input']>;
    id_contains?: InputMaybe<Scalars['String']['input']>;
    id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_not?: InputMaybe<Scalars['String']['input']>;
    id_not_contains?: InputMaybe<Scalars['String']['input']>;
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    intro?: InputMaybe<Scalars['String']['input']>;
    intro_contains?: InputMaybe<Scalars['String']['input']>;
    intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
    intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    intro_not?: InputMaybe<Scalars['String']['input']>;
    intro_not_contains?: InputMaybe<Scalars['String']['input']>;
    intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    submitButtonText?: InputMaybe<Scalars['String']['input']>;
    submitButtonText_contains?: InputMaybe<Scalars['String']['input']>;
    submitButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    submitButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    submitButtonText_not?: InputMaybe<Scalars['String']['input']>;
    submitButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
    submitButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    successMessage?: InputMaybe<Scalars['String']['input']>;
    successMessage_contains?: InputMaybe<Scalars['String']['input']>;
    successMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    successMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    successMessage_not?: InputMaybe<Scalars['String']['input']>;
    successMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
    successMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfIconBlockNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfIconBlockNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfIconBlockNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
    link_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfIconNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfIconNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfIconNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    iconCloudinary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    iconImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    keywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    keywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    keywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    keywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfImageWrapperNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfImageWrapperNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfImageWrapperNestedFilter>>>;
    altText?: InputMaybe<Scalars['String']['input']>;
    altText_contains?: InputMaybe<Scalars['String']['input']>;
    altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    altText_not?: InputMaybe<Scalars['String']['input']>;
    altText_not_contains?: InputMaybe<Scalars['String']['input']>;
    altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    cloudinaryMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    description?: InputMaybe<Scalars['String']['input']>;
    description_contains?: InputMaybe<Scalars['String']['input']>;
    description_exists?: InputMaybe<Scalars['Boolean']['input']>;
    description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    description_not?: InputMaybe<Scalars['String']['input']>;
    description_not_contains?: InputMaybe<Scalars['String']['input']>;
    description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    media_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfIndustryNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfIndustryNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfIndustryNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    name?: InputMaybe<Scalars['String']['input']>;
    name_contains?: InputMaybe<Scalars['String']['input']>;
    name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    name_not?: InputMaybe<Scalars['String']['input']>;
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfInternalPageLinkNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfInternalPageLinkNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfInternalPageLinkNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    linkPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkText?: InputMaybe<Scalars['String']['input']>;
    linkText_contains?: InputMaybe<Scalars['String']['input']>;
    linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkText_not?: InputMaybe<Scalars['String']['input']>;
    linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
    linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfLandingPageNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfLandingPageNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfLandingPageNestedFilter>>>;
    componentSettings_exists?: InputMaybe<Scalars['Boolean']['input']>;
    componentTree_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    dataSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    unboundValues_exists?: InputMaybe<Scalars['Boolean']['input']>;
    usedComponentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfNavSectionNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfNavSectionNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfNavSectionNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    id_contains?: InputMaybe<Scalars['String']['input']>;
    id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    id_not?: InputMaybe<Scalars['String']['input']>;
    id_not_contains?: InputMaybe<Scalars['String']['input']>;
    id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    justLink?: InputMaybe<Scalars['Boolean']['input']>;
    justLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
    justLink_not?: InputMaybe<Scalars['Boolean']['input']>;
    linkList1Collection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkList1Overline?: InputMaybe<Scalars['String']['input']>;
    linkList1Overline_contains?: InputMaybe<Scalars['String']['input']>;
    linkList1Overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkList1Overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkList1Overline_not?: InputMaybe<Scalars['String']['input']>;
    linkList1Overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    linkList1Overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkList2Collection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkList2Overline?: InputMaybe<Scalars['String']['input']>;
    linkList2Overline_contains?: InputMaybe<Scalars['String']['input']>;
    linkList2Overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    linkList2Overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    linkList2Overline_not?: InputMaybe<Scalars['String']['input']>;
    linkList2Overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    linkList2Overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    mainLinkDescription?: InputMaybe<Scalars['String']['input']>;
    mainLinkDescription_contains?: InputMaybe<Scalars['String']['input']>;
    mainLinkDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    mainLinkDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    mainLinkDescription_not?: InputMaybe<Scalars['String']['input']>;
    mainLinkDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    mainLinkDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    mainPageLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
    showEntry?: InputMaybe<Scalars['String']['input']>;
    showEntry_contains?: InputMaybe<Scalars['String']['input']>;
    showEntry_exists?: InputMaybe<Scalars['Boolean']['input']>;
    showEntry_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    showEntry_not?: InputMaybe<Scalars['String']['input']>;
    showEntry_not_contains?: InputMaybe<Scalars['String']['input']>;
    showEntry_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfNtAudienceNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfNtAudienceNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfNtAudienceNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    nt_audience_id?: InputMaybe<Scalars['String']['input']>;
    nt_audience_id_contains?: InputMaybe<Scalars['String']['input']>;
    nt_audience_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_audience_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_audience_id_not?: InputMaybe<Scalars['String']['input']>;
    nt_audience_id_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_audience_id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_description?: InputMaybe<Scalars['String']['input']>;
    nt_description_contains?: InputMaybe<Scalars['String']['input']>;
    nt_description_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_description_not?: InputMaybe<Scalars['String']['input']>;
    nt_description_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_metadata_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_name?: InputMaybe<Scalars['String']['input']>;
    nt_name_contains?: InputMaybe<Scalars['String']['input']>;
    nt_name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_name_not?: InputMaybe<Scalars['String']['input']>;
    nt_name_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_rules_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type CfNtExperienceNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfNtExperienceNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfNtExperienceNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    nt_audience_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_config_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_description?: InputMaybe<Scalars['String']['input']>;
    nt_description_contains?: InputMaybe<Scalars['String']['input']>;
    nt_description_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_description_not?: InputMaybe<Scalars['String']['input']>;
    nt_description_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experience_id?: InputMaybe<Scalars['String']['input']>;
    nt_experience_id_contains?: InputMaybe<Scalars['String']['input']>;
    nt_experience_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_experience_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_experience_id_not?: InputMaybe<Scalars['String']['input']>;
    nt_experience_id_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_experience_id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_metadata_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_name?: InputMaybe<Scalars['String']['input']>;
    nt_name_contains?: InputMaybe<Scalars['String']['input']>;
    nt_name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_name_not?: InputMaybe<Scalars['String']['input']>;
    nt_name_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_type?: InputMaybe<Scalars['String']['input']>;
    nt_type_contains?: InputMaybe<Scalars['String']['input']>;
    nt_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
    nt_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_type_not?: InputMaybe<Scalars['String']['input']>;
    nt_type_not_contains?: InputMaybe<Scalars['String']['input']>;
    nt_type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    nt_variantsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
};

export type CfPageCaseStudyNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfPageCaseStudyNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfPageCaseStudyNestedFilter>>>;
    approach?: InputMaybe<Scalars['String']['input']>;
    approach_contains?: InputMaybe<Scalars['String']['input']>;
    approach_exists?: InputMaybe<Scalars['Boolean']['input']>;
    approach_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    approach_not?: InputMaybe<Scalars['String']['input']>;
    approach_not_contains?: InputMaybe<Scalars['String']['input']>;
    approach_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    challenge?: InputMaybe<Scalars['String']['input']>;
    challenge_contains?: InputMaybe<Scalars['String']['input']>;
    challenge_exists?: InputMaybe<Scalars['Boolean']['input']>;
    challenge_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    challenge_not?: InputMaybe<Scalars['String']['input']>;
    challenge_not_contains?: InputMaybe<Scalars['String']['input']>;
    challenge_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    clientIntroductionBody?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionBody_contains?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionBody_exists?: InputMaybe<Scalars['Boolean']['input']>;
    clientIntroductionBody_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    clientIntroductionBody_not?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionBody_not_contains?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionBody_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    clientIntroductionHeader?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionHeader_contains?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
    clientIntroductionHeader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    clientIntroductionHeader_not?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionHeader_not_contains?: InputMaybe<Scalars['String']['input']>;
    clientIntroductionHeader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    clientIntroductionImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    client_exists?: InputMaybe<Scalars['Boolean']['input']>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    featured?: InputMaybe<Scalars['Boolean']['input']>;
    featured_exists?: InputMaybe<Scalars['Boolean']['input']>;
    featured_not?: InputMaybe<Scalars['Boolean']['input']>;
    heroImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    industriesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    isSnapshot?: InputMaybe<Scalars['Boolean']['input']>;
    isSnapshot_exists?: InputMaybe<Scalars['Boolean']['input']>;
    isSnapshot_not?: InputMaybe<Scalars['Boolean']['input']>;
    listImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    outcome?: InputMaybe<Scalars['String']['input']>;
    outcome_contains?: InputMaybe<Scalars['String']['input']>;
    outcome_exists?: InputMaybe<Scalars['Boolean']['input']>;
    outcome_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    outcome_not?: InputMaybe<Scalars['String']['input']>;
    outcome_not_contains?: InputMaybe<Scalars['String']['input']>;
    outcome_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    publishDate?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
    publishDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    publishDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_not?: InputMaybe<Scalars['DateTime']['input']>;
    publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    servicesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slideshowPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    solutionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    technologiesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    year?: InputMaybe<Scalars['Int']['input']>;
    year_exists?: InputMaybe<Scalars['Boolean']['input']>;
    year_gt?: InputMaybe<Scalars['Int']['input']>;
    year_gte?: InputMaybe<Scalars['Int']['input']>;
    year_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    year_lt?: InputMaybe<Scalars['Int']['input']>;
    year_lte?: InputMaybe<Scalars['Int']['input']>;
    year_not?: InputMaybe<Scalars['Int']['input']>;
    year_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CfPageIndustryNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfPageIndustryNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfPageIndustryNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    industry_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    listImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary?: InputMaybe<Scalars['String']['input']>;
    summary_contains?: InputMaybe<Scalars['String']['input']>;
    summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    summary_not?: InputMaybe<Scalars['String']['input']>;
    summary_not_contains?: InputMaybe<Scalars['String']['input']>;
    summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPagePersonNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfPagePersonNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfPagePersonNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    heroImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    isActive_exists?: InputMaybe<Scalars['Boolean']['input']>;
    isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
    person_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoDescription_not?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
    seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    seoTitle_not?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPersonNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfPersonNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfPersonNestedFilter>>>;
    atAGlance?: InputMaybe<Scalars['String']['input']>;
    atAGlance_contains?: InputMaybe<Scalars['String']['input']>;
    atAGlance_exists?: InputMaybe<Scalars['Boolean']['input']>;
    atAGlance_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    atAGlance_not?: InputMaybe<Scalars['String']['input']>;
    atAGlance_not_contains?: InputMaybe<Scalars['String']['input']>;
    atAGlance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    atFosterMade?: InputMaybe<Scalars['String']['input']>;
    atFosterMade_contains?: InputMaybe<Scalars['String']['input']>;
    atFosterMade_exists?: InputMaybe<Scalars['Boolean']['input']>;
    atFosterMade_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    atFosterMade_not?: InputMaybe<Scalars['String']['input']>;
    atFosterMade_not_contains?: InputMaybe<Scalars['String']['input']>;
    atFosterMade_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    beyondIntroductions?: InputMaybe<Scalars['String']['input']>;
    beyondIntroductions_contains?: InputMaybe<Scalars['String']['input']>;
    beyondIntroductions_exists?: InputMaybe<Scalars['Boolean']['input']>;
    beyondIntroductions_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    beyondIntroductions_not?: InputMaybe<Scalars['String']['input']>;
    beyondIntroductions_not_contains?: InputMaybe<Scalars['String']['input']>;
    beyondIntroductions_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    bio?: InputMaybe<Scalars['String']['input']>;
    bio_contains?: InputMaybe<Scalars['String']['input']>;
    bio_exists?: InputMaybe<Scalars['Boolean']['input']>;
    bio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    bio_not?: InputMaybe<Scalars['String']['input']>;
    bio_not_contains?: InputMaybe<Scalars['String']['input']>;
    bio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    email?: InputMaybe<Scalars['String']['input']>;
    email_contains?: InputMaybe<Scalars['String']['input']>;
    email_exists?: InputMaybe<Scalars['Boolean']['input']>;
    email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    email_not?: InputMaybe<Scalars['String']['input']>;
    email_not_contains?: InputMaybe<Scalars['String']['input']>;
    email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    expertise_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    expertise_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    expertise_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    expertise_exists?: InputMaybe<Scalars['Boolean']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    firstName_contains?: InputMaybe<Scalars['String']['input']>;
    firstName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    firstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    firstName_not?: InputMaybe<Scalars['String']['input']>;
    firstName_not_contains?: InputMaybe<Scalars['String']['input']>;
    firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    funFactsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
    jobTitle?: InputMaybe<Scalars['String']['input']>;
    jobTitle_contains?: InputMaybe<Scalars['String']['input']>;
    jobTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
    jobTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    jobTitle_not?: InputMaybe<Scalars['String']['input']>;
    jobTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
    jobTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    lastName_contains?: InputMaybe<Scalars['String']['input']>;
    lastName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    lastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    lastName_not?: InputMaybe<Scalars['String']['input']>;
    lastName_not_contains?: InputMaybe<Scalars['String']['input']>;
    lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    profileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
    socialLinks_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    socialLinks_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    socialLinks_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    socialLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
    sys?: InputMaybe<SysFilter>;
    testimonial?: InputMaybe<Scalars['String']['input']>;
    testimonial_contains?: InputMaybe<Scalars['String']['input']>;
    testimonial_exists?: InputMaybe<Scalars['Boolean']['input']>;
    testimonial_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    testimonial_not?: InputMaybe<Scalars['String']['input']>;
    testimonial_not_contains?: InputMaybe<Scalars['String']['input']>;
    testimonial_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfResourceNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfResourceNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfResourceNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    key?: InputMaybe<Scalars['String']['input']>;
    key_contains?: InputMaybe<Scalars['String']['input']>;
    key_exists?: InputMaybe<Scalars['Boolean']['input']>;
    key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    key_not?: InputMaybe<Scalars['String']['input']>;
    key_not_contains?: InputMaybe<Scalars['String']['input']>;
    key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    value?: InputMaybe<Scalars['String']['input']>;
    value_contains?: InputMaybe<Scalars['String']['input']>;
    value_exists?: InputMaybe<Scalars['Boolean']['input']>;
    value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    value_not?: InputMaybe<Scalars['String']['input']>;
    value_not_contains?: InputMaybe<Scalars['String']['input']>;
    value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfScrolljackItemNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfScrolljackItemNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfScrolljackItemNestedFilter>>>;
    bodyText?: InputMaybe<Scalars['String']['input']>;
    bodyText_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    bodyText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    bodyText_not?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headline?: InputMaybe<Scalars['String']['input']>;
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headline_not?: InputMaybe<Scalars['String']['input']>;
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfServiceNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfServiceNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfServiceNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSolutionNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfSolutionNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfSolutionNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfStackedCardItemNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfStackedCardItemNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfStackedCardItemNestedFilter>>>;
    bodyText?: InputMaybe<Scalars['String']['input']>;
    bodyText_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    bodyText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    bodyText_not?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_contains?: InputMaybe<Scalars['String']['input']>;
    bodyText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headline?: InputMaybe<Scalars['String']['input']>;
    headline_contains?: InputMaybe<Scalars['String']['input']>;
    headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headline_not?: InputMaybe<Scalars['String']['input']>;
    headline_not_contains?: InputMaybe<Scalars['String']['input']>;
    headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline?: InputMaybe<Scalars['String']['input']>;
    overline_contains?: InputMaybe<Scalars['String']['input']>;
    overline_exists?: InputMaybe<Scalars['Boolean']['input']>;
    overline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overline_not?: InputMaybe<Scalars['String']['input']>;
    overline_not_contains?: InputMaybe<Scalars['String']['input']>;
    overline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfSubIndustryNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfSubIndustryNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfSubIndustryNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    name?: InputMaybe<Scalars['String']['input']>;
    name_contains?: InputMaybe<Scalars['String']['input']>;
    name_exists?: InputMaybe<Scalars['Boolean']['input']>;
    name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    name_not?: InputMaybe<Scalars['String']['input']>;
    name_not_contains?: InputMaybe<Scalars['String']['input']>;
    name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    parentIndustry_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfTabbedContentItemNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfTabbedContentItemNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfTabbedContentItemNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    headerText?: InputMaybe<Scalars['String']['input']>;
    headerText_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
    headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    headerText_not?: InputMaybe<Scalars['String']['input']>;
    headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
    headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    image_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph?: InputMaybe<Scalars['String']['input']>;
    paragraph_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_exists?: InputMaybe<Scalars['Boolean']['input']>;
    paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    paragraph_not?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
    paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    tabLabel?: InputMaybe<Scalars['String']['input']>;
    tabLabel_contains?: InputMaybe<Scalars['String']['input']>;
    tabLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
    tabLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    tabLabel_not?: InputMaybe<Scalars['String']['input']>;
    tabLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
    tabLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTechnologyNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfTechnologyNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfTechnologyNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    slug_contains?: InputMaybe<Scalars['String']['input']>;
    slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
    slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    slug_not?: InputMaybe<Scalars['String']['input']>;
    slug_not_contains?: InputMaybe<Scalars['String']['input']>;
    slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
    technologySummary?: InputMaybe<Scalars['String']['input']>;
    technologySummary_contains?: InputMaybe<Scalars['String']['input']>;
    technologySummary_exists?: InputMaybe<Scalars['Boolean']['input']>;
    technologySummary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    technologySummary_not?: InputMaybe<Scalars['String']['input']>;
    technologySummary_not_contains?: InputMaybe<Scalars['String']['input']>;
    technologySummary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    technologyType?: InputMaybe<Scalars['String']['input']>;
    technologyType_contains?: InputMaybe<Scalars['String']['input']>;
    technologyType_exists?: InputMaybe<Scalars['Boolean']['input']>;
    technologyType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    technologyType_not?: InputMaybe<Scalars['String']['input']>;
    technologyType_not_contains?: InputMaybe<Scalars['String']['input']>;
    technologyType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title?: InputMaybe<Scalars['String']['input']>;
    title_contains?: InputMaybe<Scalars['String']['input']>;
    title_exists?: InputMaybe<Scalars['Boolean']['input']>;
    title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    title_not?: InputMaybe<Scalars['String']['input']>;
    title_not_contains?: InputMaybe<Scalars['String']['input']>;
    title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfblocksMultiTypeNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfblocksMultiTypeNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfblocksMultiTypeNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type CfentriesMultiTypeNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfentriesMultiTypeNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfentriesMultiTypeNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    internalName?: InputMaybe<Scalars['String']['input']>;
    internalName_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
    internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    internalName_not?: InputMaybe<Scalars['String']['input']>;
    internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
    internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    sys?: InputMaybe<SysFilter>;
};

export type CfsectionsMultiTypeNestedFilter = {
    AND?: InputMaybe<Array<InputMaybe<CfsectionsMultiTypeNestedFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CfsectionsMultiTypeNestedFilter>>>;
    contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
    sys?: InputMaybe<SysFilter>;
};

export type BlockPageIntroFragmentFragment = {
    __typename: 'BlockPageIntro';
    overline?: string | null;
    headerText?: string | null;
    headerParagraph?: string | null;
    tableOfContents?: any | null;
    sys: { __typename?: 'Sys'; id: string };
    image?: {
        __typename: 'ImageWrapper';
        cloudinaryMedia?: any | null;
        description?: string | null;
        title?: string | null;
        altText?: string | null;
        sys: { __typename?: 'Sys'; id: string };
    } | null;
    button?: {
        __typename: 'Button';
        buttonText?: string | null;
        linkPath?: string | null;
        sys: { __typename?: 'Sys'; id: string };
        linkPage?:
            | { __typename: 'PageCaseStudy'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
            | { __typename: 'PageIndustry'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
            | { __typename: 'PageLanding'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
            | { __typename: 'PagePerson'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
            | { __typename: 'PageService'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
            | null;
    } | null;
};

export type GetBlockPageIntroByIdQueryVariables = Exact<{
    id: Scalars['String']['input'];
    preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetBlockPageIntroByIdQuery = {
    __typename?: 'Query';
    blockPageIntroCollection?: {
        __typename?: 'BlockPageIntroCollection';
        items: Array<{
            __typename: 'BlockPageIntro';
            overline?: string | null;
            headerText?: string | null;
            headerParagraph?: string | null;
            tableOfContents?: any | null;
            sys: { __typename?: 'Sys'; id: string };
            image?: {
                __typename: 'ImageWrapper';
                cloudinaryMedia?: any | null;
                description?: string | null;
                title?: string | null;
                altText?: string | null;
                sys: { __typename?: 'Sys'; id: string };
            } | null;
            button?: {
                __typename: 'Button';
                buttonText?: string | null;
                linkPath?: string | null;
                sys: { __typename?: 'Sys'; id: string };
                linkPage?:
                    | { __typename: 'PageCaseStudy'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename: 'PageIndustry'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename: 'PageLanding'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename: 'PagePerson'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename: 'PageService'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | null;
            } | null;
        } | null>;
    } | null;
};

export type PageJournalFragmentFragment = {
    __typename: 'PageJournal';
    slug?: string | null;
    title?: string | null;
    summary?: string | null;
    publishDate?: any | null;
    updatedDate?: any | null;
    sys: { __typename?: 'Sys'; id: string };
    body?: { __typename?: 'PageJournalBody'; json: any } | null;
    heroImage?: {
        __typename: 'ImageWrapper';
        cloudinaryMedia?: any | null;
        description?: string | null;
        title?: string | null;
        altText?: string | null;
        sys: { __typename?: 'Sys'; id: string };
    } | null;
    technologiesCollection?: {
        __typename?: 'PageJournalTechnologiesCollection';
        items: Array<{
            __typename: 'Technology';
            title?: string | null;
            sys: { __typename?: 'Sys'; id: string };
        } | null>;
    } | null;
    servicesCollection?: {
        __typename?: 'PageJournalServicesCollection';
        items: Array<{ __typename: 'Service'; title?: string | null; sys: { __typename?: 'Sys'; id: string } } | null>;
    } | null;
    solutionsCollection?: {
        __typename?: 'PageJournalSolutionsCollection';
        items: Array<{ __typename: 'Solution'; title?: string | null; sys: { __typename?: 'Sys'; id: string } } | null>;
    } | null;
    companyTopicsCollection?: {
        __typename?: 'PageJournalCompanyTopicsCollection';
        items: Array<{
            __typename: 'CompanyTopic';
            title?: string | null;
            sys: { __typename?: 'Sys'; id: string };
        } | null>;
    } | null;
    authorsCollection?: {
        __typename?: 'PageJournalAuthorsCollection';
        items: Array<{
            __typename: 'PagePerson';
            slug?: string | null;
            isActive?: boolean | null;
            sys: { __typename?: 'Sys'; id: string };
            person?: {
                __typename: 'Person';
                firstName?: string | null;
                lastName?: string | null;
                sys: { __typename?: 'Sys'; id: string };
                profileImage?: {
                    __typename: 'ImageWrapper';
                    cloudinaryMedia?: any | null;
                    description?: string | null;
                    title?: string | null;
                    altText?: string | null;
                    sys: { __typename?: 'Sys'; id: string };
                } | null;
            } | null;
        } | null>;
    } | null;
};

export type GetPagesJournalAllQueryVariables = Exact<{
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetPagesJournalAllQuery = {
    __typename?: 'Query';
    pageJournalCollection?: {
        __typename?: 'PageJournalCollection';
        items: Array<{
            __typename: 'PageJournal';
            slug?: string | null;
            sys: { __typename?: 'Sys'; id: string };
        } | null>;
    } | null;
};

export type GetJournalBySlugQueryVariables = Exact<{
    slug: Scalars['String']['input'];
    preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetJournalBySlugQuery = {
    __typename?: 'Query';
    pageJournalCollection?: {
        __typename?: 'PageJournalCollection';
        items: Array<{
            __typename: 'PageJournal';
            slug?: string | null;
            title?: string | null;
            summary?: string | null;
            publishDate?: any | null;
            updatedDate?: any | null;
            sys: { __typename?: 'Sys'; id: string };
            body?: { __typename?: 'PageJournalBody'; json: any } | null;
            heroImage?: {
                __typename: 'ImageWrapper';
                cloudinaryMedia?: any | null;
                description?: string | null;
                title?: string | null;
                altText?: string | null;
                sys: { __typename?: 'Sys'; id: string };
            } | null;
            technologiesCollection?: {
                __typename?: 'PageJournalTechnologiesCollection';
                items: Array<{
                    __typename: 'Technology';
                    title?: string | null;
                    sys: { __typename?: 'Sys'; id: string };
                } | null>;
            } | null;
            servicesCollection?: {
                __typename?: 'PageJournalServicesCollection';
                items: Array<{
                    __typename: 'Service';
                    title?: string | null;
                    sys: { __typename?: 'Sys'; id: string };
                } | null>;
            } | null;
            solutionsCollection?: {
                __typename?: 'PageJournalSolutionsCollection';
                items: Array<{
                    __typename: 'Solution';
                    title?: string | null;
                    sys: { __typename?: 'Sys'; id: string };
                } | null>;
            } | null;
            companyTopicsCollection?: {
                __typename?: 'PageJournalCompanyTopicsCollection';
                items: Array<{
                    __typename: 'CompanyTopic';
                    title?: string | null;
                    sys: { __typename?: 'Sys'; id: string };
                } | null>;
            } | null;
            authorsCollection?: {
                __typename?: 'PageJournalAuthorsCollection';
                items: Array<{
                    __typename: 'PagePerson';
                    slug?: string | null;
                    isActive?: boolean | null;
                    sys: { __typename?: 'Sys'; id: string };
                    person?: {
                        __typename: 'Person';
                        firstName?: string | null;
                        lastName?: string | null;
                        sys: { __typename?: 'Sys'; id: string };
                        profileImage?: {
                            __typename: 'ImageWrapper';
                            cloudinaryMedia?: any | null;
                            description?: string | null;
                            title?: string | null;
                            altText?: string | null;
                            sys: { __typename?: 'Sys'; id: string };
                        } | null;
                    } | null;
                } | null>;
            } | null;
        } | null>;
    } | null;
};

export type GetPagesJournalQueryVariables = Exact<{
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetPagesJournalQuery = {
    __typename?: 'Query';
    pageJournalCollection?: {
        __typename?: 'PageJournalCollection';
        items: Array<{
            __typename: 'PageJournal';
            slug?: string | null;
            title?: string | null;
            summary?: string | null;
            publishDate?: any | null;
            updatedDate?: any | null;
            sys: { __typename?: 'Sys'; id: string };
            body?: { __typename?: 'PageJournalBody'; json: any } | null;
            heroImage?: {
                __typename: 'ImageWrapper';
                cloudinaryMedia?: any | null;
                description?: string | null;
                title?: string | null;
                altText?: string | null;
                sys: { __typename?: 'Sys'; id: string };
            } | null;
            technologiesCollection?: {
                __typename?: 'PageJournalTechnologiesCollection';
                items: Array<{
                    __typename: 'Technology';
                    title?: string | null;
                    sys: { __typename?: 'Sys'; id: string };
                } | null>;
            } | null;
            servicesCollection?: {
                __typename?: 'PageJournalServicesCollection';
                items: Array<{
                    __typename: 'Service';
                    title?: string | null;
                    sys: { __typename?: 'Sys'; id: string };
                } | null>;
            } | null;
            solutionsCollection?: {
                __typename?: 'PageJournalSolutionsCollection';
                items: Array<{
                    __typename: 'Solution';
                    title?: string | null;
                    sys: { __typename?: 'Sys'; id: string };
                } | null>;
            } | null;
            companyTopicsCollection?: {
                __typename?: 'PageJournalCompanyTopicsCollection';
                items: Array<{
                    __typename: 'CompanyTopic';
                    title?: string | null;
                    sys: { __typename?: 'Sys'; id: string };
                } | null>;
            } | null;
            authorsCollection?: {
                __typename?: 'PageJournalAuthorsCollection';
                items: Array<{
                    __typename: 'PagePerson';
                    slug?: string | null;
                    isActive?: boolean | null;
                    sys: { __typename?: 'Sys'; id: string };
                    person?: {
                        __typename: 'Person';
                        firstName?: string | null;
                        lastName?: string | null;
                        sys: { __typename?: 'Sys'; id: string };
                        profileImage?: {
                            __typename: 'ImageWrapper';
                            cloudinaryMedia?: any | null;
                            description?: string | null;
                            title?: string | null;
                            altText?: string | null;
                            sys: { __typename?: 'Sys'; id: string };
                        } | null;
                    } | null;
                } | null>;
            } | null;
        } | null>;
    } | null;
};

export type PageLandingFragmentFragment = {
    __typename: 'PageLanding';
    slug?: string | null;
    sys: { __typename?: 'Sys'; id: string };
    pageIntro?: { __typename?: 'BlockPageIntro'; sys: { __typename?: 'Sys'; id: string } } | null;
};

export type GetPageLandingBySlugQueryVariables = Exact<{
    slug: Scalars['String']['input'];
    preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetPageLandingBySlugQuery = {
    __typename?: 'Query';
    pageLandingCollection?: {
        __typename?: 'PageLandingCollection';
        items: Array<{
            __typename: 'PageLanding';
            slug?: string | null;
            sys: { __typename?: 'Sys'; id: string };
            pageIntro?: { __typename?: 'BlockPageIntro'; sys: { __typename?: 'Sys'; id: string } } | null;
        } | null>;
    } | null;
};

export type PagePersonFragmentFragment = {
    __typename: 'PagePerson';
    slug?: string | null;
    seoTitle?: string | null;
    seoDescription?: string | null;
    title?: string | null;
    isActive?: boolean | null;
    sys: { __typename?: 'Sys'; id: string };
    heroImage?: {
        __typename: 'ImageWrapper';
        cloudinaryMedia?: any | null;
        description?: string | null;
        title?: string | null;
        altText?: string | null;
        sys: { __typename?: 'Sys'; id: string };
    } | null;
    person?: { __typename?: 'Person'; sys: { __typename?: 'Sys'; id: string } } | null;
};

export type GetPagesPersonAllQueryVariables = Exact<{
    preview?: InputMaybe<Scalars['Boolean']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetPagesPersonAllQuery = {
    __typename?: 'Query';
    pagePersonCollection?: {
        __typename?: 'PagePersonCollection';
        items: Array<{
            __typename: 'PagePerson';
            slug?: string | null;
            sys: { __typename?: 'Sys'; id: string };
        } | null>;
    } | null;
};

export type GetPersonBySlugQueryVariables = Exact<{
    slug: Scalars['String']['input'];
    preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetPersonBySlugQuery = {
    __typename?: 'Query';
    pagePersonCollection?: {
        __typename?: 'PagePersonCollection';
        items: Array<{
            __typename: 'PagePerson';
            slug?: string | null;
            seoTitle?: string | null;
            seoDescription?: string | null;
            title?: string | null;
            isActive?: boolean | null;
            sys: { __typename?: 'Sys'; id: string };
            heroImage?: {
                __typename: 'ImageWrapper';
                cloudinaryMedia?: any | null;
                description?: string | null;
                title?: string | null;
                altText?: string | null;
                sys: { __typename?: 'Sys'; id: string };
            } | null;
            person?: { __typename?: 'Person'; sys: { __typename?: 'Sys'; id: string } } | null;
        } | null>;
    } | null;
};

export type PersonFragmentFragment = {
    __typename: 'Person';
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    atAGlance?: string | null;
    atFosterMade?: string | null;
    beyondIntroductions?: string | null;
    bio?: string | null;
    email?: string | null;
    expertise?: Array<string | null> | null;
    socialLinks?: Array<string | null> | null;
    testimonial?: string | null;
    sys: { __typename?: 'Sys'; id: string };
    profileImage?: {
        __typename: 'ImageWrapper';
        cloudinaryMedia?: any | null;
        description?: string | null;
        title?: string | null;
        altText?: string | null;
        sys: { __typename?: 'Sys'; id: string };
    } | null;
    funFactsCollection?: {
        __typename?: 'PersonFunFactsCollection';
        items: Array<{
            __typename: 'Fact';
            fact?: string | null;
            header?: string | null;
            sys: { __typename?: 'Sys'; id: string };
            link?: {
                __typename: 'InternalPageLink';
                linkText?: string | null;
                sys: { __typename?: 'Sys'; id: string };
                linkPage?:
                    | { __typename: 'PageCaseStudy'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename?: 'PageCompany' }
                    | { __typename: 'PageIndustry'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename?: 'PageJournal' }
                    | { __typename: 'PageLanding'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename: 'PagePerson'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename: 'PageService'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename?: 'PageTechnology' }
                    | null;
            } | null;
        } | null>;
    } | null;
};

export type GetPersonByIdQueryVariables = Exact<{
    id: Scalars['String']['input'];
    preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetPersonByIdQuery = {
    __typename?: 'Query';
    personCollection?: {
        __typename?: 'PersonCollection';
        items: Array<{
            __typename: 'Person';
            firstName?: string | null;
            lastName?: string | null;
            jobTitle?: string | null;
            atAGlance?: string | null;
            atFosterMade?: string | null;
            beyondIntroductions?: string | null;
            bio?: string | null;
            email?: string | null;
            expertise?: Array<string | null> | null;
            socialLinks?: Array<string | null> | null;
            testimonial?: string | null;
            sys: { __typename?: 'Sys'; id: string };
            profileImage?: {
                __typename: 'ImageWrapper';
                cloudinaryMedia?: any | null;
                description?: string | null;
                title?: string | null;
                altText?: string | null;
                sys: { __typename?: 'Sys'; id: string };
            } | null;
            funFactsCollection?: {
                __typename?: 'PersonFunFactsCollection';
                items: Array<{
                    __typename: 'Fact';
                    fact?: string | null;
                    header?: string | null;
                    sys: { __typename?: 'Sys'; id: string };
                    link?: {
                        __typename: 'InternalPageLink';
                        linkText?: string | null;
                        sys: { __typename?: 'Sys'; id: string };
                        linkPage?:
                            | {
                                  __typename: 'PageCaseStudy';
                                  slug?: string | null;
                                  sys: { __typename?: 'Sys'; id: string };
                              }
                            | { __typename?: 'PageCompany' }
                            | {
                                  __typename: 'PageIndustry';
                                  slug?: string | null;
                                  sys: { __typename?: 'Sys'; id: string };
                              }
                            | { __typename?: 'PageJournal' }
                            | {
                                  __typename: 'PageLanding';
                                  slug?: string | null;
                                  sys: { __typename?: 'Sys'; id: string };
                              }
                            | {
                                  __typename: 'PagePerson';
                                  slug?: string | null;
                                  sys: { __typename?: 'Sys'; id: string };
                              }
                            | {
                                  __typename: 'PageService';
                                  slug?: string | null;
                                  sys: { __typename?: 'Sys'; id: string };
                              }
                            | { __typename?: 'PageTechnology' }
                            | null;
                    } | null;
                } | null>;
            } | null;
        } | null>;
    } | null;
};

export type ButtonFragmentFragment = {
    __typename: 'Button';
    buttonText?: string | null;
    linkPath?: string | null;
    sys: { __typename?: 'Sys'; id: string };
    linkPage?:
        | { __typename: 'PageCaseStudy'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
        | { __typename: 'PageIndustry'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
        | { __typename: 'PageLanding'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
        | { __typename: 'PagePerson'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
        | { __typename: 'PageService'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
        | null;
};

export type ImageWrapperFragmentFragment = {
    __typename: 'ImageWrapper';
    cloudinaryMedia?: any | null;
    description?: string | null;
    title?: string | null;
    altText?: string | null;
    sys: { __typename?: 'Sys'; id: string };
};

export type InternalPageLinkFragmentFragment = {
    __typename: 'InternalPageLink';
    linkText?: string | null;
    sys: { __typename?: 'Sys'; id: string };
    linkPage?:
        | { __typename: 'PageCaseStudy'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
        | { __typename?: 'PageCompany' }
        | { __typename: 'PageIndustry'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
        | { __typename?: 'PageJournal' }
        | { __typename: 'PageLanding'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
        | { __typename: 'PagePerson'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
        | { __typename: 'PageService'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
        | { __typename?: 'PageTechnology' }
        | null;
};

export type PersonFullFragmentFragment = {
    __typename: 'Person';
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    atAGlance?: string | null;
    atFosterMade?: string | null;
    beyondIntroductions?: string | null;
    bio?: string | null;
    email?: string | null;
    expertise?: Array<string | null> | null;
    socialLinks?: Array<string | null> | null;
    testimonial?: string | null;
    sys: { __typename?: 'Sys'; id: string };
    profileImage?: {
        __typename: 'ImageWrapper';
        cloudinaryMedia?: any | null;
        description?: string | null;
        title?: string | null;
        altText?: string | null;
        sys: { __typename?: 'Sys'; id: string };
    } | null;
    funFactsCollection?: {
        __typename?: 'PersonFunFactsCollection';
        items: Array<{
            __typename: 'Fact';
            fact?: string | null;
            header?: string | null;
            sys: { __typename?: 'Sys'; id: string };
            link?: {
                __typename: 'InternalPageLink';
                linkText?: string | null;
                sys: { __typename?: 'Sys'; id: string };
                linkPage?:
                    | { __typename: 'PageCaseStudy'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename?: 'PageCompany' }
                    | { __typename: 'PageIndustry'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename?: 'PageJournal' }
                    | { __typename: 'PageLanding'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename: 'PagePerson'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename: 'PageService'; slug?: string | null; sys: { __typename?: 'Sys'; id: string } }
                    | { __typename?: 'PageTechnology' }
                    | null;
            } | null;
        } | null>;
    } | null;
};

export type PersonSummaryFragmentFragment = {
    __typename: 'Person';
    firstName?: string | null;
    lastName?: string | null;
    sys: { __typename?: 'Sys'; id: string };
    profileImage?: {
        __typename: 'ImageWrapper';
        cloudinaryMedia?: any | null;
        description?: string | null;
        title?: string | null;
        altText?: string | null;
        sys: { __typename?: 'Sys'; id: string };
    } | null;
};

export const ImageWrapperFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ImageWrapperFragmentFragment, unknown>;
export const ButtonFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ButtonFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkPath' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkPage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'PageCaseStudy' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageIndustry' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLanding' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePerson' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageService' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ButtonFragmentFragment, unknown>;
export const BlockPageIntroFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlockPageIntroFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockPageIntro' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'overline' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'headerText' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'headerParagraph' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'button' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ButtonFragment' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'tableOfContents' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ButtonFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkPath' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkPage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'PageCaseStudy' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageIndustry' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLanding' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePerson' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageService' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<BlockPageIntroFragmentFragment, unknown>;
export const PersonSummaryFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonSummaryFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PersonSummaryFragmentFragment, unknown>;
export const PageJournalFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PageJournalFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageJournal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'technologiesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'servicesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'solutionsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyTopicsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authorsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '4' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'person' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'PersonSummaryFragment' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonSummaryFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PageJournalFragmentFragment, unknown>;
export const PageLandingFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PageLandingFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLanding' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageIntro' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sys' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PageLandingFragmentFragment, unknown>;
export const PagePersonFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PagePersonFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePerson' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'person' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sys' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PagePersonFragmentFragment, unknown>;
export const InternalPageLinkFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'InternalPageLinkFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InternalPageLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkPage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'PageCaseStudy' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageIndustry' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLanding' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePerson' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageService' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<InternalPageLinkFragmentFragment, unknown>;
export const PersonFullFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonFullFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'atAGlance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'atFosterMade' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'beyondIntroductions' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expertise' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'socialLinks' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'testimonial' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'funFactsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '3' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'InternalPageLinkFragment' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'InternalPageLinkFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InternalPageLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkPage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'PageCaseStudy' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageIndustry' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLanding' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePerson' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageService' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PersonFullFragmentFragment, unknown>;
export const PersonFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonFullFragment' } }],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'InternalPageLinkFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InternalPageLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkPage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'PageCaseStudy' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageIndustry' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLanding' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePerson' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageService' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonFullFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'atAGlance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'atFosterMade' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'beyondIntroductions' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expertise' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'socialLinks' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'testimonial' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'funFactsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '3' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'InternalPageLinkFragment' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PersonFragmentFragment, unknown>;
export const GetBlockPageIntroByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetBlockPageIntroById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blockPageIntroCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sys' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'id' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'id' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'BlockPageIntroFragment' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ButtonFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkPath' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkPage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'PageCaseStudy' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageIndustry' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLanding' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePerson' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageService' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlockPageIntroFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockPageIntro' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'overline' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'headerText' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'headerParagraph' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'button' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ButtonFragment' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'tableOfContents' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetBlockPageIntroByIdQuery, GetBlockPageIntroByIdQueryVariables>;
export const GetPagesJournalAllDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetPagesJournalAll' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageJournalCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetPagesJournalAllQuery, GetPagesJournalAllQueryVariables>;
export const GetJournalBySlugDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetJournalBySlug' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageJournalCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'slug' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'PageJournalFragment' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonSummaryFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PageJournalFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageJournal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'technologiesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'servicesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'solutionsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyTopicsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authorsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '4' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'person' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'PersonSummaryFragment' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetJournalBySlugQuery, GetJournalBySlugQueryVariables>;
export const GetPagesJournalDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetPagesJournal' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageJournalCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'EnumValue', value: 'publishDate_DESC' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'PageJournalFragment' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonSummaryFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PageJournalFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageJournal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'technologiesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'servicesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'solutionsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyTopicsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authorsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '4' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'person' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'PersonSummaryFragment' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetPagesJournalQuery, GetPagesJournalQueryVariables>;
export const GetPageLandingBySlugDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetPageLandingBySlug' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageLandingCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'slug' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'PageLandingFragment' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PageLandingFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLanding' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageIntro' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sys' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetPageLandingBySlugQuery, GetPageLandingBySlugQueryVariables>;
export const GetPagesPersonAllDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetPagesPersonAll' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagePersonCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetPagesPersonAllQuery, GetPagesPersonAllQueryVariables>;
export const GetPersonBySlugDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetPersonBySlug' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagePersonCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'slug' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'PagePersonFragment' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PagePersonFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePerson' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'seoTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'seoDescription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'person' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sys' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetPersonBySlugQuery, GetPersonBySlugQueryVariables>;
export const GetPersonByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetPersonById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'sys' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'id' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'id' },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'PersonFullFragment' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageWrapperFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'cloudinaryMedia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'InternalPageLinkFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InternalPageLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkPage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'PageCaseStudy' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageIndustry' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageLanding' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePerson' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageService' } },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonFullFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageWrapperFragment' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'atAGlance' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'atFosterMade' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'beyondIntroductions' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expertise' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'socialLinks' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'testimonial' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'funFactsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '3' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fact' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'InternalPageLinkFragment' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetPersonByIdQuery, GetPersonByIdQueryVariables>;
